//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    isTenantAvailable(body: IsTenantAvailableInput | undefined): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTenantAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTenantAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IsTenantAvailableOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IsTenantAvailableOutput>;
        }));
    }

    protected processIsTenantAvailable(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsTenantAvailableOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param email (optional) 
     * @param userId (optional) 
     * @return Success
     */
    userNameOrEmailExist(email: string | undefined, userId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Account/UserNameOrEmailExist?";
        if (email === null)
            throw new globalThis.Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserNameOrEmailExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserNameOrEmailExist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUserNameOrEmailExist(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    sendConfirmationEmail(userId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendConfirmationEmail?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendConfirmationEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendConfirmationEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendConfirmationEmail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    confirmEmail(body: ConfirmEmailDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Account/ConfirmEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processConfirmEmail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    forgotPassword(body: ForgotPasswordDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Account/ForgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForgotPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForgotPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processForgotPassword(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param token (optional) 
     * @return Success
     */
    sendNewPasswordAfterReset(userId: number | undefined, token: string | undefined): Observable<ResetPasswordResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendNewPasswordAfterReset?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (token === null)
            throw new globalThis.Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendNewPasswordAfterReset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendNewPasswordAfterReset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResetPasswordResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResetPasswordResultDto>;
        }));
    }

    protected processSendNewPasswordAfterReset(response: HttpResponseBase): Observable<ResetPasswordResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResetPasswordResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    register(body: RegisterInput | undefined): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterOutput>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    registerPerson(body: RegisterPersonDto | undefined): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/RegisterPerson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterOutput>;
        }));
    }

    protected processRegisterPerson(response: HttpResponseBase): Observable<RegisterOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteUserData(id: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Account/DeleteUserData?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUserData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUserData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteUserData(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    registerPartner(body: RegisterPartnerDto | undefined): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/RegisterPartner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterPartner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterPartner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterOutput>;
        }));
    }

    protected processRegisterPartner(response: HttpResponseBase): Observable<RegisterOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AddressServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    insertMunicipality(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Address/InsertMunicipality";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertMunicipality(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertMunicipality(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInsertMunicipality(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllRegion(): Observable<RegionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Address/GetAllRegion";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRegion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRegion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegionDto[]>;
        }));
    }

    protected processGetAllRegion(response: HttpResponseBase): Observable<RegionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RegionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllProvinces(): Observable<ProvinceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Address/GetAllProvinces";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProvinces(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProvinces(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProvinceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProvinceDto[]>;
        }));
    }

    protected processGetAllProvinces(response: HttpResponseBase): Observable<ProvinceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProvinceDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param provinceId (optional) 
     * @return Success
     */
    getAllMunicipality(provinceId: number | undefined): Observable<MunicipalityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Address/GetAllMunicipality?";
        if (provinceId === null)
            throw new globalThis.Error("The parameter 'provinceId' cannot be null.");
        else if (provinceId !== undefined)
            url_ += "provinceId=" + encodeURIComponent("" + provinceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMunicipality(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMunicipality(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MunicipalityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MunicipalityDto[]>;
        }));
    }

    protected processGetAllMunicipality(response: HttpResponseBase): Observable<MunicipalityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MunicipalityDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ApprenticeshipServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Apprenticeship/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    closeApprenticeship(id: number | undefined): Observable<ApprenticeshipDto> {
        let url_ = this.baseUrl + "/api/services/app/Apprenticeship/CloseApprenticeship?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCloseApprenticeship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCloseApprenticeship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApprenticeshipDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApprenticeshipDto>;
        }));
    }

    protected processCloseApprenticeship(response: HttpResponseBase): Observable<ApprenticeshipDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApprenticeshipDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param stateId (optional) 
     * @param typeId (optional) 
     * @param apprenticeshipId (optional) 
     * @param tutorId (optional) 
     * @param partnerId (optional) 
     * @param personId (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, stateId: number | undefined, typeId: number | undefined, apprenticeshipId: number | undefined, tutorId: number | undefined, partnerId: number | undefined, personId: number | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ApprenticeshipDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Apprenticeship/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (stateId === null)
            throw new globalThis.Error("The parameter 'stateId' cannot be null.");
        else if (stateId !== undefined)
            url_ += "StateId=" + encodeURIComponent("" + stateId) + "&";
        if (typeId === null)
            throw new globalThis.Error("The parameter 'typeId' cannot be null.");
        else if (typeId !== undefined)
            url_ += "TypeId=" + encodeURIComponent("" + typeId) + "&";
        if (apprenticeshipId === null)
            throw new globalThis.Error("The parameter 'apprenticeshipId' cannot be null.");
        else if (apprenticeshipId !== undefined)
            url_ += "ApprenticeshipId=" + encodeURIComponent("" + apprenticeshipId) + "&";
        if (tutorId === null)
            throw new globalThis.Error("The parameter 'tutorId' cannot be null.");
        else if (tutorId !== undefined)
            url_ += "TutorId=" + encodeURIComponent("" + tutorId) + "&";
        if (partnerId === null)
            throw new globalThis.Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined)
            url_ += "PartnerId=" + encodeURIComponent("" + partnerId) + "&";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "PersonId=" + encodeURIComponent("" + personId) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApprenticeshipDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApprenticeshipDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ApprenticeshipDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApprenticeshipDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param stateId (optional) 
     * @param typeId (optional) 
     * @param apprenticeshipId (optional) 
     * @param tutorId (optional) 
     * @param partnerId (optional) 
     * @param personId (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllApprenticeshipOrderCodes(keyword: string | undefined, stateId: number | undefined, typeId: number | undefined, apprenticeshipId: number | undefined, tutorId: number | undefined, partnerId: number | undefined, personId: number | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ApprenticeshipOrderCodeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Apprenticeship/GetAllApprenticeshipOrderCodes?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (stateId === null)
            throw new globalThis.Error("The parameter 'stateId' cannot be null.");
        else if (stateId !== undefined)
            url_ += "StateId=" + encodeURIComponent("" + stateId) + "&";
        if (typeId === null)
            throw new globalThis.Error("The parameter 'typeId' cannot be null.");
        else if (typeId !== undefined)
            url_ += "TypeId=" + encodeURIComponent("" + typeId) + "&";
        if (apprenticeshipId === null)
            throw new globalThis.Error("The parameter 'apprenticeshipId' cannot be null.");
        else if (apprenticeshipId !== undefined)
            url_ += "ApprenticeshipId=" + encodeURIComponent("" + apprenticeshipId) + "&";
        if (tutorId === null)
            throw new globalThis.Error("The parameter 'tutorId' cannot be null.");
        else if (tutorId !== undefined)
            url_ += "TutorId=" + encodeURIComponent("" + tutorId) + "&";
        if (partnerId === null)
            throw new globalThis.Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined)
            url_ += "PartnerId=" + encodeURIComponent("" + partnerId) + "&";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "PersonId=" + encodeURIComponent("" + personId) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllApprenticeshipOrderCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllApprenticeshipOrderCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApprenticeshipOrderCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApprenticeshipOrderCodeDto[]>;
        }));
    }

    protected processGetAllApprenticeshipOrderCodes(response: HttpResponseBase): Observable<ApprenticeshipOrderCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApprenticeshipOrderCodeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param stateId (optional) 
     * @param typeId (optional) 
     * @param apprenticeshipId (optional) 
     * @param tutorId (optional) 
     * @param partnerId (optional) 
     * @param personId (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    downloadApprenticeshipAdditionalDataExcel(keyword: string | undefined, stateId: number | undefined, typeId: number | undefined, apprenticeshipId: number | undefined, tutorId: number | undefined, partnerId: number | undefined, personId: number | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FileExcelDto> {
        let url_ = this.baseUrl + "/api/services/app/Apprenticeship/DownloadApprenticeshipAdditionalDataExcel?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (stateId === null)
            throw new globalThis.Error("The parameter 'stateId' cannot be null.");
        else if (stateId !== undefined)
            url_ += "StateId=" + encodeURIComponent("" + stateId) + "&";
        if (typeId === null)
            throw new globalThis.Error("The parameter 'typeId' cannot be null.");
        else if (typeId !== undefined)
            url_ += "TypeId=" + encodeURIComponent("" + typeId) + "&";
        if (apprenticeshipId === null)
            throw new globalThis.Error("The parameter 'apprenticeshipId' cannot be null.");
        else if (apprenticeshipId !== undefined)
            url_ += "ApprenticeshipId=" + encodeURIComponent("" + apprenticeshipId) + "&";
        if (tutorId === null)
            throw new globalThis.Error("The parameter 'tutorId' cannot be null.");
        else if (tutorId !== undefined)
            url_ += "TutorId=" + encodeURIComponent("" + tutorId) + "&";
        if (partnerId === null)
            throw new globalThis.Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined)
            url_ += "PartnerId=" + encodeURIComponent("" + partnerId) + "&";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "PersonId=" + encodeURIComponent("" + personId) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadApprenticeshipAdditionalDataExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadApprenticeshipAdditionalDataExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileExcelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileExcelDto>;
        }));
    }

    protected processDownloadApprenticeshipAdditionalDataExcel(response: HttpResponseBase): Observable<FileExcelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExcelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param stateId (optional) 
     * @param typeId (optional) 
     * @param apprenticeshipId (optional) 
     * @param tutorId (optional) 
     * @param partnerId (optional) 
     * @param personId (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    downloadApprenticeshipExcel(keyword: string | undefined, stateId: number | undefined, typeId: number | undefined, apprenticeshipId: number | undefined, tutorId: number | undefined, partnerId: number | undefined, personId: number | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FileExcelDto> {
        let url_ = this.baseUrl + "/api/services/app/Apprenticeship/DownloadApprenticeshipExcel?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (stateId === null)
            throw new globalThis.Error("The parameter 'stateId' cannot be null.");
        else if (stateId !== undefined)
            url_ += "StateId=" + encodeURIComponent("" + stateId) + "&";
        if (typeId === null)
            throw new globalThis.Error("The parameter 'typeId' cannot be null.");
        else if (typeId !== undefined)
            url_ += "TypeId=" + encodeURIComponent("" + typeId) + "&";
        if (apprenticeshipId === null)
            throw new globalThis.Error("The parameter 'apprenticeshipId' cannot be null.");
        else if (apprenticeshipId !== undefined)
            url_ += "ApprenticeshipId=" + encodeURIComponent("" + apprenticeshipId) + "&";
        if (tutorId === null)
            throw new globalThis.Error("The parameter 'tutorId' cannot be null.");
        else if (tutorId !== undefined)
            url_ += "TutorId=" + encodeURIComponent("" + tutorId) + "&";
        if (partnerId === null)
            throw new globalThis.Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined)
            url_ += "PartnerId=" + encodeURIComponent("" + partnerId) + "&";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "PersonId=" + encodeURIComponent("" + personId) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadApprenticeshipExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadApprenticeshipExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileExcelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileExcelDto>;
        }));
    }

    protected processDownloadApprenticeshipExcel(response: HttpResponseBase): Observable<FileExcelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExcelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateApprenticeshipDto | undefined): Observable<ApprenticeshipDto> {
        let url_ = this.baseUrl + "/api/services/app/Apprenticeship/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApprenticeshipDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApprenticeshipDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ApprenticeshipDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApprenticeshipDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateApprenticeshipDto | undefined): Observable<ApprenticeshipDto> {
        let url_ = this.baseUrl + "/api/services/app/Apprenticeship/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApprenticeshipDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApprenticeshipDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ApprenticeshipDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApprenticeshipDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ApprenticeshipDto> {
        let url_ = this.baseUrl + "/api/services/app/Apprenticeship/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApprenticeshipDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApprenticeshipDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApprenticeshipDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApprenticeshipDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ApprenticeshipExtensionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param apprenticeshipId (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(apprenticeshipId: number | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ApprenticeshipExtensionDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ApprenticeshipExtension/GetAll?";
        if (apprenticeshipId === null)
            throw new globalThis.Error("The parameter 'apprenticeshipId' cannot be null.");
        else if (apprenticeshipId !== undefined)
            url_ += "ApprenticeshipId=" + encodeURIComponent("" + apprenticeshipId) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApprenticeshipExtensionDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApprenticeshipExtensionDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ApprenticeshipExtensionDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApprenticeshipExtensionDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateApprenticeshipExtensionDto | undefined): Observable<ApprenticeshipExtensionDto> {
        let url_ = this.baseUrl + "/api/services/app/ApprenticeshipExtension/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApprenticeshipExtensionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApprenticeshipExtensionDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ApprenticeshipExtensionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApprenticeshipExtensionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateApprenticeshipExtensionDto | undefined): Observable<ApprenticeshipExtensionDto> {
        let url_ = this.baseUrl + "/api/services/app/ApprenticeshipExtension/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApprenticeshipExtensionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApprenticeshipExtensionDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ApprenticeshipExtensionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApprenticeshipExtensionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ApprenticeshipExtension/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ApprenticeshipExtensionDto> {
        let url_ = this.baseUrl + "/api/services/app/ApprenticeshipExtension/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApprenticeshipExtensionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApprenticeshipExtensionDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApprenticeshipExtensionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApprenticeshipExtensionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ApprenticeshipStateServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ApprenticeshipState/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class Art18TypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Art18Type/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AtecoCodeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AtecoCode/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BusinessSectorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BusinessSector/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CertificateServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Certificate/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CompensationPaymentRequestServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param monthId (optional) 
     * @param year (optional) 
     * @param isPaginated (optional) 
     * @param apprenticeshipId (optional) 
     * @param entityId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    downloadPaymentRequestsExcel(keyword: string | undefined, monthId: number | undefined, year: number | undefined, isPaginated: boolean | undefined, apprenticeshipId: number | undefined, entityId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FileExcelDto> {
        let url_ = this.baseUrl + "/api/services/app/CompensationPaymentRequest/DownloadPaymentRequestsExcel?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (monthId === null)
            throw new globalThis.Error("The parameter 'monthId' cannot be null.");
        else if (monthId !== undefined)
            url_ += "MonthId=" + encodeURIComponent("" + monthId) + "&";
        if (year === null)
            throw new globalThis.Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (apprenticeshipId === null)
            throw new globalThis.Error("The parameter 'apprenticeshipId' cannot be null.");
        else if (apprenticeshipId !== undefined)
            url_ += "ApprenticeshipId=" + encodeURIComponent("" + apprenticeshipId) + "&";
        if (entityId === null)
            throw new globalThis.Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadPaymentRequestsExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadPaymentRequestsExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileExcelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileExcelDto>;
        }));
    }

    protected processDownloadPaymentRequestsExcel(response: HttpResponseBase): Observable<FileExcelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExcelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    multiCreate(body: MultiCreateCompensationPaymentRequestDto | undefined): Observable<CompensationPaymentRequestDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CompensationPaymentRequest/MultiCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMultiCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMultiCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompensationPaymentRequestDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompensationPaymentRequestDto[]>;
        }));
    }

    protected processMultiCreate(response: HttpResponseBase): Observable<CompensationPaymentRequestDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompensationPaymentRequestDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    multiPaymentConfirmation(body: number[] | undefined): Observable<CompensationPaymentRequestDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CompensationPaymentRequest/MultiPaymentConfirmation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMultiPaymentConfirmation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMultiPaymentConfirmation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompensationPaymentRequestDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompensationPaymentRequestDto[]>;
        }));
    }

    protected processMultiPaymentConfirmation(response: HttpResponseBase): Observable<CompensationPaymentRequestDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompensationPaymentRequestDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    sendEmailToAdmins(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CompensationPaymentRequest/SendEmailToAdmins?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmailToAdmins(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmailToAdmins(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendEmailToAdmins(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateCompensationPaymentRequestDto | undefined): Observable<CompensationPaymentRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/CompensationPaymentRequest/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompensationPaymentRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompensationPaymentRequestDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CompensationPaymentRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompensationPaymentRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCompensationPaymentRequestDto | undefined): Observable<CompensationPaymentRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/CompensationPaymentRequest/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompensationPaymentRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompensationPaymentRequestDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CompensationPaymentRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompensationPaymentRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CompensationPaymentRequest/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CompensationPaymentRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/CompensationPaymentRequest/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompensationPaymentRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompensationPaymentRequestDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CompensationPaymentRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompensationPaymentRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param monthId (optional) 
     * @param year (optional) 
     * @param isPaginated (optional) 
     * @param apprenticeshipId (optional) 
     * @param entityId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, monthId: number | undefined, year: number | undefined, isPaginated: boolean | undefined, apprenticeshipId: number | undefined, entityId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CompensationPaymentRequestDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CompensationPaymentRequest/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (monthId === null)
            throw new globalThis.Error("The parameter 'monthId' cannot be null.");
        else if (monthId !== undefined)
            url_ += "MonthId=" + encodeURIComponent("" + monthId) + "&";
        if (year === null)
            throw new globalThis.Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (apprenticeshipId === null)
            throw new globalThis.Error("The parameter 'apprenticeshipId' cannot be null.");
        else if (apprenticeshipId !== undefined)
            url_ += "ApprenticeshipId=" + encodeURIComponent("" + apprenticeshipId) + "&";
        if (entityId === null)
            throw new globalThis.Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompensationPaymentRequestDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompensationPaymentRequestDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CompensationPaymentRequestDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompensationPaymentRequestDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ComputerSkillsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ComputerSkills/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ConfigurationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeUiTheme(body: ChangeUiThemeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/ChangeUiTheme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeUiTheme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeUiTheme(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeUiTheme(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param token (optional) 
     * @return Success
     */
    changeGitToken(token: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/ChangeGitToken?";
        if (token === null)
            throw new globalThis.Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeGitToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeGitToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeGitToken(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ContactPersonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateContactPersonDto | undefined): Observable<ContactPersonDto> {
        let url_ = this.baseUrl + "/api/services/app/ContactPerson/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactPersonDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ContactPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateContactPersonDto | undefined): Observable<ContactPersonDto> {
        let url_ = this.baseUrl + "/api/services/app/ContactPerson/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactPersonDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ContactPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ContactPerson/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ContactPersonDto> {
        let url_ = this.baseUrl + "/api/services/app/ContactPerson/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactPersonDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ContactPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param userId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, userId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ContactPersonDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ContactPerson/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactPersonDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactPersonDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ContactPersonDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactPersonDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ContractProposalServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param isForApprenticeship (optional) 
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(isForApprenticeship: boolean | undefined, keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ContractProposal/GetAll?";
        if (isForApprenticeship === null)
            throw new globalThis.Error("The parameter 'isForApprenticeship' cannot be null.");
        else if (isForApprenticeship !== undefined)
            url_ += "IsForApprenticeship=" + encodeURIComponent("" + isForApprenticeship) + "&";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ContractTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ContractType/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DaysAvailabilityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DaysAvailability/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DGRServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DGR/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DisabilityTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DisabilityType/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DrivingLicenseTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DrivingLicenseType/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EducationalDegreeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param educationalDegreeLevelId (optional) 
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(educationalDegreeLevelId: number | undefined, keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<EducationalDegreeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EducationalDegree/GetAll?";
        if (educationalDegreeLevelId === null)
            throw new globalThis.Error("The parameter 'educationalDegreeLevelId' cannot be null.");
        else if (educationalDegreeLevelId !== undefined)
            url_ += "EducationalDegreeLevelId=" + encodeURIComponent("" + educationalDegreeLevelId) + "&";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducationalDegreeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducationalDegreeDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<EducationalDegreeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EducationalDegreeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EducationalDegreeLevelServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EducationalDegreeLevel/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EmployeesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EmploymentStatusServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EmploymentStatus/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    fileAssociation(body: CreateFileAssociation | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/File/FileAssociation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFileAssociation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFileAssociation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processFileAssociation(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param file (optional) 
     * @return Success
     */
    create(file: FileParameter | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/File/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    associateFileType(body: AssociateFileTypeDto | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/File/AssociateFileType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssociateFileType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssociateFileType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processAssociateFileType(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param name (optional) 
     * @param userId (optional) 
     * @param requestApprenticeshipId (optional) 
     * @param apprenticeshipId (optional) 
     * @param conventionId (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(name: string | undefined, userId: number | undefined, requestApprenticeshipId: number | undefined, apprenticeshipId: number | undefined, conventionId: number | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FileDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/File/GetAll?";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (requestApprenticeshipId === null)
            throw new globalThis.Error("The parameter 'requestApprenticeshipId' cannot be null.");
        else if (requestApprenticeshipId !== undefined)
            url_ += "RequestApprenticeshipId=" + encodeURIComponent("" + requestApprenticeshipId) + "&";
        if (apprenticeshipId === null)
            throw new globalThis.Error("The parameter 'apprenticeshipId' cannot be null.");
        else if (apprenticeshipId !== undefined)
            url_ += "ApprenticeshipId=" + encodeURIComponent("" + apprenticeshipId) + "&";
        if (conventionId === null)
            throw new globalThis.Error("The parameter 'conventionId' cannot be null.");
        else if (conventionId !== undefined)
            url_ += "ConventionId=" + encodeURIComponent("" + conventionId) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<FileDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return Success
     */
    downloadFile(fileId: number | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/app/File/DownloadFile?";
        if (fileId === null)
            throw new globalThis.Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processDownloadFile(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return Success
     */
    getFile(fileId: number | undefined): Observable<FileExtendedDto> {
        let url_ = this.baseUrl + "/api/services/app/File/GetFile?";
        if (fileId === null)
            throw new globalThis.Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileExtendedDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileExtendedDto>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<FileExtendedDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExtendedDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/File/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    downloadTemplateApprenticeship(): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/app/File/DownloadTemplateApprenticeship";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadTemplateApprenticeship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadTemplateApprenticeship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processDownloadTemplateApprenticeship(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/File/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FileTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param isForApprenticeshipDocumention (optional) 
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(isForApprenticeshipDocumention: boolean | undefined, keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FileType/GetAll?";
        if (isForApprenticeshipDocumention === null)
            throw new globalThis.Error("The parameter 'isForApprenticeshipDocumention' cannot be null.");
        else if (isForApprenticeshipDocumention !== undefined)
            url_ += "IsForApprenticeshipDocumention=" + encodeURIComponent("" + isForApprenticeshipDocumention) + "&";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FruitionTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FruitionType/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class GenderServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Gender/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HourEffortServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HourEffort/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class IncomeSupportTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/IncomeSupportType/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class JobServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Job/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class JobSearchServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateJobSearchDto | undefined): Observable<JobSearchDto> {
        let url_ = this.baseUrl + "/api/services/app/JobSearch/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobSearchDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobSearchDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<JobSearchDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobSearchDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateJobSearchDto | undefined): Observable<JobSearchDto> {
        let url_ = this.baseUrl + "/api/services/app/JobSearch/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobSearchDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobSearchDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<JobSearchDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobSearchDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/JobSearch/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<JobSearchDto> {
        let url_ = this.baseUrl + "/api/services/app/JobSearch/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobSearchDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobSearchDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<JobSearchDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobSearchDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(userId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<JobSearchDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/JobSearch/GetAll?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobSearchDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobSearchDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<JobSearchDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobSearchDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LaborConsultantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    associateCompany(body: AssociateCompanyInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LaborConsultant/AssociateCompany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssociateCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssociateCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssociateCompany(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    disassociateCompany(body: AssociateCompanyInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LaborConsultant/DisassociateCompany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisassociateCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisassociateCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDisassociateCompany(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LaborConsultant/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param companyId (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    downloadLaborConsultantCSV(keyword: string | undefined, companyId: number | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FileExcelDto> {
        let url_ = this.baseUrl + "/api/services/app/LaborConsultant/DownloadLaborConsultantCSV?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (companyId === null)
            throw new globalThis.Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadLaborConsultantCSV(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadLaborConsultantCSV(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileExcelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileExcelDto>;
        }));
    }

    protected processDownloadLaborConsultantCSV(response: HttpResponseBase): Observable<FileExcelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExcelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    downloadLaborConsultantCompaniesCSV(id: number | undefined): Observable<FileExcelDto> {
        let url_ = this.baseUrl + "/api/services/app/LaborConsultant/DownloadLaborConsultantCompaniesCSV?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadLaborConsultantCompaniesCSV(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadLaborConsultantCompaniesCSV(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileExcelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileExcelDto>;
        }));
    }

    protected processDownloadLaborConsultantCompaniesCSV(response: HttpResponseBase): Observable<FileExcelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExcelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateLaborConsultantDto | undefined): Observable<LaborConsultantDto> {
        let url_ = this.baseUrl + "/api/services/app/LaborConsultant/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LaborConsultantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LaborConsultantDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<LaborConsultantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LaborConsultantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateLaborConsultantDto | undefined): Observable<LaborConsultantDto> {
        let url_ = this.baseUrl + "/api/services/app/LaborConsultant/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LaborConsultantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LaborConsultantDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<LaborConsultantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LaborConsultantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<LaborConsultantDto> {
        let url_ = this.baseUrl + "/api/services/app/LaborConsultant/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LaborConsultantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LaborConsultantDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<LaborConsultantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LaborConsultantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param companyId (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, companyId: number | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<LaborConsultantItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/LaborConsultant/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (companyId === null)
            throw new globalThis.Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LaborConsultantItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LaborConsultantItemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<LaborConsultantItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LaborConsultantItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LanguageLevelServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LanguageLevel/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LanguagesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Languages/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MaritalStatusServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MaritalStatus/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MonthsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Months/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MotivationResidencePermitServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MotivationResidencePermit/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Nation/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NationalityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Nationality/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OperativeUnitServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getAllOperativeUnitsWithoutFilters(): Observable<OperativeUnitDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OperativeUnit/GetAllOperativeUnitsWithoutFilters";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllOperativeUnitsWithoutFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOperativeUnitsWithoutFilters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperativeUnitDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperativeUnitDto[]>;
        }));
    }

    protected processGetAllOperativeUnitsWithoutFilters(response: HttpResponseBase): Observable<OperativeUnitDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OperativeUnitDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param operativeUnitId (optional) 
     * @return Success
     */
    hasUsersAssociated(operativeUnitId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/OperativeUnit/HasUsersAssociated?";
        if (operativeUnitId === null)
            throw new globalThis.Error("The parameter 'operativeUnitId' cannot be null.");
        else if (operativeUnitId !== undefined)
            url_ += "operativeUnitId=" + encodeURIComponent("" + operativeUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasUsersAssociated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasUsersAssociated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processHasUsersAssociated(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param operativeUnitId (optional) 
     * @param body (optional) 
     * @return Success
     */
    associateUsers(operativeUnitId: number | undefined, body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OperativeUnit/AssociateUsers?";
        if (operativeUnitId === null)
            throw new globalThis.Error("The parameter 'operativeUnitId' cannot be null.");
        else if (operativeUnitId !== undefined)
            url_ += "operativeUnitId=" + encodeURIComponent("" + operativeUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssociateUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssociateUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssociateUsers(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param operativeUnitId (optional) 
     * @param body (optional) 
     * @return Success
     */
    associatePartners(operativeUnitId: number | undefined, body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OperativeUnit/AssociatePartners?";
        if (operativeUnitId === null)
            throw new globalThis.Error("The parameter 'operativeUnitId' cannot be null.");
        else if (operativeUnitId !== undefined)
            url_ += "operativeUnitId=" + encodeURIComponent("" + operativeUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssociatePartners(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssociatePartners(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssociatePartners(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateOperativeUnitDto | undefined): Observable<OperativeUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OperativeUnit/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperativeUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperativeUnitDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<OperativeUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperativeUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateOperativeUnitDto | undefined): Observable<OperativeUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OperativeUnit/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperativeUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperativeUnitDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<OperativeUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperativeUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OperativeUnit/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<OperativeUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OperativeUnit/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperativeUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperativeUnitDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OperativeUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperativeUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param headOffice (optional) 
     * @param provinceId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(headOffice: string | undefined, provinceId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OperativeUnitDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/OperativeUnit/GetAll?";
        if (headOffice === null)
            throw new globalThis.Error("The parameter 'headOffice' cannot be null.");
        else if (headOffice !== undefined)
            url_ += "HeadOffice=" + encodeURIComponent("" + headOffice) + "&";
        if (provinceId === null)
            throw new globalThis.Error("The parameter 'provinceId' cannot be null.");
        else if (provinceId !== undefined)
            url_ += "ProvinceId=" + encodeURIComponent("" + provinceId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperativeUnitDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperativeUnitDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<OperativeUnitDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperativeUnitDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OrderCodeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OrderCodeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderCode/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderCodeDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderCodeDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<OrderCodeDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderCodeDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrderCode/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateOrderCodeDto | undefined): Observable<OrderCodeDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderCode/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderCodeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderCodeDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<OrderCodeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderCodeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateOrderCodeDto | undefined): Observable<OrderCodeDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderCode/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderCodeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderCodeDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<OrderCodeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderCodeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<OrderCodeDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderCode/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderCodeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderCodeDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OrderCodeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderCodeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PartnerServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdatePartnerServiceDto | undefined): Observable<PartnerServiceDto> {
        let url_ = this.baseUrl + "/api/services/app/PartnerService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartnerServiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartnerServiceDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PartnerServiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerServiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePartnerServicesDto | undefined): Observable<PartnerServiceDto> {
        let url_ = this.baseUrl + "/api/services/app/PartnerService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartnerServiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartnerServiceDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PartnerServiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerServiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PartnerService/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PartnerServiceDto> {
        let url_ = this.baseUrl + "/api/services/app/PartnerService/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartnerServiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartnerServiceDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PartnerServiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerServiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param partnerId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(partnerId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PartnerServiceDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PartnerService/GetAll?";
        if (partnerId === null)
            throw new globalThis.Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined)
            url_ += "PartnerId=" + encodeURIComponent("" + partnerId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartnerServiceDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartnerServiceDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PartnerServiceDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerServiceDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PartnerSurveyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param partnerId (optional) 
     * @return Success
     */
    getByPartnerId(partnerId: number | undefined): Observable<PartnerSurveyDto> {
        let url_ = this.baseUrl + "/api/services/app/PartnerSurvey/GetByPartnerId?";
        if (partnerId === null)
            throw new globalThis.Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined)
            url_ += "partnerId=" + encodeURIComponent("" + partnerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByPartnerId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByPartnerId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartnerSurveyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartnerSurveyDto>;
        }));
    }

    protected processGetByPartnerId(response: HttpResponseBase): Observable<PartnerSurveyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerSurveyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdatePartnerSurveyDto | undefined): Observable<PartnerSurveyDto> {
        let url_ = this.baseUrl + "/api/services/app/PartnerSurvey/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartnerSurveyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartnerSurveyDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PartnerSurveyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerSurveyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePartnerSurveyDto | undefined): Observable<PartnerSurveyDto> {
        let url_ = this.baseUrl + "/api/services/app/PartnerSurvey/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartnerSurveyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartnerSurveyDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PartnerSurveyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerSurveyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PartnerSurvey/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PartnerSurveyDto> {
        let url_ = this.baseUrl + "/api/services/app/PartnerSurvey/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartnerSurveyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartnerSurveyDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PartnerSurveyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerSurveyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PartnerSurveyDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PartnerSurvey/GetAll?";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartnerSurveyDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartnerSurveyDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PartnerSurveyDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerSurveyDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PartnerTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PartnerType/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PartnerUserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePartnerUserDto | undefined): Observable<PartnerUserDto> {
        let url_ = this.baseUrl + "/api/services/app/PartnerUser/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartnerUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartnerUserDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PartnerUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param partnerId (optional) 
     * @param personId (optional) 
     * @return Success
     */
    deletePartnerUser(partnerId: number | undefined, personId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PartnerUser/DeletePartnerUser?";
        if (partnerId === null)
            throw new globalThis.Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined)
            url_ += "PartnerId=" + encodeURIComponent("" + partnerId) + "&";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "PersonId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePartnerUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePartnerUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePartnerUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PartnerUser/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PartnerUserDto> {
        let url_ = this.baseUrl + "/api/services/app/PartnerUser/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartnerUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartnerUserDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PartnerUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keywordPartner (optional) 
     * @param keywordPerson (optional) 
     * @param partnerId (optional) 
     * @param personId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keywordPartner: string | undefined, keywordPerson: string | undefined, partnerId: number | undefined, personId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PartnerUserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PartnerUser/GetAll?";
        if (keywordPartner === null)
            throw new globalThis.Error("The parameter 'keywordPartner' cannot be null.");
        else if (keywordPartner !== undefined)
            url_ += "KeywordPartner=" + encodeURIComponent("" + keywordPartner) + "&";
        if (keywordPerson === null)
            throw new globalThis.Error("The parameter 'keywordPerson' cannot be null.");
        else if (keywordPerson !== undefined)
            url_ += "KeywordPerson=" + encodeURIComponent("" + keywordPerson) + "&";
        if (partnerId === null)
            throw new globalThis.Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined)
            url_ += "PartnerId=" + encodeURIComponent("" + partnerId) + "&";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "PersonId=" + encodeURIComponent("" + personId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartnerUserDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartnerUserDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PartnerUserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerUserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PersonalInfoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdatePersonalInfoDto | undefined): Observable<PersonalInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonalInfo/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonalInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonalInfoDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PersonalInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonalInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePersonalInfoDto | undefined): Observable<PersonalInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonalInfo/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonalInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonalInfoDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PersonalInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonalInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PersonalInfo/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PersonalInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonalInfo/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonalInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonalInfoDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PersonalInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonalInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(userId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PersonalInfoDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonalInfo/GetAll?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonalInfoDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonalInfoDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PersonalInfoDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonalInfoDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProjectCodeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProjectCode/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class QualificationTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/QualificationType/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RequestApprenticeshipServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateRequestApprenticeshipDto | undefined): Observable<RequestApprenticeshipDto> {
        let url_ = this.baseUrl + "/api/services/app/RequestApprenticeship/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RequestApprenticeshipDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RequestApprenticeshipDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RequestApprenticeshipDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RequestApprenticeshipDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateRequestApprenticeshipDto | undefined): Observable<RequestApprenticeshipDto> {
        let url_ = this.baseUrl + "/api/services/app/RequestApprenticeship/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RequestApprenticeshipDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RequestApprenticeshipDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RequestApprenticeshipDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RequestApprenticeshipDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RequestApprenticeship/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<RequestApprenticeshipDto> {
        let url_ = this.baseUrl + "/api/services/app/RequestApprenticeship/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RequestApprenticeshipDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RequestApprenticeshipDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RequestApprenticeshipDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RequestApprenticeshipDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param isPaginated (optional) 
     * @param keyword (optional) 
     * @param partnerId (optional) 
     * @param stateId (optional) 
     * @param typeId (optional) 
     * @param requestTypeId (optional) 
     * @param jobId (optional) 
     * @param personId (optional) 
     * @param isPrivate (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(isPaginated: boolean | undefined, keyword: string | undefined, partnerId: number | undefined, stateId: number | undefined, typeId: number | undefined, requestTypeId: number | undefined, jobId: number | undefined, personId: number | undefined, isPrivate: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<RequestApprenticeshipDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/RequestApprenticeship/GetAll?";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (partnerId === null)
            throw new globalThis.Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined)
            url_ += "PartnerId=" + encodeURIComponent("" + partnerId) + "&";
        if (stateId === null)
            throw new globalThis.Error("The parameter 'stateId' cannot be null.");
        else if (stateId !== undefined)
            url_ += "StateId=" + encodeURIComponent("" + stateId) + "&";
        if (typeId === null)
            throw new globalThis.Error("The parameter 'typeId' cannot be null.");
        else if (typeId !== undefined)
            url_ += "TypeId=" + encodeURIComponent("" + typeId) + "&";
        if (requestTypeId === null)
            throw new globalThis.Error("The parameter 'requestTypeId' cannot be null.");
        else if (requestTypeId !== undefined)
            url_ += "RequestTypeId=" + encodeURIComponent("" + requestTypeId) + "&";
        if (jobId === null)
            throw new globalThis.Error("The parameter 'jobId' cannot be null.");
        else if (jobId !== undefined)
            url_ += "JobId=" + encodeURIComponent("" + jobId) + "&";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "PersonId=" + encodeURIComponent("" + personId) + "&";
        if (isPrivate === null)
            throw new globalThis.Error("The parameter 'isPrivate' cannot be null.");
        else if (isPrivate !== undefined)
            url_ += "IsPrivate=" + encodeURIComponent("" + isPrivate) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RequestApprenticeshipDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RequestApprenticeshipDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RequestApprenticeshipDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RequestApprenticeshipDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RequestApprenticeshipStateServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RequestApprenticeshipState/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RequestApprenticeshipTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RequestApprenticeshipType/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RequestTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RequestType/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ResidenceInfoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getByUserId(userId: number | undefined): Observable<ResidenceInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/ResidenceInfo/GetByUserId?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResidenceInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResidenceInfoDto>;
        }));
    }

    protected processGetByUserId(response: HttpResponseBase): Observable<ResidenceInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResidenceInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateResidenceInfoDto | undefined): Observable<ResidenceInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/ResidenceInfo/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResidenceInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResidenceInfoDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ResidenceInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResidenceInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateResidenceInfoDto | undefined): Observable<ResidenceInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/ResidenceInfo/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResidenceInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResidenceInfoDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ResidenceInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResidenceInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ResidenceInfo/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ResidenceInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/ResidenceInfo/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResidenceInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResidenceInfoDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ResidenceInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResidenceInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ResidenceInfoDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ResidenceInfo/GetAll?";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResidenceInfoDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResidenceInfoDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ResidenceInfoDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResidenceInfoDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ResidencePermitServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ResidencePermit/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateRoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param permission (optional) 
     * @return Success
     */
    getRoles(permission: string | undefined): Observable<RoleListDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoles?";
        if (permission === null)
            throw new globalThis.Error("The parameter 'permission' cannot be null.");
        else if (permission !== undefined)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleListDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleListDtoListResultDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleListDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleListDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: RoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllPermissions(): Observable<PermissionDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PermissionDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PermissionDtoListResultDto>;
        }));
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<PermissionDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PermissionDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRoleForEdit(id: number | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRoleForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRoleForEditOutput>;
        }));
    }

    protected processGetRoleForEdit(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRoleForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<RoleDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RoleDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SafetyTrainingTypesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SafetyTrainingTypes/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SalesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Sales/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SelectionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getUserSelectionsMatching(id: number | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<UserRatingDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Selection/GetUserSelectionsMatching?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserSelectionsMatching(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserSelectionsMatching(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserRatingDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserRatingDtoPagedResultDto>;
        }));
    }

    protected processGetUserSelectionsMatching(response: HttpResponseBase): Observable<UserRatingDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserRatingDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Selection/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param selectionId (optional) 
     * @param body (optional) 
     * @return Success
     */
    selectCandidates(selectionId: number | undefined, body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Selection/SelectCandidates?";
        if (selectionId === null)
            throw new globalThis.Error("The parameter 'selectionId' cannot be null.");
        else if (selectionId !== undefined)
            url_ += "selectionId=" + encodeURIComponent("" + selectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSelectCandidates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelectCandidates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSelectCandidates(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param partnerId (optional) 
     * @param requestTypeId (optional) 
     * @param jobId (optional) 
     * @param law68 (optional) 
     * @param personId (optional) 
     * @param isPrivate (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllSelectionsForMatching(keyword: string | undefined, partnerId: number | undefined, requestTypeId: number | undefined, jobId: number | undefined, law68: boolean | undefined, personId: number | undefined, isPrivate: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<SelectionDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Selection/GetAllSelectionsForMatching?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (partnerId === null)
            throw new globalThis.Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined)
            url_ += "PartnerId=" + encodeURIComponent("" + partnerId) + "&";
        if (requestTypeId === null)
            throw new globalThis.Error("The parameter 'requestTypeId' cannot be null.");
        else if (requestTypeId !== undefined)
            url_ += "RequestTypeId=" + encodeURIComponent("" + requestTypeId) + "&";
        if (jobId === null)
            throw new globalThis.Error("The parameter 'jobId' cannot be null.");
        else if (jobId !== undefined)
            url_ += "JobId=" + encodeURIComponent("" + jobId) + "&";
        if (law68 === null)
            throw new globalThis.Error("The parameter 'law68' cannot be null.");
        else if (law68 !== undefined)
            url_ += "Law68=" + encodeURIComponent("" + law68) + "&";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "PersonId=" + encodeURIComponent("" + personId) + "&";
        if (isPrivate === null)
            throw new globalThis.Error("The parameter 'isPrivate' cannot be null.");
        else if (isPrivate !== undefined)
            url_ += "IsPrivate=" + encodeURIComponent("" + isPrivate) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSelectionsForMatching(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSelectionsForMatching(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectionDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectionDtoPagedResultDto>;
        }));
    }

    protected processGetAllSelectionsForMatching(response: HttpResponseBase): Observable<SelectionDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelectionDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getSelectionForLandingPage(): Observable<PublicSelectionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Selection/GetSelectionForLandingPage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSelectionForLandingPage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSelectionForLandingPage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PublicSelectionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PublicSelectionDto[]>;
        }));
    }

    protected processGetSelectionForLandingPage(response: HttpResponseBase): Observable<PublicSelectionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PublicSelectionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateSelectionDto | undefined): Observable<SelectionDto> {
        let url_ = this.baseUrl + "/api/services/app/Selection/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectionDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<SelectionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateSelectionDto | undefined): Observable<SelectionDto> {
        let url_ = this.baseUrl + "/api/services/app/Selection/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectionDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<SelectionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<SelectionDto> {
        let url_ = this.baseUrl + "/api/services/app/Selection/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectionDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SelectionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param partnerId (optional) 
     * @param requestTypeId (optional) 
     * @param jobId (optional) 
     * @param law68 (optional) 
     * @param personId (optional) 
     * @param isPrivate (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, partnerId: number | undefined, requestTypeId: number | undefined, jobId: number | undefined, law68: boolean | undefined, personId: number | undefined, isPrivate: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<SelectionDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Selection/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (partnerId === null)
            throw new globalThis.Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined)
            url_ += "PartnerId=" + encodeURIComponent("" + partnerId) + "&";
        if (requestTypeId === null)
            throw new globalThis.Error("The parameter 'requestTypeId' cannot be null.");
        else if (requestTypeId !== undefined)
            url_ += "RequestTypeId=" + encodeURIComponent("" + requestTypeId) + "&";
        if (jobId === null)
            throw new globalThis.Error("The parameter 'jobId' cannot be null.");
        else if (jobId !== undefined)
            url_ += "JobId=" + encodeURIComponent("" + jobId) + "&";
        if (law68 === null)
            throw new globalThis.Error("The parameter 'law68' cannot be null.");
        else if (law68 !== undefined)
            url_ += "Law68=" + encodeURIComponent("" + law68) + "&";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "PersonId=" + encodeURIComponent("" + personId) + "&";
        if (isPrivate === null)
            throw new globalThis.Error("The parameter 'isPrivate' cannot be null.");
        else if (isPrivate !== undefined)
            url_ += "IsPrivate=" + encodeURIComponent("" + isPrivate) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectionDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectionDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SelectionDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelectionDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SelectionApplicationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SelectionApplication/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateSelectionApplicationDto | undefined): Observable<SelectionApplicationDto> {
        let url_ = this.baseUrl + "/api/services/app/SelectionApplication/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectionApplicationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectionApplicationDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<SelectionApplicationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelectionApplicationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateSelectionApplicationDto | undefined): Observable<SelectionApplicationDto> {
        let url_ = this.baseUrl + "/api/services/app/SelectionApplication/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectionApplicationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectionApplicationDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<SelectionApplicationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelectionApplicationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<SelectionApplicationDto> {
        let url_ = this.baseUrl + "/api/services/app/SelectionApplication/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectionApplicationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectionApplicationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SelectionApplicationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelectionApplicationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @param selectionId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(personId: number | undefined, selectionId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<SelectionApplicationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/SelectionApplication/GetAll?";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "PersonId=" + encodeURIComponent("" + personId) + "&";
        if (selectionId === null)
            throw new globalThis.Error("The parameter 'selectionId' cannot be null.");
        else if (selectionId !== undefined)
            url_ += "SelectionId=" + encodeURIComponent("" + selectionId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectionApplicationDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectionApplicationDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SelectionApplicationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelectionApplicationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SelectionComputerSkillServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateSelectionComputerSkillDto | undefined): Observable<SelectionComputerSkillDto> {
        let url_ = this.baseUrl + "/api/services/app/SelectionComputerSkill/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectionComputerSkillDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectionComputerSkillDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<SelectionComputerSkillDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelectionComputerSkillDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateSelectionComputerSkillDto | undefined): Observable<SelectionComputerSkillDto> {
        let url_ = this.baseUrl + "/api/services/app/SelectionComputerSkill/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectionComputerSkillDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectionComputerSkillDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<SelectionComputerSkillDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelectionComputerSkillDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SelectionComputerSkill/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<SelectionComputerSkillDto> {
        let url_ = this.baseUrl + "/api/services/app/SelectionComputerSkill/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectionComputerSkillDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectionComputerSkillDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SelectionComputerSkillDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelectionComputerSkillDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param selectionId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(selectionId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<SelectionComputerSkillDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/SelectionComputerSkill/GetAll?";
        if (selectionId === null)
            throw new globalThis.Error("The parameter 'selectionId' cannot be null.");
        else if (selectionId !== undefined)
            url_ += "SelectionId=" + encodeURIComponent("" + selectionId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectionComputerSkillDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectionComputerSkillDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SelectionComputerSkillDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelectionComputerSkillDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SelectionJobSearchServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateSelectionJobSearchDto | undefined): Observable<SelectionJobSearchDto> {
        let url_ = this.baseUrl + "/api/services/app/SelectionJobSearch/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectionJobSearchDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectionJobSearchDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<SelectionJobSearchDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelectionJobSearchDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateSelectionJobSearchDto | undefined): Observable<SelectionJobSearchDto> {
        let url_ = this.baseUrl + "/api/services/app/SelectionJobSearch/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectionJobSearchDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectionJobSearchDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<SelectionJobSearchDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelectionJobSearchDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SelectionJobSearch/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<SelectionJobSearchDto> {
        let url_ = this.baseUrl + "/api/services/app/SelectionJobSearch/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectionJobSearchDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectionJobSearchDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SelectionJobSearchDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelectionJobSearchDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param selectionId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(selectionId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<SelectionJobSearchDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/SelectionJobSearch/GetAll?";
        if (selectionId === null)
            throw new globalThis.Error("The parameter 'selectionId' cannot be null.");
        else if (selectionId !== undefined)
            url_ += "SelectionId=" + encodeURIComponent("" + selectionId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectionJobSearchDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectionJobSearchDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SelectionJobSearchDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelectionJobSearchDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SelectionLanguageServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateSelectionLanguageDto | undefined): Observable<SelectionLanguageDto> {
        let url_ = this.baseUrl + "/api/services/app/SelectionLanguage/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectionLanguageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectionLanguageDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<SelectionLanguageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelectionLanguageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateSelectionLanguageDto | undefined): Observable<SelectionLanguageDto> {
        let url_ = this.baseUrl + "/api/services/app/SelectionLanguage/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectionLanguageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectionLanguageDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<SelectionLanguageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelectionLanguageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SelectionLanguage/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<SelectionLanguageDto> {
        let url_ = this.baseUrl + "/api/services/app/SelectionLanguage/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectionLanguageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectionLanguageDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SelectionLanguageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelectionLanguageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param selectionId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(selectionId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<SelectionLanguageDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/SelectionLanguage/GetAll?";
        if (selectionId === null)
            throw new globalThis.Error("The parameter 'selectionId' cannot be null.");
        else if (selectionId !== undefined)
            url_ += "SelectionId=" + encodeURIComponent("" + selectionId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectionLanguageDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectionLanguageDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SelectionLanguageDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelectionLanguageDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SelectionQualificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateSelectionQualificationDto | undefined): Observable<SelectionQualificationDto> {
        let url_ = this.baseUrl + "/api/services/app/SelectionQualification/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectionQualificationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectionQualificationDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<SelectionQualificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelectionQualificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateSelectionQualificationDto | undefined): Observable<SelectionQualificationDto> {
        let url_ = this.baseUrl + "/api/services/app/SelectionQualification/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectionQualificationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectionQualificationDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<SelectionQualificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelectionQualificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SelectionQualification/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<SelectionQualificationDto> {
        let url_ = this.baseUrl + "/api/services/app/SelectionQualification/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectionQualificationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectionQualificationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SelectionQualificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelectionQualificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param selectionId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(selectionId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<SelectionQualificationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/SelectionQualification/GetAll?";
        if (selectionId === null)
            throw new globalThis.Error("The parameter 'selectionId' cannot be null.");
        else if (selectionId !== undefined)
            url_ += "SelectionId=" + encodeURIComponent("" + selectionId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectionQualificationDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectionQualificationDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SelectionQualificationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelectionQualificationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginInformations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCurrentLoginInformationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCurrentLoginInformationsOutput>;
        }));
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateTenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<TenantDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new globalThis.Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TenantDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: TenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TimeAvailabilitySlotServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TimeAvailabilitySlot/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TitleRecognitionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TitleRecognition/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticate(body: AuthenticateModel | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticateResultModel>;
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalAuthenticationProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalAuthenticationProviders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalLoginProviderInfoModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalLoginProviderInfoModel[]>;
        }));
    }

    protected processGetExternalAuthenticationProviders(response: HttpResponseBase): Observable<ExternalLoginProviderInfoModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExternalLoginProviderInfoModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    externalAuthenticate(body: ExternalAuthenticateModel | undefined): Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalAuthenticateResultModel>;
        }));
    }

    protected processExternalAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TransversalSkillLevelServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TransversalSkillLevel/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateUserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    toggleActivationUser(userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ToggleActivationUser?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToggleActivationUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleActivationUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processToggleActivationUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    unlockLogin(userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UnlockLogin?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlockLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlockLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlockLogin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeLanguage(body: ChangeUserLanguageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    forceResetPassword(body: ForceResetPasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ForceResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForceResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForceResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processForceResetPassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param educationOtherKeyword (optional) 
     * @param isActive (optional) 
     * @param operativeUnitId (optional) 
     * @param roleIds (optional) 
     * @param regionId (optional) 
     * @param provinceId (optional) 
     * @param municipalityId (optional) 
     * @param employmentStatusId (optional) 
     * @param partnerId (optional) 
     * @param isForAssociate (optional) 
     * @param operativeUnitNotAssociated (optional) 
     * @param partnerTypeId (optional) 
     * @param creatorUserId (optional) 
     * @param isPaginated (optional) 
     * @param qualificationTypeId (optional) 
     * @param languageId (optional) 
     * @param hasLaw68 (optional) 
     * @param hasAvailabilityToTravel (optional) 
     * @param selectionId (optional) 
     * @param educationalDegreeId (optional) 
     * @param hasApprenticeship (optional) 
     * @param withoutLaborConsultant (optional) 
     * @param jobId (optional) 
     * @param requestTypeId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, educationOtherKeyword: string | undefined, isActive: boolean | undefined, operativeUnitId: number | undefined, roleIds: number[] | undefined, regionId: number | undefined, provinceId: number | undefined, municipalityId: number | undefined, employmentStatusId: number | undefined, partnerId: number | undefined, isForAssociate: boolean | undefined, operativeUnitNotAssociated: number | undefined, partnerTypeId: number | undefined, creatorUserId: number | undefined, isPaginated: boolean | undefined, qualificationTypeId: number | undefined, languageId: number | undefined, hasLaw68: boolean | undefined, hasAvailabilityToTravel: boolean | undefined, selectionId: number | undefined, educationalDegreeId: number | undefined, hasApprenticeship: boolean | undefined, withoutLaborConsultant: boolean | undefined, jobId: number | undefined, requestTypeId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (educationOtherKeyword === null)
            throw new globalThis.Error("The parameter 'educationOtherKeyword' cannot be null.");
        else if (educationOtherKeyword !== undefined)
            url_ += "EducationOtherKeyword=" + encodeURIComponent("" + educationOtherKeyword) + "&";
        if (isActive === null)
            throw new globalThis.Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (operativeUnitId === null)
            throw new globalThis.Error("The parameter 'operativeUnitId' cannot be null.");
        else if (operativeUnitId !== undefined)
            url_ += "OperativeUnitId=" + encodeURIComponent("" + operativeUnitId) + "&";
        if (roleIds === null)
            throw new globalThis.Error("The parameter 'roleIds' cannot be null.");
        else if (roleIds !== undefined)
            roleIds && roleIds.forEach(item => { url_ += "RoleIds=" + encodeURIComponent("" + item) + "&"; });
        if (regionId === null)
            throw new globalThis.Error("The parameter 'regionId' cannot be null.");
        else if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&";
        if (provinceId === null)
            throw new globalThis.Error("The parameter 'provinceId' cannot be null.");
        else if (provinceId !== undefined)
            url_ += "ProvinceId=" + encodeURIComponent("" + provinceId) + "&";
        if (municipalityId === null)
            throw new globalThis.Error("The parameter 'municipalityId' cannot be null.");
        else if (municipalityId !== undefined)
            url_ += "MunicipalityId=" + encodeURIComponent("" + municipalityId) + "&";
        if (employmentStatusId === null)
            throw new globalThis.Error("The parameter 'employmentStatusId' cannot be null.");
        else if (employmentStatusId !== undefined)
            url_ += "EmploymentStatusId=" + encodeURIComponent("" + employmentStatusId) + "&";
        if (partnerId === null)
            throw new globalThis.Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined)
            url_ += "PartnerId=" + encodeURIComponent("" + partnerId) + "&";
        if (isForAssociate === null)
            throw new globalThis.Error("The parameter 'isForAssociate' cannot be null.");
        else if (isForAssociate !== undefined)
            url_ += "IsForAssociate=" + encodeURIComponent("" + isForAssociate) + "&";
        if (operativeUnitNotAssociated === null)
            throw new globalThis.Error("The parameter 'operativeUnitNotAssociated' cannot be null.");
        else if (operativeUnitNotAssociated !== undefined)
            url_ += "OperativeUnitNotAssociated=" + encodeURIComponent("" + operativeUnitNotAssociated) + "&";
        if (partnerTypeId === null)
            throw new globalThis.Error("The parameter 'partnerTypeId' cannot be null.");
        else if (partnerTypeId !== undefined)
            url_ += "PartnerTypeId=" + encodeURIComponent("" + partnerTypeId) + "&";
        if (creatorUserId === null)
            throw new globalThis.Error("The parameter 'creatorUserId' cannot be null.");
        else if (creatorUserId !== undefined)
            url_ += "CreatorUserId=" + encodeURIComponent("" + creatorUserId) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (qualificationTypeId === null)
            throw new globalThis.Error("The parameter 'qualificationTypeId' cannot be null.");
        else if (qualificationTypeId !== undefined)
            url_ += "QualificationTypeId=" + encodeURIComponent("" + qualificationTypeId) + "&";
        if (languageId === null)
            throw new globalThis.Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "LanguageId=" + encodeURIComponent("" + languageId) + "&";
        if (hasLaw68 === null)
            throw new globalThis.Error("The parameter 'hasLaw68' cannot be null.");
        else if (hasLaw68 !== undefined)
            url_ += "HasLaw68=" + encodeURIComponent("" + hasLaw68) + "&";
        if (hasAvailabilityToTravel === null)
            throw new globalThis.Error("The parameter 'hasAvailabilityToTravel' cannot be null.");
        else if (hasAvailabilityToTravel !== undefined)
            url_ += "HasAvailabilityToTravel=" + encodeURIComponent("" + hasAvailabilityToTravel) + "&";
        if (selectionId === null)
            throw new globalThis.Error("The parameter 'selectionId' cannot be null.");
        else if (selectionId !== undefined)
            url_ += "SelectionId=" + encodeURIComponent("" + selectionId) + "&";
        if (educationalDegreeId === null)
            throw new globalThis.Error("The parameter 'educationalDegreeId' cannot be null.");
        else if (educationalDegreeId !== undefined)
            url_ += "EducationalDegreeId=" + encodeURIComponent("" + educationalDegreeId) + "&";
        if (hasApprenticeship === null)
            throw new globalThis.Error("The parameter 'hasApprenticeship' cannot be null.");
        else if (hasApprenticeship !== undefined)
            url_ += "HasApprenticeship=" + encodeURIComponent("" + hasApprenticeship) + "&";
        if (withoutLaborConsultant === null)
            throw new globalThis.Error("The parameter 'withoutLaborConsultant' cannot be null.");
        else if (withoutLaborConsultant !== undefined)
            url_ += "WithoutLaborConsultant=" + encodeURIComponent("" + withoutLaborConsultant) + "&";
        if (jobId === null)
            throw new globalThis.Error("The parameter 'jobId' cannot be null.");
        else if (jobId !== undefined)
            url_ += "JobId=" + encodeURIComponent("" + jobId) + "&";
        if (requestTypeId === null)
            throw new globalThis.Error("The parameter 'requestTypeId' cannot be null.");
        else if (requestTypeId !== undefined)
            url_ += "RequestTypeId=" + encodeURIComponent("" + requestTypeId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getUserSelectionsMatching(id: number | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<SelectionRatingDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserSelectionsMatching?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserSelectionsMatching(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserSelectionsMatching(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectionRatingDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectionRatingDtoPagedResultDto>;
        }));
    }

    protected processGetUserSelectionsMatching(response: HttpResponseBase): Observable<SelectionRatingDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelectionRatingDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fiscalCode (optional) 
     * @param userId (optional) 
     * @return Success
     */
    isFiscalCodeCorrect(fiscalCode: string | undefined, userId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/IsFiscalCodeCorrect?";
        if (fiscalCode === null)
            throw new globalThis.Error("The parameter 'fiscalCode' cannot be null.");
        else if (fiscalCode !== undefined)
            url_ += "fiscalCode=" + encodeURIComponent("" + fiscalCode) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsFiscalCodeCorrect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsFiscalCodeCorrect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsFiscalCodeCorrect(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param vatNumber (optional) 
     * @param userId (optional) 
     * @return Success
     */
    isVatNumberCorrect(vatNumber: string | undefined, userId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/IsVatNumberCorrect?";
        if (vatNumber === null)
            throw new globalThis.Error("The parameter 'vatNumber' cannot be null.");
        else if (vatNumber !== undefined)
            url_ += "vatNumber=" + encodeURIComponent("" + vatNumber) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsVatNumberCorrect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsVatNumberCorrect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsVatNumberCorrect(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param educationOtherKeyword (optional) 
     * @param isActive (optional) 
     * @param operativeUnitId (optional) 
     * @param roleIds (optional) 
     * @param regionId (optional) 
     * @param provinceId (optional) 
     * @param municipalityId (optional) 
     * @param employmentStatusId (optional) 
     * @param partnerId (optional) 
     * @param isForAssociate (optional) 
     * @param operativeUnitNotAssociated (optional) 
     * @param partnerTypeId (optional) 
     * @param creatorUserId (optional) 
     * @param isPaginated (optional) 
     * @param qualificationTypeId (optional) 
     * @param languageId (optional) 
     * @param hasLaw68 (optional) 
     * @param hasAvailabilityToTravel (optional) 
     * @param selectionId (optional) 
     * @param educationalDegreeId (optional) 
     * @param hasApprenticeship (optional) 
     * @param withoutLaborConsultant (optional) 
     * @param jobId (optional) 
     * @param requestTypeId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    downloadPersonsExcel(keyword: string | undefined, educationOtherKeyword: string | undefined, isActive: boolean | undefined, operativeUnitId: number | undefined, roleIds: number[] | undefined, regionId: number | undefined, provinceId: number | undefined, municipalityId: number | undefined, employmentStatusId: number | undefined, partnerId: number | undefined, isForAssociate: boolean | undefined, operativeUnitNotAssociated: number | undefined, partnerTypeId: number | undefined, creatorUserId: number | undefined, isPaginated: boolean | undefined, qualificationTypeId: number | undefined, languageId: number | undefined, hasLaw68: boolean | undefined, hasAvailabilityToTravel: boolean | undefined, selectionId: number | undefined, educationalDegreeId: number | undefined, hasApprenticeship: boolean | undefined, withoutLaborConsultant: boolean | undefined, jobId: number | undefined, requestTypeId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FileExcelDto> {
        let url_ = this.baseUrl + "/api/services/app/User/DownloadPersonsExcel?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (educationOtherKeyword === null)
            throw new globalThis.Error("The parameter 'educationOtherKeyword' cannot be null.");
        else if (educationOtherKeyword !== undefined)
            url_ += "EducationOtherKeyword=" + encodeURIComponent("" + educationOtherKeyword) + "&";
        if (isActive === null)
            throw new globalThis.Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (operativeUnitId === null)
            throw new globalThis.Error("The parameter 'operativeUnitId' cannot be null.");
        else if (operativeUnitId !== undefined)
            url_ += "OperativeUnitId=" + encodeURIComponent("" + operativeUnitId) + "&";
        if (roleIds === null)
            throw new globalThis.Error("The parameter 'roleIds' cannot be null.");
        else if (roleIds !== undefined)
            roleIds && roleIds.forEach(item => { url_ += "RoleIds=" + encodeURIComponent("" + item) + "&"; });
        if (regionId === null)
            throw new globalThis.Error("The parameter 'regionId' cannot be null.");
        else if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&";
        if (provinceId === null)
            throw new globalThis.Error("The parameter 'provinceId' cannot be null.");
        else if (provinceId !== undefined)
            url_ += "ProvinceId=" + encodeURIComponent("" + provinceId) + "&";
        if (municipalityId === null)
            throw new globalThis.Error("The parameter 'municipalityId' cannot be null.");
        else if (municipalityId !== undefined)
            url_ += "MunicipalityId=" + encodeURIComponent("" + municipalityId) + "&";
        if (employmentStatusId === null)
            throw new globalThis.Error("The parameter 'employmentStatusId' cannot be null.");
        else if (employmentStatusId !== undefined)
            url_ += "EmploymentStatusId=" + encodeURIComponent("" + employmentStatusId) + "&";
        if (partnerId === null)
            throw new globalThis.Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined)
            url_ += "PartnerId=" + encodeURIComponent("" + partnerId) + "&";
        if (isForAssociate === null)
            throw new globalThis.Error("The parameter 'isForAssociate' cannot be null.");
        else if (isForAssociate !== undefined)
            url_ += "IsForAssociate=" + encodeURIComponent("" + isForAssociate) + "&";
        if (operativeUnitNotAssociated === null)
            throw new globalThis.Error("The parameter 'operativeUnitNotAssociated' cannot be null.");
        else if (operativeUnitNotAssociated !== undefined)
            url_ += "OperativeUnitNotAssociated=" + encodeURIComponent("" + operativeUnitNotAssociated) + "&";
        if (partnerTypeId === null)
            throw new globalThis.Error("The parameter 'partnerTypeId' cannot be null.");
        else if (partnerTypeId !== undefined)
            url_ += "PartnerTypeId=" + encodeURIComponent("" + partnerTypeId) + "&";
        if (creatorUserId === null)
            throw new globalThis.Error("The parameter 'creatorUserId' cannot be null.");
        else if (creatorUserId !== undefined)
            url_ += "CreatorUserId=" + encodeURIComponent("" + creatorUserId) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (qualificationTypeId === null)
            throw new globalThis.Error("The parameter 'qualificationTypeId' cannot be null.");
        else if (qualificationTypeId !== undefined)
            url_ += "QualificationTypeId=" + encodeURIComponent("" + qualificationTypeId) + "&";
        if (languageId === null)
            throw new globalThis.Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "LanguageId=" + encodeURIComponent("" + languageId) + "&";
        if (hasLaw68 === null)
            throw new globalThis.Error("The parameter 'hasLaw68' cannot be null.");
        else if (hasLaw68 !== undefined)
            url_ += "HasLaw68=" + encodeURIComponent("" + hasLaw68) + "&";
        if (hasAvailabilityToTravel === null)
            throw new globalThis.Error("The parameter 'hasAvailabilityToTravel' cannot be null.");
        else if (hasAvailabilityToTravel !== undefined)
            url_ += "HasAvailabilityToTravel=" + encodeURIComponent("" + hasAvailabilityToTravel) + "&";
        if (selectionId === null)
            throw new globalThis.Error("The parameter 'selectionId' cannot be null.");
        else if (selectionId !== undefined)
            url_ += "SelectionId=" + encodeURIComponent("" + selectionId) + "&";
        if (educationalDegreeId === null)
            throw new globalThis.Error("The parameter 'educationalDegreeId' cannot be null.");
        else if (educationalDegreeId !== undefined)
            url_ += "EducationalDegreeId=" + encodeURIComponent("" + educationalDegreeId) + "&";
        if (hasApprenticeship === null)
            throw new globalThis.Error("The parameter 'hasApprenticeship' cannot be null.");
        else if (hasApprenticeship !== undefined)
            url_ += "HasApprenticeship=" + encodeURIComponent("" + hasApprenticeship) + "&";
        if (withoutLaborConsultant === null)
            throw new globalThis.Error("The parameter 'withoutLaborConsultant' cannot be null.");
        else if (withoutLaborConsultant !== undefined)
            url_ += "WithoutLaborConsultant=" + encodeURIComponent("" + withoutLaborConsultant) + "&";
        if (jobId === null)
            throw new globalThis.Error("The parameter 'jobId' cannot be null.");
        else if (jobId !== undefined)
            url_ += "JobId=" + encodeURIComponent("" + jobId) + "&";
        if (requestTypeId === null)
            throw new globalThis.Error("The parameter 'requestTypeId' cannot be null.");
        else if (requestTypeId !== undefined)
            url_ += "RequestTypeId=" + encodeURIComponent("" + requestTypeId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadPersonsExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadPersonsExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileExcelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileExcelDto>;
        }));
    }

    protected processDownloadPersonsExcel(response: HttpResponseBase): Observable<FileExcelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExcelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param educationOtherKeyword (optional) 
     * @param isActive (optional) 
     * @param operativeUnitId (optional) 
     * @param roleIds (optional) 
     * @param regionId (optional) 
     * @param provinceId (optional) 
     * @param municipalityId (optional) 
     * @param employmentStatusId (optional) 
     * @param partnerId (optional) 
     * @param isForAssociate (optional) 
     * @param operativeUnitNotAssociated (optional) 
     * @param partnerTypeId (optional) 
     * @param creatorUserId (optional) 
     * @param isPaginated (optional) 
     * @param qualificationTypeId (optional) 
     * @param languageId (optional) 
     * @param hasLaw68 (optional) 
     * @param hasAvailabilityToTravel (optional) 
     * @param selectionId (optional) 
     * @param educationalDegreeId (optional) 
     * @param hasApprenticeship (optional) 
     * @param withoutLaborConsultant (optional) 
     * @param jobId (optional) 
     * @param requestTypeId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    downloadPartnersExcel(keyword: string | undefined, educationOtherKeyword: string | undefined, isActive: boolean | undefined, operativeUnitId: number | undefined, roleIds: number[] | undefined, regionId: number | undefined, provinceId: number | undefined, municipalityId: number | undefined, employmentStatusId: number | undefined, partnerId: number | undefined, isForAssociate: boolean | undefined, operativeUnitNotAssociated: number | undefined, partnerTypeId: number | undefined, creatorUserId: number | undefined, isPaginated: boolean | undefined, qualificationTypeId: number | undefined, languageId: number | undefined, hasLaw68: boolean | undefined, hasAvailabilityToTravel: boolean | undefined, selectionId: number | undefined, educationalDegreeId: number | undefined, hasApprenticeship: boolean | undefined, withoutLaborConsultant: boolean | undefined, jobId: number | undefined, requestTypeId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FileExcelDto> {
        let url_ = this.baseUrl + "/api/services/app/User/DownloadPartnersExcel?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (educationOtherKeyword === null)
            throw new globalThis.Error("The parameter 'educationOtherKeyword' cannot be null.");
        else if (educationOtherKeyword !== undefined)
            url_ += "EducationOtherKeyword=" + encodeURIComponent("" + educationOtherKeyword) + "&";
        if (isActive === null)
            throw new globalThis.Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (operativeUnitId === null)
            throw new globalThis.Error("The parameter 'operativeUnitId' cannot be null.");
        else if (operativeUnitId !== undefined)
            url_ += "OperativeUnitId=" + encodeURIComponent("" + operativeUnitId) + "&";
        if (roleIds === null)
            throw new globalThis.Error("The parameter 'roleIds' cannot be null.");
        else if (roleIds !== undefined)
            roleIds && roleIds.forEach(item => { url_ += "RoleIds=" + encodeURIComponent("" + item) + "&"; });
        if (regionId === null)
            throw new globalThis.Error("The parameter 'regionId' cannot be null.");
        else if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&";
        if (provinceId === null)
            throw new globalThis.Error("The parameter 'provinceId' cannot be null.");
        else if (provinceId !== undefined)
            url_ += "ProvinceId=" + encodeURIComponent("" + provinceId) + "&";
        if (municipalityId === null)
            throw new globalThis.Error("The parameter 'municipalityId' cannot be null.");
        else if (municipalityId !== undefined)
            url_ += "MunicipalityId=" + encodeURIComponent("" + municipalityId) + "&";
        if (employmentStatusId === null)
            throw new globalThis.Error("The parameter 'employmentStatusId' cannot be null.");
        else if (employmentStatusId !== undefined)
            url_ += "EmploymentStatusId=" + encodeURIComponent("" + employmentStatusId) + "&";
        if (partnerId === null)
            throw new globalThis.Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined)
            url_ += "PartnerId=" + encodeURIComponent("" + partnerId) + "&";
        if (isForAssociate === null)
            throw new globalThis.Error("The parameter 'isForAssociate' cannot be null.");
        else if (isForAssociate !== undefined)
            url_ += "IsForAssociate=" + encodeURIComponent("" + isForAssociate) + "&";
        if (operativeUnitNotAssociated === null)
            throw new globalThis.Error("The parameter 'operativeUnitNotAssociated' cannot be null.");
        else if (operativeUnitNotAssociated !== undefined)
            url_ += "OperativeUnitNotAssociated=" + encodeURIComponent("" + operativeUnitNotAssociated) + "&";
        if (partnerTypeId === null)
            throw new globalThis.Error("The parameter 'partnerTypeId' cannot be null.");
        else if (partnerTypeId !== undefined)
            url_ += "PartnerTypeId=" + encodeURIComponent("" + partnerTypeId) + "&";
        if (creatorUserId === null)
            throw new globalThis.Error("The parameter 'creatorUserId' cannot be null.");
        else if (creatorUserId !== undefined)
            url_ += "CreatorUserId=" + encodeURIComponent("" + creatorUserId) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (qualificationTypeId === null)
            throw new globalThis.Error("The parameter 'qualificationTypeId' cannot be null.");
        else if (qualificationTypeId !== undefined)
            url_ += "QualificationTypeId=" + encodeURIComponent("" + qualificationTypeId) + "&";
        if (languageId === null)
            throw new globalThis.Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "LanguageId=" + encodeURIComponent("" + languageId) + "&";
        if (hasLaw68 === null)
            throw new globalThis.Error("The parameter 'hasLaw68' cannot be null.");
        else if (hasLaw68 !== undefined)
            url_ += "HasLaw68=" + encodeURIComponent("" + hasLaw68) + "&";
        if (hasAvailabilityToTravel === null)
            throw new globalThis.Error("The parameter 'hasAvailabilityToTravel' cannot be null.");
        else if (hasAvailabilityToTravel !== undefined)
            url_ += "HasAvailabilityToTravel=" + encodeURIComponent("" + hasAvailabilityToTravel) + "&";
        if (selectionId === null)
            throw new globalThis.Error("The parameter 'selectionId' cannot be null.");
        else if (selectionId !== undefined)
            url_ += "SelectionId=" + encodeURIComponent("" + selectionId) + "&";
        if (educationalDegreeId === null)
            throw new globalThis.Error("The parameter 'educationalDegreeId' cannot be null.");
        else if (educationalDegreeId !== undefined)
            url_ += "EducationalDegreeId=" + encodeURIComponent("" + educationalDegreeId) + "&";
        if (hasApprenticeship === null)
            throw new globalThis.Error("The parameter 'hasApprenticeship' cannot be null.");
        else if (hasApprenticeship !== undefined)
            url_ += "HasApprenticeship=" + encodeURIComponent("" + hasApprenticeship) + "&";
        if (withoutLaborConsultant === null)
            throw new globalThis.Error("The parameter 'withoutLaborConsultant' cannot be null.");
        else if (withoutLaborConsultant !== undefined)
            url_ += "WithoutLaborConsultant=" + encodeURIComponent("" + withoutLaborConsultant) + "&";
        if (jobId === null)
            throw new globalThis.Error("The parameter 'jobId' cannot be null.");
        else if (jobId !== undefined)
            url_ += "JobId=" + encodeURIComponent("" + jobId) + "&";
        if (requestTypeId === null)
            throw new globalThis.Error("The parameter 'requestTypeId' cannot be null.");
        else if (requestTypeId !== undefined)
            url_ += "RequestTypeId=" + encodeURIComponent("" + requestTypeId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadPartnersExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadPartnersExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileExcelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileExcelDto>;
        }));
    }

    protected processDownloadPartnersExcel(response: HttpResponseBase): Observable<FileExcelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExcelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param body (optional) 
     * @return Success
     */
    applyForSelections(userId: number | undefined, body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ApplyForSelections?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApplyForSelections(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApplyForSelections(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApplyForSelections(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param educationOtherKeyword (optional) 
     * @param isActive (optional) 
     * @param operativeUnitId (optional) 
     * @param roleIds (optional) 
     * @param regionId (optional) 
     * @param provinceId (optional) 
     * @param municipalityId (optional) 
     * @param employmentStatusId (optional) 
     * @param partnerId (optional) 
     * @param isForAssociate (optional) 
     * @param operativeUnitNotAssociated (optional) 
     * @param partnerTypeId (optional) 
     * @param creatorUserId (optional) 
     * @param isPaginated (optional) 
     * @param qualificationTypeId (optional) 
     * @param languageId (optional) 
     * @param hasLaw68 (optional) 
     * @param hasAvailabilityToTravel (optional) 
     * @param selectionId (optional) 
     * @param educationalDegreeId (optional) 
     * @param hasApprenticeship (optional) 
     * @param withoutLaborConsultant (optional) 
     * @param jobId (optional) 
     * @param requestTypeId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllUsersForMatching(keyword: string | undefined, educationOtherKeyword: string | undefined, isActive: boolean | undefined, operativeUnitId: number | undefined, roleIds: number[] | undefined, regionId: number | undefined, provinceId: number | undefined, municipalityId: number | undefined, employmentStatusId: number | undefined, partnerId: number | undefined, isForAssociate: boolean | undefined, operativeUnitNotAssociated: number | undefined, partnerTypeId: number | undefined, creatorUserId: number | undefined, isPaginated: boolean | undefined, qualificationTypeId: number | undefined, languageId: number | undefined, hasLaw68: boolean | undefined, hasAvailabilityToTravel: boolean | undefined, selectionId: number | undefined, educationalDegreeId: number | undefined, hasApprenticeship: boolean | undefined, withoutLaborConsultant: boolean | undefined, jobId: number | undefined, requestTypeId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAllUsersForMatching?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (educationOtherKeyword === null)
            throw new globalThis.Error("The parameter 'educationOtherKeyword' cannot be null.");
        else if (educationOtherKeyword !== undefined)
            url_ += "EducationOtherKeyword=" + encodeURIComponent("" + educationOtherKeyword) + "&";
        if (isActive === null)
            throw new globalThis.Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (operativeUnitId === null)
            throw new globalThis.Error("The parameter 'operativeUnitId' cannot be null.");
        else if (operativeUnitId !== undefined)
            url_ += "OperativeUnitId=" + encodeURIComponent("" + operativeUnitId) + "&";
        if (roleIds === null)
            throw new globalThis.Error("The parameter 'roleIds' cannot be null.");
        else if (roleIds !== undefined)
            roleIds && roleIds.forEach(item => { url_ += "RoleIds=" + encodeURIComponent("" + item) + "&"; });
        if (regionId === null)
            throw new globalThis.Error("The parameter 'regionId' cannot be null.");
        else if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&";
        if (provinceId === null)
            throw new globalThis.Error("The parameter 'provinceId' cannot be null.");
        else if (provinceId !== undefined)
            url_ += "ProvinceId=" + encodeURIComponent("" + provinceId) + "&";
        if (municipalityId === null)
            throw new globalThis.Error("The parameter 'municipalityId' cannot be null.");
        else if (municipalityId !== undefined)
            url_ += "MunicipalityId=" + encodeURIComponent("" + municipalityId) + "&";
        if (employmentStatusId === null)
            throw new globalThis.Error("The parameter 'employmentStatusId' cannot be null.");
        else if (employmentStatusId !== undefined)
            url_ += "EmploymentStatusId=" + encodeURIComponent("" + employmentStatusId) + "&";
        if (partnerId === null)
            throw new globalThis.Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined)
            url_ += "PartnerId=" + encodeURIComponent("" + partnerId) + "&";
        if (isForAssociate === null)
            throw new globalThis.Error("The parameter 'isForAssociate' cannot be null.");
        else if (isForAssociate !== undefined)
            url_ += "IsForAssociate=" + encodeURIComponent("" + isForAssociate) + "&";
        if (operativeUnitNotAssociated === null)
            throw new globalThis.Error("The parameter 'operativeUnitNotAssociated' cannot be null.");
        else if (operativeUnitNotAssociated !== undefined)
            url_ += "OperativeUnitNotAssociated=" + encodeURIComponent("" + operativeUnitNotAssociated) + "&";
        if (partnerTypeId === null)
            throw new globalThis.Error("The parameter 'partnerTypeId' cannot be null.");
        else if (partnerTypeId !== undefined)
            url_ += "PartnerTypeId=" + encodeURIComponent("" + partnerTypeId) + "&";
        if (creatorUserId === null)
            throw new globalThis.Error("The parameter 'creatorUserId' cannot be null.");
        else if (creatorUserId !== undefined)
            url_ += "CreatorUserId=" + encodeURIComponent("" + creatorUserId) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (qualificationTypeId === null)
            throw new globalThis.Error("The parameter 'qualificationTypeId' cannot be null.");
        else if (qualificationTypeId !== undefined)
            url_ += "QualificationTypeId=" + encodeURIComponent("" + qualificationTypeId) + "&";
        if (languageId === null)
            throw new globalThis.Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "LanguageId=" + encodeURIComponent("" + languageId) + "&";
        if (hasLaw68 === null)
            throw new globalThis.Error("The parameter 'hasLaw68' cannot be null.");
        else if (hasLaw68 !== undefined)
            url_ += "HasLaw68=" + encodeURIComponent("" + hasLaw68) + "&";
        if (hasAvailabilityToTravel === null)
            throw new globalThis.Error("The parameter 'hasAvailabilityToTravel' cannot be null.");
        else if (hasAvailabilityToTravel !== undefined)
            url_ += "HasAvailabilityToTravel=" + encodeURIComponent("" + hasAvailabilityToTravel) + "&";
        if (selectionId === null)
            throw new globalThis.Error("The parameter 'selectionId' cannot be null.");
        else if (selectionId !== undefined)
            url_ += "SelectionId=" + encodeURIComponent("" + selectionId) + "&";
        if (educationalDegreeId === null)
            throw new globalThis.Error("The parameter 'educationalDegreeId' cannot be null.");
        else if (educationalDegreeId !== undefined)
            url_ += "EducationalDegreeId=" + encodeURIComponent("" + educationalDegreeId) + "&";
        if (hasApprenticeship === null)
            throw new globalThis.Error("The parameter 'hasApprenticeship' cannot be null.");
        else if (hasApprenticeship !== undefined)
            url_ += "HasApprenticeship=" + encodeURIComponent("" + hasApprenticeship) + "&";
        if (withoutLaborConsultant === null)
            throw new globalThis.Error("The parameter 'withoutLaborConsultant' cannot be null.");
        else if (withoutLaborConsultant !== undefined)
            url_ += "WithoutLaborConsultant=" + encodeURIComponent("" + withoutLaborConsultant) + "&";
        if (jobId === null)
            throw new globalThis.Error("The parameter 'jobId' cannot be null.");
        else if (jobId !== undefined)
            url_ += "JobId=" + encodeURIComponent("" + jobId) + "&";
        if (requestTypeId === null)
            throw new globalThis.Error("The parameter 'requestTypeId' cannot be null.");
        else if (requestTypeId !== undefined)
            url_ += "RequestTypeId=" + encodeURIComponent("" + requestTypeId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUsersForMatching(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUsersForMatching(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDtoPagedResultDto>;
        }));
    }

    protected processGetAllUsersForMatching(response: HttpResponseBase): Observable<UserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserCertificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateUserCertificationDto | undefined): Observable<UserCertificationDto> {
        let url_ = this.baseUrl + "/api/services/app/UserCertification/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserCertificationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserCertificationDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserCertificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserCertificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUserCertificationDto | undefined): Observable<UserCertificationDto> {
        let url_ = this.baseUrl + "/api/services/app/UserCertification/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserCertificationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserCertificationDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserCertificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserCertificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserCertification/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserCertificationDto> {
        let url_ = this.baseUrl + "/api/services/app/UserCertification/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserCertificationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserCertificationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserCertificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserCertificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(userId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserCertificationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/UserCertification/GetAll?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserCertificationDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserCertificationDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserCertificationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserCertificationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserComputerSkillsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateUserComputerSkillDto | undefined): Observable<UserComputerSkillDto> {
        let url_ = this.baseUrl + "/api/services/app/UserComputerSkills/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserComputerSkillDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserComputerSkillDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserComputerSkillDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserComputerSkillDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUserComputerSkillDto | undefined): Observable<UserComputerSkillDto> {
        let url_ = this.baseUrl + "/api/services/app/UserComputerSkills/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserComputerSkillDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserComputerSkillDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserComputerSkillDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserComputerSkillDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserComputerSkills/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserComputerSkillDto> {
        let url_ = this.baseUrl + "/api/services/app/UserComputerSkills/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserComputerSkillDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserComputerSkillDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserComputerSkillDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserComputerSkillDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(userId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserComputerSkillDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/UserComputerSkills/GetAll?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserComputerSkillDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserComputerSkillDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserComputerSkillDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserComputerSkillDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserDisabilityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateUserDisabilityDto | undefined): Observable<UserDisabilityDto> {
        let url_ = this.baseUrl + "/api/services/app/UserDisability/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDisabilityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDisabilityDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserDisabilityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDisabilityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUserDisabilityDto | undefined): Observable<UserDisabilityDto> {
        let url_ = this.baseUrl + "/api/services/app/UserDisability/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDisabilityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDisabilityDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserDisabilityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDisabilityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserDisability/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserDisabilityDto> {
        let url_ = this.baseUrl + "/api/services/app/UserDisability/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDisabilityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDisabilityDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserDisabilityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDisabilityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(userId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserDisabilityDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/UserDisability/GetAll?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDisabilityDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDisabilityDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserDisabilityDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDisabilityDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserEducationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateUserEducationDto | undefined): Observable<UserEducationDto> {
        let url_ = this.baseUrl + "/api/services/app/UserEducation/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserEducationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserEducationDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserEducationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserEducationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUserEducationDto | undefined): Observable<UserEducationDto> {
        let url_ = this.baseUrl + "/api/services/app/UserEducation/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserEducationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserEducationDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserEducationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserEducationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserEducation/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserEducationDto> {
        let url_ = this.baseUrl + "/api/services/app/UserEducation/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserEducationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserEducationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserEducationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserEducationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(userId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserEducationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/UserEducation/GetAll?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserEducationDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserEducationDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserEducationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserEducationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserJobServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateUserJobDto | undefined): Observable<UserJobDto> {
        let url_ = this.baseUrl + "/api/services/app/UserJob/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserJobDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserJobDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserJobDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserJobDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUserJobDto | undefined): Observable<UserJobDto> {
        let url_ = this.baseUrl + "/api/services/app/UserJob/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserJobDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserJobDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserJobDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserJobDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserJob/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserJobDto> {
        let url_ = this.baseUrl + "/api/services/app/UserJob/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserJobDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserJobDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserJobDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserJobDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(userId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserJobDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/UserJob/GetAll?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserJobDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserJobDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserJobDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserJobDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserLanguagesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateUserLanguageDto | undefined): Observable<UserLanguageDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLanguages/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserLanguageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserLanguageDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserLanguageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserLanguageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUserLanguageDto | undefined): Observable<UserLanguageDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLanguages/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserLanguageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserLanguageDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserLanguageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserLanguageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserLanguages/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserLanguageDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLanguages/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserLanguageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserLanguageDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserLanguageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserLanguageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(userId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserLanguageDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLanguages/GetAll?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserLanguageDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserLanguageDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserLanguageDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserLanguageDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserNoteServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateUserNoteDto | undefined): Observable<UserNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/UserNote/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserNoteDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserNoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUserNoteDto | undefined): Observable<UserNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/UserNote/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserNoteDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserNoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserNote/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/UserNote/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserNoteDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserNoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(userId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserNoteDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/UserNote/GetAll?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserNoteDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserNoteDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserNoteDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserNoteDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserQualificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateUserQualificationDto | undefined): Observable<UserQualificationDto> {
        let url_ = this.baseUrl + "/api/services/app/UserQualification/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserQualificationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserQualificationDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserQualificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserQualificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUserQualificationDto | undefined): Observable<UserQualificationDto> {
        let url_ = this.baseUrl + "/api/services/app/UserQualification/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserQualificationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserQualificationDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserQualificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserQualificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserQualification/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserQualificationDto> {
        let url_ = this.baseUrl + "/api/services/app/UserQualification/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserQualificationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserQualificationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserQualificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserQualificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(userId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserQualificationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/UserQualification/GetAll?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserQualificationDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserQualificationDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserQualificationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserQualificationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserSafetyTrainingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateUserSafetyTrainingDto | undefined): Observable<UserSafetyTrainingDto> {
        let url_ = this.baseUrl + "/api/services/app/UserSafetyTraining/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSafetyTrainingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSafetyTrainingDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserSafetyTrainingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSafetyTrainingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUserSafetyTrainingDto | undefined): Observable<UserSafetyTrainingDto> {
        let url_ = this.baseUrl + "/api/services/app/UserSafetyTraining/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSafetyTrainingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSafetyTrainingDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserSafetyTrainingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSafetyTrainingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserSafetyTraining/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserSafetyTrainingDto> {
        let url_ = this.baseUrl + "/api/services/app/UserSafetyTraining/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSafetyTrainingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSafetyTrainingDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserSafetyTrainingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSafetyTrainingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(userId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserSafetyTrainingDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/UserSafetyTraining/GetAll?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSafetyTrainingDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSafetyTrainingDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserSafetyTrainingDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSafetyTrainingDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserSurveyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getByUserId(userId: number | undefined): Observable<UserSurveyDto> {
        let url_ = this.baseUrl + "/api/services/app/UserSurvey/GetByUserId?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSurveyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSurveyDto>;
        }));
    }

    protected processGetByUserId(response: HttpResponseBase): Observable<UserSurveyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSurveyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateUserSurveyDto | undefined): Observable<UserSurveyDto> {
        let url_ = this.baseUrl + "/api/services/app/UserSurvey/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSurveyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSurveyDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserSurveyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSurveyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUserSurveyDto | undefined): Observable<UserSurveyDto> {
        let url_ = this.baseUrl + "/api/services/app/UserSurvey/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSurveyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSurveyDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserSurveyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSurveyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserSurvey/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserSurveyDto> {
        let url_ = this.baseUrl + "/api/services/app/UserSurvey/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSurveyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSurveyDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserSurveyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSurveyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserSurveyDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/UserSurvey/GetAll?";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSurveyDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSurveyDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserSurveyDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSurveyDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserTrainingCourseServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateUserTrainingCourseDto | undefined): Observable<UserTrainingCourseDto> {
        let url_ = this.baseUrl + "/api/services/app/UserTrainingCourse/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserTrainingCourseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserTrainingCourseDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserTrainingCourseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserTrainingCourseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUserTrainingCourseDto | undefined): Observable<UserTrainingCourseDto> {
        let url_ = this.baseUrl + "/api/services/app/UserTrainingCourse/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserTrainingCourseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserTrainingCourseDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserTrainingCourseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserTrainingCourseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserTrainingCourse/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserTrainingCourseDto> {
        let url_ = this.baseUrl + "/api/services/app/UserTrainingCourse/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserTrainingCourseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserTrainingCourseDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserTrainingCourseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserTrainingCourseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(userId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserTrainingCourseDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/UserTrainingCourse/GetAll?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserTrainingCourseDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserTrainingCourseDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserTrainingCourseDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserTrainingCourseDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserTrainingCourseInterestServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateUserTrainingCourseInterestDto | undefined): Observable<UserTrainingCourseInterestDto> {
        let url_ = this.baseUrl + "/api/services/app/UserTrainingCourseInterest/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserTrainingCourseInterestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserTrainingCourseInterestDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserTrainingCourseInterestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserTrainingCourseInterestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUserTrainingCourseInterestDto | undefined): Observable<UserTrainingCourseInterestDto> {
        let url_ = this.baseUrl + "/api/services/app/UserTrainingCourseInterest/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserTrainingCourseInterestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserTrainingCourseInterestDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserTrainingCourseInterestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserTrainingCourseInterestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserTrainingCourseInterest/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserTrainingCourseInterestDto> {
        let url_ = this.baseUrl + "/api/services/app/UserTrainingCourseInterest/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserTrainingCourseInterestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserTrainingCourseInterestDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserTrainingCourseInterestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserTrainingCourseInterestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(userId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserTrainingCourseInterestDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/UserTrainingCourseInterest/GetAll?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserTrainingCourseInterestDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserTrainingCourseInterestDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserTrainingCourseInterestDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserTrainingCourseInterestDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserTrainingCourseInterestOperativeUnitServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateUserTrainingCourseInterestOperativeUnitDto | undefined): Observable<UserTrainingCourseInterestOperativeUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/UserTrainingCourseInterestOperativeUnit/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserTrainingCourseInterestOperativeUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserTrainingCourseInterestOperativeUnitDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserTrainingCourseInterestOperativeUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserTrainingCourseInterestOperativeUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUserTrainingCourseInterestOperativeUnitDto | undefined): Observable<UserTrainingCourseInterestOperativeUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/UserTrainingCourseInterestOperativeUnit/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserTrainingCourseInterestOperativeUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserTrainingCourseInterestOperativeUnitDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserTrainingCourseInterestOperativeUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserTrainingCourseInterestOperativeUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserTrainingCourseInterestOperativeUnit/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserTrainingCourseInterestOperativeUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/UserTrainingCourseInterestOperativeUnit/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserTrainingCourseInterestOperativeUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserTrainingCourseInterestOperativeUnitDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserTrainingCourseInterestOperativeUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserTrainingCourseInterestOperativeUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserTrainingCourseInterestOperativeUnitDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/UserTrainingCourseInterestOperativeUnit/GetAll?";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserTrainingCourseInterestOperativeUnitDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserTrainingCourseInterestOperativeUnitDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserTrainingCourseInterestOperativeUnitDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserTrainingCourseInterestOperativeUnitDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserTransversalSkillServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateUserTransversalSkillDto | undefined): Observable<UserTransversalSkillDto> {
        let url_ = this.baseUrl + "/api/services/app/UserTransversalSkill/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserTransversalSkillDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserTransversalSkillDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserTransversalSkillDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserTransversalSkillDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUserTransversalSkillDto | undefined): Observable<UserTransversalSkillDto> {
        let url_ = this.baseUrl + "/api/services/app/UserTransversalSkill/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserTransversalSkillDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserTransversalSkillDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserTransversalSkillDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserTransversalSkillDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserTransversalSkill/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserTransversalSkillDto> {
        let url_ = this.baseUrl + "/api/services/app/UserTransversalSkill/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserTransversalSkillDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserTransversalSkillDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserTransversalSkillDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserTransversalSkillDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(userId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserTransversalSkillDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/UserTransversalSkill/GetAll?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserTransversalSkillDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserTransversalSkillDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserTransversalSkillDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserTransversalSkillDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WorkModeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/WorkMode/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AddressDto implements IAddressDto {
    id!: number;
    name!: string | undefined;
    postalCode!: string | undefined;
    description!: string | undefined;
    isMain!: boolean;
    municipality!: MunicipalityDto;

    constructor(data?: IAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.postalCode = _data["postalCode"];
            this.description = _data["description"];
            this.isMain = _data["isMain"];
            this.municipality = _data["municipality"] ? MunicipalityDto.fromJS(_data["municipality"]) : undefined as any;
        }
    }

    static fromJS(data: any): AddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["postalCode"] = this.postalCode;
        data["description"] = this.description;
        data["isMain"] = this.isMain;
        data["municipality"] = this.municipality ? this.municipality.toJSON() : undefined as any;
        return data;
    }

    clone(): AddressDto {
        const json = this.toJSON();
        let result = new AddressDto();
        result.init(json);
        return result;
    }
}

export interface IAddressDto {
    id: number;
    name: string | undefined;
    postalCode: string | undefined;
    description: string | undefined;
    isMain: boolean;
    municipality: MunicipalityDto;
}

export class AgencyServiceOperativeUnitDto implements IAgencyServiceOperativeUnitDto {
    id!: number;
    operativeUnit!: OperativeUnitDto;

    constructor(data?: IAgencyServiceOperativeUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.operativeUnit = _data["operativeUnit"] ? OperativeUnitDto.fromJS(_data["operativeUnit"]) : undefined as any;
        }
    }

    static fromJS(data: any): AgencyServiceOperativeUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyServiceOperativeUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["operativeUnit"] = this.operativeUnit ? this.operativeUnit.toJSON() : undefined as any;
        return data;
    }

    clone(): AgencyServiceOperativeUnitDto {
        const json = this.toJSON();
        let result = new AgencyServiceOperativeUnitDto();
        result.init(json);
        return result;
    }
}

export interface IAgencyServiceOperativeUnitDto {
    id: number;
    operativeUnit: OperativeUnitDto;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version!: string | undefined;
    releaseDate!: moment.Moment;
    features!: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.releaseDate = _data["releaseDate"] ? moment(_data["releaseDate"].toString()) : undefined as any;
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        (this.features as any)![key] = _data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : undefined as any;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    (data["features"] as any)[key] = (this.features as any)[key];
            }
        }
        return data;
    }

    clone(): ApplicationInfoDto {
        const json = this.toJSON();
        let result = new ApplicationInfoDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean; } | undefined;
}

export class ApprenticeshipAdditionalDataDto implements IApprenticeshipAdditionalDataDto {
    id!: number;
    paymentData!: moment.Moment | undefined;
    operator!: string | undefined;
    tutorORSo!: string | undefined;
    company!: string | undefined;
    companyName!: string | undefined;
    address!: string | undefined;
    cap!: string | undefined;
    city!: string | undefined;
    piva!: string | undefined;
    cfCompany!: string | undefined;
    cfLegalRepresentative!: string | undefined;
    telematicIdentificationAddress!: string | undefined;
    mail!: string | undefined;
    intern!: string | undefined;
    economicValueWithoutVAT22!: number | undefined;

    constructor(data?: IApprenticeshipAdditionalDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.paymentData = _data["paymentData"] ? moment(_data["paymentData"].toString()) : undefined as any;
            this.operator = _data["operator"];
            this.tutorORSo = _data["tutorORSo"];
            this.company = _data["company"];
            this.companyName = _data["companyName"];
            this.address = _data["address"];
            this.cap = _data["cap"];
            this.city = _data["city"];
            this.piva = _data["piva"];
            this.cfCompany = _data["cfCompany"];
            this.cfLegalRepresentative = _data["cfLegalRepresentative"];
            this.telematicIdentificationAddress = _data["telematicIdentificationAddress"];
            this.mail = _data["mail"];
            this.intern = _data["intern"];
            this.economicValueWithoutVAT22 = _data["economicValueWithoutVAT22"];
        }
    }

    static fromJS(data: any): ApprenticeshipAdditionalDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApprenticeshipAdditionalDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["paymentData"] = this.paymentData ? this.paymentData.toISOString() : undefined as any;
        data["operator"] = this.operator;
        data["tutorORSo"] = this.tutorORSo;
        data["company"] = this.company;
        data["companyName"] = this.companyName;
        data["address"] = this.address;
        data["cap"] = this.cap;
        data["city"] = this.city;
        data["piva"] = this.piva;
        data["cfCompany"] = this.cfCompany;
        data["cfLegalRepresentative"] = this.cfLegalRepresentative;
        data["telematicIdentificationAddress"] = this.telematicIdentificationAddress;
        data["mail"] = this.mail;
        data["intern"] = this.intern;
        data["economicValueWithoutVAT22"] = this.economicValueWithoutVAT22;
        return data;
    }

    clone(): ApprenticeshipAdditionalDataDto {
        const json = this.toJSON();
        let result = new ApprenticeshipAdditionalDataDto();
        result.init(json);
        return result;
    }
}

export interface IApprenticeshipAdditionalDataDto {
    id: number;
    paymentData: moment.Moment | undefined;
    operator: string | undefined;
    tutorORSo: string | undefined;
    company: string | undefined;
    companyName: string | undefined;
    address: string | undefined;
    cap: string | undefined;
    city: string | undefined;
    piva: string | undefined;
    cfCompany: string | undefined;
    cfLegalRepresentative: string | undefined;
    telematicIdentificationAddress: string | undefined;
    mail: string | undefined;
    intern: string | undefined;
    economicValueWithoutVAT22: number | undefined;
}

export class ApprenticeshipDocumentItemDto implements IApprenticeshipDocumentItemDto {
    fileId!: number;
    documentType!: string | undefined;
    uploadDate!: moment.Moment;
    fileName!: string | undefined;

    constructor(data?: IApprenticeshipDocumentItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.documentType = _data["documentType"];
            this.uploadDate = _data["uploadDate"] ? moment(_data["uploadDate"].toString()) : undefined as any;
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): ApprenticeshipDocumentItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApprenticeshipDocumentItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["documentType"] = this.documentType;
        data["uploadDate"] = this.uploadDate ? this.uploadDate.toISOString() : undefined as any;
        data["fileName"] = this.fileName;
        return data;
    }

    clone(): ApprenticeshipDocumentItemDto {
        const json = this.toJSON();
        let result = new ApprenticeshipDocumentItemDto();
        result.init(json);
        return result;
    }
}

export interface IApprenticeshipDocumentItemDto {
    fileId: number;
    documentType: string | undefined;
    uploadDate: moment.Moment;
    fileName: string | undefined;
}

export class ApprenticeshipDto implements IApprenticeshipDto {
    id!: number;
    reference!: string | undefined;
    selection!: SelectionDto;
    person!: UserItemDto;
    partner!: UserItemDto;
    lastModifierUserName!: string | undefined;
    state!: DictionaryDto;
    identificationCode!: string | undefined;
    dgr!: DictionaryDto;
    internIBAN!: string | undefined;
    tutorORSo!: UserDto;
    externalTutor!: string | undefined;
    closedDateTime!: moment.Moment | undefined;
    startDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    startSuspensionDate!: moment.Moment | undefined;
    endSuspensionDate!: moment.Moment | undefined;
    interruptionFrom!: moment.Moment | undefined;
    isPrivate!: boolean;
    isPaidService!: boolean;
    invoice!: string | undefined;
    compensationPaidByOrso!: boolean;
    compensationIban!: string | undefined;
    apprenticeshipAdditionalData!: ApprenticeshipAdditionalDataDto;
    apprenticeshipDocument!: ApprenticeshipDocumentItemDto[] | undefined;

    constructor(data?: IApprenticeshipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reference = _data["reference"];
            this.selection = _data["selection"] ? SelectionDto.fromJS(_data["selection"]) : undefined as any;
            this.person = _data["person"] ? UserItemDto.fromJS(_data["person"]) : undefined as any;
            this.partner = _data["partner"] ? UserItemDto.fromJS(_data["partner"]) : undefined as any;
            this.lastModifierUserName = _data["lastModifierUserName"];
            this.state = _data["state"] ? DictionaryDto.fromJS(_data["state"]) : undefined as any;
            this.identificationCode = _data["identificationCode"];
            this.dgr = _data["dgr"] ? DictionaryDto.fromJS(_data["dgr"]) : undefined as any;
            this.internIBAN = _data["internIBAN"];
            this.tutorORSo = _data["tutorORSo"] ? UserDto.fromJS(_data["tutorORSo"]) : undefined as any;
            this.externalTutor = _data["externalTutor"];
            this.closedDateTime = _data["closedDateTime"] ? moment(_data["closedDateTime"].toString()) : undefined as any;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : undefined as any;
            this.startSuspensionDate = _data["startSuspensionDate"] ? moment(_data["startSuspensionDate"].toString()) : undefined as any;
            this.endSuspensionDate = _data["endSuspensionDate"] ? moment(_data["endSuspensionDate"].toString()) : undefined as any;
            this.interruptionFrom = _data["interruptionFrom"] ? moment(_data["interruptionFrom"].toString()) : undefined as any;
            this.isPrivate = _data["isPrivate"];
            this.isPaidService = _data["isPaidService"];
            this.invoice = _data["invoice"];
            this.compensationPaidByOrso = _data["compensationPaidByOrso"];
            this.compensationIban = _data["compensationIban"];
            this.apprenticeshipAdditionalData = _data["apprenticeshipAdditionalData"] ? ApprenticeshipAdditionalDataDto.fromJS(_data["apprenticeshipAdditionalData"]) : undefined as any;
            if (Array.isArray(_data["apprenticeshipDocument"])) {
                this.apprenticeshipDocument = [] as any;
                for (let item of _data["apprenticeshipDocument"])
                    this.apprenticeshipDocument!.push(ApprenticeshipDocumentItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApprenticeshipDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApprenticeshipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reference"] = this.reference;
        data["selection"] = this.selection ? this.selection.toJSON() : undefined as any;
        data["person"] = this.person ? this.person.toJSON() : undefined as any;
        data["partner"] = this.partner ? this.partner.toJSON() : undefined as any;
        data["lastModifierUserName"] = this.lastModifierUserName;
        data["state"] = this.state ? this.state.toJSON() : undefined as any;
        data["identificationCode"] = this.identificationCode;
        data["dgr"] = this.dgr ? this.dgr.toJSON() : undefined as any;
        data["internIBAN"] = this.internIBAN;
        data["tutorORSo"] = this.tutorORSo ? this.tutorORSo.toJSON() : undefined as any;
        data["externalTutor"] = this.externalTutor;
        data["closedDateTime"] = this.closedDateTime ? this.closedDateTime.toISOString() : undefined as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["startSuspensionDate"] = this.startSuspensionDate ? this.startSuspensionDate.toISOString() : undefined as any;
        data["endSuspensionDate"] = this.endSuspensionDate ? this.endSuspensionDate.toISOString() : undefined as any;
        data["interruptionFrom"] = this.interruptionFrom ? this.interruptionFrom.toISOString() : undefined as any;
        data["isPrivate"] = this.isPrivate;
        data["isPaidService"] = this.isPaidService;
        data["invoice"] = this.invoice;
        data["compensationPaidByOrso"] = this.compensationPaidByOrso;
        data["compensationIban"] = this.compensationIban;
        data["apprenticeshipAdditionalData"] = this.apprenticeshipAdditionalData ? this.apprenticeshipAdditionalData.toJSON() : undefined as any;
        if (Array.isArray(this.apprenticeshipDocument)) {
            data["apprenticeshipDocument"] = [];
            for (let item of this.apprenticeshipDocument)
                data["apprenticeshipDocument"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ApprenticeshipDto {
        const json = this.toJSON();
        let result = new ApprenticeshipDto();
        result.init(json);
        return result;
    }
}

export interface IApprenticeshipDto {
    id: number;
    reference: string | undefined;
    selection: SelectionDto;
    person: UserItemDto;
    partner: UserItemDto;
    lastModifierUserName: string | undefined;
    state: DictionaryDto;
    identificationCode: string | undefined;
    dgr: DictionaryDto;
    internIBAN: string | undefined;
    tutorORSo: UserDto;
    externalTutor: string | undefined;
    closedDateTime: moment.Moment | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    startSuspensionDate: moment.Moment | undefined;
    endSuspensionDate: moment.Moment | undefined;
    interruptionFrom: moment.Moment | undefined;
    isPrivate: boolean;
    isPaidService: boolean;
    invoice: string | undefined;
    compensationPaidByOrso: boolean;
    compensationIban: string | undefined;
    apprenticeshipAdditionalData: ApprenticeshipAdditionalDataDto;
    apprenticeshipDocument: ApprenticeshipDocumentItemDto[] | undefined;
}

export class ApprenticeshipDtoPagedResultDto implements IApprenticeshipDtoPagedResultDto {
    items!: ApprenticeshipDto[] | undefined;
    totalCount!: number;

    constructor(data?: IApprenticeshipDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApprenticeshipDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ApprenticeshipDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApprenticeshipDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ApprenticeshipDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ApprenticeshipDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IApprenticeshipDtoPagedResultDto {
    items: ApprenticeshipDto[] | undefined;
    totalCount: number;
}

export class ApprenticeshipExtensionDto implements IApprenticeshipExtensionDto {
    id!: number;
    startDateTime!: moment.Moment | undefined;
    endDateTime!: moment.Moment | undefined;

    constructor(data?: IApprenticeshipExtensionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startDateTime = _data["startDateTime"] ? moment(_data["startDateTime"].toString()) : undefined as any;
            this.endDateTime = _data["endDateTime"] ? moment(_data["endDateTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ApprenticeshipExtensionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApprenticeshipExtensionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : undefined as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : undefined as any;
        return data;
    }

    clone(): ApprenticeshipExtensionDto {
        const json = this.toJSON();
        let result = new ApprenticeshipExtensionDto();
        result.init(json);
        return result;
    }
}

export interface IApprenticeshipExtensionDto {
    id: number;
    startDateTime: moment.Moment | undefined;
    endDateTime: moment.Moment | undefined;
}

export class ApprenticeshipExtensionDtoPagedResultDto implements IApprenticeshipExtensionDtoPagedResultDto {
    items!: ApprenticeshipExtensionDto[] | undefined;
    totalCount!: number;

    constructor(data?: IApprenticeshipExtensionDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApprenticeshipExtensionDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ApprenticeshipExtensionDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApprenticeshipExtensionDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ApprenticeshipExtensionDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ApprenticeshipExtensionDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IApprenticeshipExtensionDtoPagedResultDto {
    items: ApprenticeshipExtensionDto[] | undefined;
    totalCount: number;
}

export class ApprenticeshipOrderCodeDto implements IApprenticeshipOrderCodeDto {
    apprenticeshipId!: number;
    selectionTitle!: string | undefined;
    internName!: string | undefined;
    orderCodes!: DictionaryDto[] | undefined;

    constructor(data?: IApprenticeshipOrderCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apprenticeshipId = _data["apprenticeshipId"];
            this.selectionTitle = _data["selectionTitle"];
            this.internName = _data["internName"];
            if (Array.isArray(_data["orderCodes"])) {
                this.orderCodes = [] as any;
                for (let item of _data["orderCodes"])
                    this.orderCodes!.push(DictionaryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApprenticeshipOrderCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApprenticeshipOrderCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apprenticeshipId"] = this.apprenticeshipId;
        data["selectionTitle"] = this.selectionTitle;
        data["internName"] = this.internName;
        if (Array.isArray(this.orderCodes)) {
            data["orderCodes"] = [];
            for (let item of this.orderCodes)
                data["orderCodes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ApprenticeshipOrderCodeDto {
        const json = this.toJSON();
        let result = new ApprenticeshipOrderCodeDto();
        result.init(json);
        return result;
    }
}

export interface IApprenticeshipOrderCodeDto {
    apprenticeshipId: number;
    selectionTitle: string | undefined;
    internName: string | undefined;
    orderCodes: DictionaryDto[] | undefined;
}

export class AssociateCompanyInput implements IAssociateCompanyInput {
    laborConsultantId!: number;
    companyId!: number;

    constructor(data?: IAssociateCompanyInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.laborConsultantId = _data["laborConsultantId"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): AssociateCompanyInput {
        data = typeof data === 'object' ? data : {};
        let result = new AssociateCompanyInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["laborConsultantId"] = this.laborConsultantId;
        data["companyId"] = this.companyId;
        return data;
    }

    clone(): AssociateCompanyInput {
        const json = this.toJSON();
        let result = new AssociateCompanyInput();
        result.init(json);
        return result;
    }
}

export interface IAssociateCompanyInput {
    laborConsultantId: number;
    companyId: number;
}

export class AssociateFileTypeDto implements IAssociateFileTypeDto {
    fileId!: number;
    fileTypeId!: number;

    constructor(data?: IAssociateFileTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.fileTypeId = _data["fileTypeId"];
        }
    }

    static fromJS(data: any): AssociateFileTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssociateFileTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["fileTypeId"] = this.fileTypeId;
        return data;
    }

    clone(): AssociateFileTypeDto {
        const json = this.toJSON();
        let result = new AssociateFileTypeDto();
        result.init(json);
        return result;
    }
}

export interface IAssociateFileTypeDto {
    fileId: number;
    fileTypeId: number;
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress!: string;
    password!: string;
    rememberClient!: boolean;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
            this.password = _data["password"];
            this.rememberClient = _data["rememberClient"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["rememberClient"] = this.rememberClient;
        return data;
    }

    clone(): AuthenticateModel {
        const json = this.toJSON();
        let result = new AuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;
    userId!: number;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["userId"] = this.userId;
        return data;
    }

    clone(): AuthenticateResultModel {
        const json = this.toJSON();
        let result = new AuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;
}

export class ChangePasswordDto implements IChangePasswordDto {
    currentPassword!: string;
    newPassword!: string;

    constructor(data?: IChangePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ChangePasswordDto {
        const json = this.toJSON();
        let result = new ChangePasswordDto();
        result.init(json);
        return result;
    }
}

export interface IChangePasswordDto {
    currentPassword: string;
    newPassword: string;
}

export class ChangeUiThemeInput implements IChangeUiThemeInput {
    theme!: string;

    constructor(data?: IChangeUiThemeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theme = _data["theme"];
        }
    }

    static fromJS(data: any): ChangeUiThemeInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUiThemeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme;
        return data;
    }

    clone(): ChangeUiThemeInput {
        const json = this.toJSON();
        let result = new ChangeUiThemeInput();
        result.init(json);
        return result;
    }
}

export interface IChangeUiThemeInput {
    theme: string;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName!: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data;
    }

    clone(): ChangeUserLanguageDto {
        const json = this.toJSON();
        let result = new ChangeUserLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class CompensationPaymentRequestDto implements ICompensationPaymentRequestDto {
    id!: number;
    apprenticeship!: ApprenticeshipDto;
    months!: DictionaryDto;
    year!: number;
    tutorRequest!: number | undefined;
    totalPayment!: number | undefined;
    paymentConfirmed!: boolean;

    constructor(data?: ICompensationPaymentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.apprenticeship = _data["apprenticeship"] ? ApprenticeshipDto.fromJS(_data["apprenticeship"]) : undefined as any;
            this.months = _data["months"] ? DictionaryDto.fromJS(_data["months"]) : undefined as any;
            this.year = _data["year"];
            this.tutorRequest = _data["tutorRequest"];
            this.totalPayment = _data["totalPayment"];
            this.paymentConfirmed = _data["paymentConfirmed"];
        }
    }

    static fromJS(data: any): CompensationPaymentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompensationPaymentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["apprenticeship"] = this.apprenticeship ? this.apprenticeship.toJSON() : undefined as any;
        data["months"] = this.months ? this.months.toJSON() : undefined as any;
        data["year"] = this.year;
        data["tutorRequest"] = this.tutorRequest;
        data["totalPayment"] = this.totalPayment;
        data["paymentConfirmed"] = this.paymentConfirmed;
        return data;
    }

    clone(): CompensationPaymentRequestDto {
        const json = this.toJSON();
        let result = new CompensationPaymentRequestDto();
        result.init(json);
        return result;
    }
}

export interface ICompensationPaymentRequestDto {
    id: number;
    apprenticeship: ApprenticeshipDto;
    months: DictionaryDto;
    year: number;
    tutorRequest: number | undefined;
    totalPayment: number | undefined;
    paymentConfirmed: boolean;
}

export class CompensationPaymentRequestDtoPagedResultDto implements ICompensationPaymentRequestDtoPagedResultDto {
    items!: CompensationPaymentRequestDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICompensationPaymentRequestDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CompensationPaymentRequestDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CompensationPaymentRequestDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompensationPaymentRequestDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CompensationPaymentRequestDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CompensationPaymentRequestDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICompensationPaymentRequestDtoPagedResultDto {
    items: CompensationPaymentRequestDto[] | undefined;
    totalCount: number;
}

export class ConfirmEmailDto implements IConfirmEmailDto {
    userId!: number;
    token!: string | undefined;

    constructor(data?: IConfirmEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): ConfirmEmailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["token"] = this.token;
        return data;
    }

    clone(): ConfirmEmailDto {
        const json = this.toJSON();
        let result = new ConfirmEmailDto();
        result.init(json);
        return result;
    }
}

export interface IConfirmEmailDto {
    userId: number;
    token: string | undefined;
}

export class ContactPersonDto implements IContactPersonDto {
    id!: number;
    name!: string;
    surname!: string;
    email!: string;
    role!: string | undefined;
    phoneNumber!: string | undefined;

    constructor(data?: IContactPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.email = _data["email"];
            this.role = _data["role"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): ContactPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["email"] = this.email;
        data["role"] = this.role;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }

    clone(): ContactPersonDto {
        const json = this.toJSON();
        let result = new ContactPersonDto();
        result.init(json);
        return result;
    }
}

export interface IContactPersonDto {
    id: number;
    name: string;
    surname: string;
    email: string;
    role: string | undefined;
    phoneNumber: string | undefined;
}

export class ContactPersonDtoPagedResultDto implements IContactPersonDtoPagedResultDto {
    items!: ContactPersonDto[] | undefined;
    totalCount!: number;

    constructor(data?: IContactPersonDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ContactPersonDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ContactPersonDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactPersonDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ContactPersonDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ContactPersonDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IContactPersonDtoPagedResultDto {
    items: ContactPersonDto[] | undefined;
    totalCount: number;
}

export class ConventionDto implements IConventionDto {
    id!: number;
    progressiveNumber!: string | undefined;
    expirationDate!: moment.Moment;
    readonly isExpired!: boolean;
    conventionType!: DictionaryDto;
    orderCodes!: OrderCodeDto[] | undefined;
    files!: FileDto[] | undefined;

    constructor(data?: IConventionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.progressiveNumber = _data["progressiveNumber"];
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : undefined as any;
            (this as any).isExpired = _data["isExpired"];
            this.conventionType = _data["conventionType"] ? DictionaryDto.fromJS(_data["conventionType"]) : undefined as any;
            if (Array.isArray(_data["orderCodes"])) {
                this.orderCodes = [] as any;
                for (let item of _data["orderCodes"])
                    this.orderCodes!.push(OrderCodeDto.fromJS(item));
            }
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(FileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConventionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConventionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["progressiveNumber"] = this.progressiveNumber;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : undefined as any;
        data["isExpired"] = this.isExpired;
        data["conventionType"] = this.conventionType ? this.conventionType.toJSON() : undefined as any;
        if (Array.isArray(this.orderCodes)) {
            data["orderCodes"] = [];
            for (let item of this.orderCodes)
                data["orderCodes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ConventionDto {
        const json = this.toJSON();
        let result = new ConventionDto();
        result.init(json);
        return result;
    }
}

export interface IConventionDto {
    id: number;
    progressiveNumber: string | undefined;
    expirationDate: moment.Moment;
    isExpired: boolean;
    conventionType: DictionaryDto;
    orderCodes: OrderCodeDto[] | undefined;
    files: FileDto[] | undefined;
}

export class CreateAddressDto implements ICreateAddressDto {
    name!: string | undefined;
    description!: string | undefined;
    postalCode!: string | undefined;
    municipalityId!: number;

    constructor(data?: ICreateAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.postalCode = _data["postalCode"];
            this.municipalityId = _data["municipalityId"];
        }
    }

    static fromJS(data: any): CreateAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["postalCode"] = this.postalCode;
        data["municipalityId"] = this.municipalityId;
        return data;
    }

    clone(): CreateAddressDto {
        const json = this.toJSON();
        let result = new CreateAddressDto();
        result.init(json);
        return result;
    }
}

export interface ICreateAddressDto {
    name: string | undefined;
    description: string | undefined;
    postalCode: string | undefined;
    municipalityId: number;
}

export class CreateAgencyServiceOperativeUnitDto implements ICreateAgencyServiceOperativeUnitDto {
    operativeUnitId!: number;

    constructor(data?: ICreateAgencyServiceOperativeUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operativeUnitId = _data["operativeUnitId"];
        }
    }

    static fromJS(data: any): CreateAgencyServiceOperativeUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAgencyServiceOperativeUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operativeUnitId"] = this.operativeUnitId;
        return data;
    }

    clone(): CreateAgencyServiceOperativeUnitDto {
        const json = this.toJSON();
        let result = new CreateAgencyServiceOperativeUnitDto();
        result.init(json);
        return result;
    }
}

export interface ICreateAgencyServiceOperativeUnitDto {
    operativeUnitId: number;
}

export class CreateApprenticeshipAdditionalDataDto implements ICreateApprenticeshipAdditionalDataDto {
    id!: number;
    paymentData!: moment.Moment | undefined;
    operator!: string | undefined;
    tutorORSo!: string | undefined;
    company!: string | undefined;
    companyName!: string | undefined;
    address!: string | undefined;
    cap!: string | undefined;
    city!: string | undefined;
    piva!: string | undefined;
    cfCompany!: string | undefined;
    cfLegalRepresentative!: string | undefined;
    telematicIdentificationAddress!: string | undefined;
    mail!: string | undefined;
    intern!: string | undefined;
    economicValueWithoutVAT22!: number | undefined;

    constructor(data?: ICreateApprenticeshipAdditionalDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.paymentData = _data["paymentData"] ? moment(_data["paymentData"].toString()) : undefined as any;
            this.operator = _data["operator"];
            this.tutorORSo = _data["tutorORSo"];
            this.company = _data["company"];
            this.companyName = _data["companyName"];
            this.address = _data["address"];
            this.cap = _data["cap"];
            this.city = _data["city"];
            this.piva = _data["piva"];
            this.cfCompany = _data["cfCompany"];
            this.cfLegalRepresentative = _data["cfLegalRepresentative"];
            this.telematicIdentificationAddress = _data["telematicIdentificationAddress"];
            this.mail = _data["mail"];
            this.intern = _data["intern"];
            this.economicValueWithoutVAT22 = _data["economicValueWithoutVAT22"];
        }
    }

    static fromJS(data: any): CreateApprenticeshipAdditionalDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateApprenticeshipAdditionalDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["paymentData"] = this.paymentData ? this.paymentData.toISOString() : undefined as any;
        data["operator"] = this.operator;
        data["tutorORSo"] = this.tutorORSo;
        data["company"] = this.company;
        data["companyName"] = this.companyName;
        data["address"] = this.address;
        data["cap"] = this.cap;
        data["city"] = this.city;
        data["piva"] = this.piva;
        data["cfCompany"] = this.cfCompany;
        data["cfLegalRepresentative"] = this.cfLegalRepresentative;
        data["telematicIdentificationAddress"] = this.telematicIdentificationAddress;
        data["mail"] = this.mail;
        data["intern"] = this.intern;
        data["economicValueWithoutVAT22"] = this.economicValueWithoutVAT22;
        return data;
    }

    clone(): CreateApprenticeshipAdditionalDataDto {
        const json = this.toJSON();
        let result = new CreateApprenticeshipAdditionalDataDto();
        result.init(json);
        return result;
    }
}

export interface ICreateApprenticeshipAdditionalDataDto {
    id: number;
    paymentData: moment.Moment | undefined;
    operator: string | undefined;
    tutorORSo: string | undefined;
    company: string | undefined;
    companyName: string | undefined;
    address: string | undefined;
    cap: string | undefined;
    city: string | undefined;
    piva: string | undefined;
    cfCompany: string | undefined;
    cfLegalRepresentative: string | undefined;
    telematicIdentificationAddress: string | undefined;
    mail: string | undefined;
    intern: string | undefined;
    economicValueWithoutVAT22: number | undefined;
}

export class CreateApprenticeshipDto implements ICreateApprenticeshipDto {
    selectionId!: number;

    constructor(data?: ICreateApprenticeshipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selectionId = _data["selectionId"];
        }
    }

    static fromJS(data: any): CreateApprenticeshipDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateApprenticeshipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selectionId"] = this.selectionId;
        return data;
    }

    clone(): CreateApprenticeshipDto {
        const json = this.toJSON();
        let result = new CreateApprenticeshipDto();
        result.init(json);
        return result;
    }
}

export interface ICreateApprenticeshipDto {
    selectionId: number;
}

export class CreateApprenticeshipExtensionDto implements ICreateApprenticeshipExtensionDto {
    apprenticeShipId!: number;
    startDateTime!: moment.Moment | undefined;
    endDateTime!: moment.Moment | undefined;

    constructor(data?: ICreateApprenticeshipExtensionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apprenticeShipId = _data["apprenticeShipId"];
            this.startDateTime = _data["startDateTime"] ? moment(_data["startDateTime"].toString()) : undefined as any;
            this.endDateTime = _data["endDateTime"] ? moment(_data["endDateTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CreateApprenticeshipExtensionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateApprenticeshipExtensionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apprenticeShipId"] = this.apprenticeShipId;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : undefined as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : undefined as any;
        return data;
    }

    clone(): CreateApprenticeshipExtensionDto {
        const json = this.toJSON();
        let result = new CreateApprenticeshipExtensionDto();
        result.init(json);
        return result;
    }
}

export interface ICreateApprenticeshipExtensionDto {
    apprenticeShipId: number;
    startDateTime: moment.Moment | undefined;
    endDateTime: moment.Moment | undefined;
}

export class CreateCompensationPaymentRequestDto implements ICreateCompensationPaymentRequestDto {
    apprenticeshipId!: number;
    monthId!: number;
    year!: number;
    tutorRequest!: number | undefined;
    totalPayment!: number | undefined;
    paymentConfirmed!: boolean;

    constructor(data?: ICreateCompensationPaymentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apprenticeshipId = _data["apprenticeshipId"];
            this.monthId = _data["monthId"];
            this.year = _data["year"];
            this.tutorRequest = _data["tutorRequest"];
            this.totalPayment = _data["totalPayment"];
            this.paymentConfirmed = _data["paymentConfirmed"];
        }
    }

    static fromJS(data: any): CreateCompensationPaymentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompensationPaymentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apprenticeshipId"] = this.apprenticeshipId;
        data["monthId"] = this.monthId;
        data["year"] = this.year;
        data["tutorRequest"] = this.tutorRequest;
        data["totalPayment"] = this.totalPayment;
        data["paymentConfirmed"] = this.paymentConfirmed;
        return data;
    }

    clone(): CreateCompensationPaymentRequestDto {
        const json = this.toJSON();
        let result = new CreateCompensationPaymentRequestDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCompensationPaymentRequestDto {
    apprenticeshipId: number;
    monthId: number;
    year: number;
    tutorRequest: number | undefined;
    totalPayment: number | undefined;
    paymentConfirmed: boolean;
}

export class CreateContactPersonDto implements ICreateContactPersonDto {
    userId!: number;
    name!: string;
    surname!: string;
    email!: string;
    role!: string | undefined;
    phoneNumber!: string | undefined;

    constructor(data?: ICreateContactPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.email = _data["email"];
            this.role = _data["role"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): CreateContactPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateContactPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["email"] = this.email;
        data["role"] = this.role;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }

    clone(): CreateContactPersonDto {
        const json = this.toJSON();
        let result = new CreateContactPersonDto();
        result.init(json);
        return result;
    }
}

export interface ICreateContactPersonDto {
    userId: number;
    name: string;
    surname: string;
    email: string;
    role: string | undefined;
    phoneNumber: string | undefined;
}

export class CreateConventionDto implements ICreateConventionDto {
    partnerId!: number;
    expirationDate!: moment.Moment;
    conventionTypeId!: number;
    orderCodeIds!: number[] | undefined;
    fileIds!: number[] | undefined;

    constructor(data?: ICreateConventionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data["partnerId"];
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : undefined as any;
            this.conventionTypeId = _data["conventionTypeId"];
            if (Array.isArray(_data["orderCodeIds"])) {
                this.orderCodeIds = [] as any;
                for (let item of _data["orderCodeIds"])
                    this.orderCodeIds!.push(item);
            }
            if (Array.isArray(_data["fileIds"])) {
                this.fileIds = [] as any;
                for (let item of _data["fileIds"])
                    this.fileIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateConventionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateConventionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerId"] = this.partnerId;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : undefined as any;
        data["conventionTypeId"] = this.conventionTypeId;
        if (Array.isArray(this.orderCodeIds)) {
            data["orderCodeIds"] = [];
            for (let item of this.orderCodeIds)
                data["orderCodeIds"].push(item);
        }
        if (Array.isArray(this.fileIds)) {
            data["fileIds"] = [];
            for (let item of this.fileIds)
                data["fileIds"].push(item);
        }
        return data;
    }

    clone(): CreateConventionDto {
        const json = this.toJSON();
        let result = new CreateConventionDto();
        result.init(json);
        return result;
    }
}

export interface ICreateConventionDto {
    partnerId: number;
    expirationDate: moment.Moment;
    conventionTypeId: number;
    orderCodeIds: number[] | undefined;
    fileIds: number[] | undefined;
}

export class CreateFileAssociation implements ICreateFileAssociation {
    fileId!: number;
    userId!: number | undefined;
    requestApprenticeshipId!: number | undefined;
    apprenticeshipId!: number | undefined;
    conventionId!: number | undefined;
    expireDate!: moment.Moment | undefined;

    constructor(data?: ICreateFileAssociation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.userId = _data["userId"];
            this.requestApprenticeshipId = _data["requestApprenticeshipId"];
            this.apprenticeshipId = _data["apprenticeshipId"];
            this.conventionId = _data["conventionId"];
            this.expireDate = _data["expireDate"] ? moment(_data["expireDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CreateFileAssociation {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFileAssociation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["userId"] = this.userId;
        data["requestApprenticeshipId"] = this.requestApprenticeshipId;
        data["apprenticeshipId"] = this.apprenticeshipId;
        data["conventionId"] = this.conventionId;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : undefined as any;
        return data;
    }

    clone(): CreateFileAssociation {
        const json = this.toJSON();
        let result = new CreateFileAssociation();
        result.init(json);
        return result;
    }
}

export interface ICreateFileAssociation {
    fileId: number;
    userId: number | undefined;
    requestApprenticeshipId: number | undefined;
    apprenticeshipId: number | undefined;
    conventionId: number | undefined;
    expireDate: moment.Moment | undefined;
}

export class CreateJobExperienceDto implements ICreateJobExperienceDto {
    jobId!: number;
    hasExperience!: boolean;

    constructor(data?: ICreateJobExperienceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            this.hasExperience = _data["hasExperience"];
        }
    }

    static fromJS(data: any): CreateJobExperienceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateJobExperienceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        data["hasExperience"] = this.hasExperience;
        return data;
    }

    clone(): CreateJobExperienceDto {
        const json = this.toJSON();
        let result = new CreateJobExperienceDto();
        result.init(json);
        return result;
    }
}

export interface ICreateJobExperienceDto {
    jobId: number;
    hasExperience: boolean;
}

export class CreateJobSearchDto implements ICreateJobSearchDto {
    userId!: number;
    jobExperiences!: CreateJobExperienceDto[] | undefined;
    contractTypeIds!: number[];
    hourEffortId!: number | undefined;
    traineeshipAvailability!: boolean | undefined;
    shiftWorkAvailability!: boolean | undefined;
    businessTripAvailability!: boolean | undefined;
    timeAvailability!: CreateTimeAvailabilityDto;
    daysAvailabilityId!: number | undefined;

    constructor(data?: ICreateJobSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.contractTypeIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            if (Array.isArray(_data["jobExperiences"])) {
                this.jobExperiences = [] as any;
                for (let item of _data["jobExperiences"])
                    this.jobExperiences!.push(CreateJobExperienceDto.fromJS(item));
            }
            if (Array.isArray(_data["contractTypeIds"])) {
                this.contractTypeIds = [] as any;
                for (let item of _data["contractTypeIds"])
                    this.contractTypeIds!.push(item);
            }
            this.hourEffortId = _data["hourEffortId"];
            this.traineeshipAvailability = _data["traineeshipAvailability"];
            this.shiftWorkAvailability = _data["shiftWorkAvailability"];
            this.businessTripAvailability = _data["businessTripAvailability"];
            this.timeAvailability = _data["timeAvailability"] ? CreateTimeAvailabilityDto.fromJS(_data["timeAvailability"]) : undefined as any;
            this.daysAvailabilityId = _data["daysAvailabilityId"];
        }
    }

    static fromJS(data: any): CreateJobSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateJobSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        if (Array.isArray(this.jobExperiences)) {
            data["jobExperiences"] = [];
            for (let item of this.jobExperiences)
                data["jobExperiences"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.contractTypeIds)) {
            data["contractTypeIds"] = [];
            for (let item of this.contractTypeIds)
                data["contractTypeIds"].push(item);
        }
        data["hourEffortId"] = this.hourEffortId;
        data["traineeshipAvailability"] = this.traineeshipAvailability;
        data["shiftWorkAvailability"] = this.shiftWorkAvailability;
        data["businessTripAvailability"] = this.businessTripAvailability;
        data["timeAvailability"] = this.timeAvailability ? this.timeAvailability.toJSON() : undefined as any;
        data["daysAvailabilityId"] = this.daysAvailabilityId;
        return data;
    }

    clone(): CreateJobSearchDto {
        const json = this.toJSON();
        let result = new CreateJobSearchDto();
        result.init(json);
        return result;
    }
}

export interface ICreateJobSearchDto {
    userId: number;
    jobExperiences: CreateJobExperienceDto[] | undefined;
    contractTypeIds: number[];
    hourEffortId: number | undefined;
    traineeshipAvailability: boolean | undefined;
    shiftWorkAvailability: boolean | undefined;
    businessTripAvailability: boolean | undefined;
    timeAvailability: CreateTimeAvailabilityDto;
    daysAvailabilityId: number | undefined;
}

export class CreateLaborConsultantDto implements ICreateLaborConsultantDto {
    businessName!: string;
    phoneNumber!: string;
    responsibleName!: string | undefined;
    vatNumber!: string | undefined;
    fiscalCode!: string | undefined;
    email!: string | undefined;
    address!: CreateAddressDto;
    notes!: string | undefined;

    constructor(data?: ICreateLaborConsultantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.businessName = _data["businessName"];
            this.phoneNumber = _data["phoneNumber"];
            this.responsibleName = _data["responsibleName"];
            this.vatNumber = _data["vatNumber"];
            this.fiscalCode = _data["fiscalCode"];
            this.email = _data["email"];
            this.address = _data["address"] ? CreateAddressDto.fromJS(_data["address"]) : undefined as any;
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): CreateLaborConsultantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLaborConsultantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["businessName"] = this.businessName;
        data["phoneNumber"] = this.phoneNumber;
        data["responsibleName"] = this.responsibleName;
        data["vatNumber"] = this.vatNumber;
        data["fiscalCode"] = this.fiscalCode;
        data["email"] = this.email;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["notes"] = this.notes;
        return data;
    }

    clone(): CreateLaborConsultantDto {
        const json = this.toJSON();
        let result = new CreateLaborConsultantDto();
        result.init(json);
        return result;
    }
}

export interface ICreateLaborConsultantDto {
    businessName: string;
    phoneNumber: string;
    responsibleName: string | undefined;
    vatNumber: string | undefined;
    fiscalCode: string | undefined;
    email: string | undefined;
    address: CreateAddressDto;
    notes: string | undefined;
}

export class CreateNotesDto implements ICreateNotesDto {
    id!: number;
    date!: moment.Moment;
    description!: string | undefined;

    constructor(data?: ICreateNotesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateNotesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNotesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.format('YYYY-MM-DD') : undefined as any;
        data["description"] = this.description;
        return data;
    }

    clone(): CreateNotesDto {
        const json = this.toJSON();
        let result = new CreateNotesDto();
        result.init(json);
        return result;
    }
}

export interface ICreateNotesDto {
    id: number;
    date: moment.Moment;
    description: string | undefined;
}

export class CreateOperativeUnitDto implements ICreateOperativeUnitDto {
    headOffice!: string;
    address!: CreateAddressDto;
    contact!: string;

    constructor(data?: ICreateOperativeUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.address = new CreateAddressDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.headOffice = _data["headOffice"];
            this.address = _data["address"] ? CreateAddressDto.fromJS(_data["address"]) : new CreateAddressDto();
            this.contact = _data["contact"];
        }
    }

    static fromJS(data: any): CreateOperativeUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOperativeUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["headOffice"] = this.headOffice;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["contact"] = this.contact;
        return data;
    }

    clone(): CreateOperativeUnitDto {
        const json = this.toJSON();
        let result = new CreateOperativeUnitDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOperativeUnitDto {
    headOffice: string;
    address: CreateAddressDto;
    contact: string;
}

export class CreateOrderCodeDto implements ICreateOrderCodeDto {
    description!: string;

    constructor(data?: ICreateOrderCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateOrderCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrderCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        return data;
    }

    clone(): CreateOrderCodeDto {
        const json = this.toJSON();
        let result = new CreateOrderCodeDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOrderCodeDto {
    description: string;
}

export class CreatePartnerServicesDto implements ICreatePartnerServicesDto {
    userId!: number;
    silServiceOperativeUnits!: CreateSILServiceOperativeUnitDto[] | undefined;
    agencyServiceOperativeUnits!: CreateAgencyServiceOperativeUnitDto[] | undefined;
    silLastContact!: string | undefined;
    agencyLastContact!: string | undefined;
    hasSILService!: boolean | undefined;
    hasAgencyService!: boolean | undefined;

    constructor(data?: ICreatePartnerServicesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            if (Array.isArray(_data["silServiceOperativeUnits"])) {
                this.silServiceOperativeUnits = [] as any;
                for (let item of _data["silServiceOperativeUnits"])
                    this.silServiceOperativeUnits!.push(CreateSILServiceOperativeUnitDto.fromJS(item));
            }
            if (Array.isArray(_data["agencyServiceOperativeUnits"])) {
                this.agencyServiceOperativeUnits = [] as any;
                for (let item of _data["agencyServiceOperativeUnits"])
                    this.agencyServiceOperativeUnits!.push(CreateAgencyServiceOperativeUnitDto.fromJS(item));
            }
            this.silLastContact = _data["silLastContact"];
            this.agencyLastContact = _data["agencyLastContact"];
            this.hasSILService = _data["hasSILService"];
            this.hasAgencyService = _data["hasAgencyService"];
        }
    }

    static fromJS(data: any): CreatePartnerServicesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePartnerServicesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        if (Array.isArray(this.silServiceOperativeUnits)) {
            data["silServiceOperativeUnits"] = [];
            for (let item of this.silServiceOperativeUnits)
                data["silServiceOperativeUnits"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.agencyServiceOperativeUnits)) {
            data["agencyServiceOperativeUnits"] = [];
            for (let item of this.agencyServiceOperativeUnits)
                data["agencyServiceOperativeUnits"].push(item ? item.toJSON() : undefined as any);
        }
        data["silLastContact"] = this.silLastContact;
        data["agencyLastContact"] = this.agencyLastContact;
        data["hasSILService"] = this.hasSILService;
        data["hasAgencyService"] = this.hasAgencyService;
        return data;
    }

    clone(): CreatePartnerServicesDto {
        const json = this.toJSON();
        let result = new CreatePartnerServicesDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePartnerServicesDto {
    userId: number;
    silServiceOperativeUnits: CreateSILServiceOperativeUnitDto[] | undefined;
    agencyServiceOperativeUnits: CreateAgencyServiceOperativeUnitDto[] | undefined;
    silLastContact: string | undefined;
    agencyLastContact: string | undefined;
    hasSILService: boolean | undefined;
    hasAgencyService: boolean | undefined;
}

export class CreatePartnerSurveyDto implements ICreatePartnerSurveyDto {
    partnerId!: number;
    hastJobPlacementApprenticeships!: number;
    hostTrainingApprenticeship!: number;
    participantOrientationInitiatives!: number;
    hostJobTrialEvents!: number;

    constructor(data?: ICreatePartnerSurveyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data["partnerId"];
            this.hastJobPlacementApprenticeships = _data["hastJobPlacementApprenticeships"];
            this.hostTrainingApprenticeship = _data["hostTrainingApprenticeship"];
            this.participantOrientationInitiatives = _data["participantOrientationInitiatives"];
            this.hostJobTrialEvents = _data["hostJobTrialEvents"];
        }
    }

    static fromJS(data: any): CreatePartnerSurveyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePartnerSurveyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerId"] = this.partnerId;
        data["hastJobPlacementApprenticeships"] = this.hastJobPlacementApprenticeships;
        data["hostTrainingApprenticeship"] = this.hostTrainingApprenticeship;
        data["participantOrientationInitiatives"] = this.participantOrientationInitiatives;
        data["hostJobTrialEvents"] = this.hostJobTrialEvents;
        return data;
    }

    clone(): CreatePartnerSurveyDto {
        const json = this.toJSON();
        let result = new CreatePartnerSurveyDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePartnerSurveyDto {
    partnerId: number;
    hastJobPlacementApprenticeships: number;
    hostTrainingApprenticeship: number;
    participantOrientationInitiatives: number;
    hostJobTrialEvents: number;
}

export class CreatePartnerUserDto implements ICreatePartnerUserDto {
    partnerId!: number;
    personIds!: number[] | undefined;

    constructor(data?: ICreatePartnerUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data["partnerId"];
            if (Array.isArray(_data["personIds"])) {
                this.personIds = [] as any;
                for (let item of _data["personIds"])
                    this.personIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreatePartnerUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePartnerUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerId"] = this.partnerId;
        if (Array.isArray(this.personIds)) {
            data["personIds"] = [];
            for (let item of this.personIds)
                data["personIds"].push(item);
        }
        return data;
    }

    clone(): CreatePartnerUserDto {
        const json = this.toJSON();
        let result = new CreatePartnerUserDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePartnerUserDto {
    partnerId: number;
    personIds: number[] | undefined;
}

export class CreatePersonalInfoDto implements ICreatePersonalInfoDto {
    userId!: number;
    employmentStatusId!: number | undefined;
    currentCompany!: string | undefined;
    phoneNumber!: string | undefined;
    maritalStatusId!: number | undefined;
    childrenNumber!: number | undefined;
    hasCar!: boolean | undefined;
    hasDrivingLicense!: boolean | undefined;
    drivingLicenseTypeIds!: number[] | undefined;
    usePublicTransport!: boolean | undefined;
    hasIndependently!: boolean | undefined;
    hasAvilabilityTravel!: boolean | undefined;
    kmRadius!: number | undefined;
    drivingLicenseDescription!: string | undefined;
    orderCodeIds!: number[] | undefined;
    atecoCodeIds!: number[] | undefined;

    constructor(data?: ICreatePersonalInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.employmentStatusId = _data["employmentStatusId"];
            this.currentCompany = _data["currentCompany"];
            this.phoneNumber = _data["phoneNumber"];
            this.maritalStatusId = _data["maritalStatusId"];
            this.childrenNumber = _data["childrenNumber"];
            this.hasCar = _data["hasCar"];
            this.hasDrivingLicense = _data["hasDrivingLicense"];
            if (Array.isArray(_data["drivingLicenseTypeIds"])) {
                this.drivingLicenseTypeIds = [] as any;
                for (let item of _data["drivingLicenseTypeIds"])
                    this.drivingLicenseTypeIds!.push(item);
            }
            this.usePublicTransport = _data["usePublicTransport"];
            this.hasIndependently = _data["hasIndependently"];
            this.hasAvilabilityTravel = _data["hasAvilabilityTravel"];
            this.kmRadius = _data["kmRadius"];
            this.drivingLicenseDescription = _data["drivingLicenseDescription"];
            if (Array.isArray(_data["orderCodeIds"])) {
                this.orderCodeIds = [] as any;
                for (let item of _data["orderCodeIds"])
                    this.orderCodeIds!.push(item);
            }
            if (Array.isArray(_data["atecoCodeIds"])) {
                this.atecoCodeIds = [] as any;
                for (let item of _data["atecoCodeIds"])
                    this.atecoCodeIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreatePersonalInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePersonalInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["employmentStatusId"] = this.employmentStatusId;
        data["currentCompany"] = this.currentCompany;
        data["phoneNumber"] = this.phoneNumber;
        data["maritalStatusId"] = this.maritalStatusId;
        data["childrenNumber"] = this.childrenNumber;
        data["hasCar"] = this.hasCar;
        data["hasDrivingLicense"] = this.hasDrivingLicense;
        if (Array.isArray(this.drivingLicenseTypeIds)) {
            data["drivingLicenseTypeIds"] = [];
            for (let item of this.drivingLicenseTypeIds)
                data["drivingLicenseTypeIds"].push(item);
        }
        data["usePublicTransport"] = this.usePublicTransport;
        data["hasIndependently"] = this.hasIndependently;
        data["hasAvilabilityTravel"] = this.hasAvilabilityTravel;
        data["kmRadius"] = this.kmRadius;
        data["drivingLicenseDescription"] = this.drivingLicenseDescription;
        if (Array.isArray(this.orderCodeIds)) {
            data["orderCodeIds"] = [];
            for (let item of this.orderCodeIds)
                data["orderCodeIds"].push(item);
        }
        if (Array.isArray(this.atecoCodeIds)) {
            data["atecoCodeIds"] = [];
            for (let item of this.atecoCodeIds)
                data["atecoCodeIds"].push(item);
        }
        return data;
    }

    clone(): CreatePersonalInfoDto {
        const json = this.toJSON();
        let result = new CreatePersonalInfoDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePersonalInfoDto {
    userId: number;
    employmentStatusId: number | undefined;
    currentCompany: string | undefined;
    phoneNumber: string | undefined;
    maritalStatusId: number | undefined;
    childrenNumber: number | undefined;
    hasCar: boolean | undefined;
    hasDrivingLicense: boolean | undefined;
    drivingLicenseTypeIds: number[] | undefined;
    usePublicTransport: boolean | undefined;
    hasIndependently: boolean | undefined;
    hasAvilabilityTravel: boolean | undefined;
    kmRadius: number | undefined;
    drivingLicenseDescription: string | undefined;
    orderCodeIds: number[] | undefined;
    atecoCodeIds: number[] | undefined;
}

export class CreateRequestApprenticeshipDto implements ICreateRequestApprenticeshipDto {
    title!: string;
    partnerId!: number;
    operativeUnitId!: number;
    contractProposalId!: number | undefined;
    placeOfWork!: string | undefined;
    requestApprenticeshipTypeId!: number | undefined;
    startDateTime!: moment.Moment | undefined;
    endDateTime!: moment.Moment | undefined;
    educationalDegreeLevelId!: number;
    educationalDegreeId!: number | undefined;
    otherEducationalDegreeLevel!: string | undefined;
    reference!: string | undefined;
    businessSectorId!: number;
    jobId!: number | undefined;
    requestTypeId!: number | undefined;
    requestApprenticeshipStateId!: number | undefined;

    constructor(data?: ICreateRequestApprenticeshipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.partnerId = _data["partnerId"];
            this.operativeUnitId = _data["operativeUnitId"];
            this.contractProposalId = _data["contractProposalId"];
            this.placeOfWork = _data["placeOfWork"];
            this.requestApprenticeshipTypeId = _data["requestApprenticeshipTypeId"];
            this.startDateTime = _data["startDateTime"] ? moment(_data["startDateTime"].toString()) : undefined as any;
            this.endDateTime = _data["endDateTime"] ? moment(_data["endDateTime"].toString()) : undefined as any;
            this.educationalDegreeLevelId = _data["educationalDegreeLevelId"];
            this.educationalDegreeId = _data["educationalDegreeId"];
            this.otherEducationalDegreeLevel = _data["otherEducationalDegreeLevel"];
            this.reference = _data["reference"];
            this.businessSectorId = _data["businessSectorId"];
            this.jobId = _data["jobId"];
            this.requestTypeId = _data["requestTypeId"];
            this.requestApprenticeshipStateId = _data["requestApprenticeshipStateId"];
        }
    }

    static fromJS(data: any): CreateRequestApprenticeshipDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRequestApprenticeshipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["partnerId"] = this.partnerId;
        data["operativeUnitId"] = this.operativeUnitId;
        data["contractProposalId"] = this.contractProposalId;
        data["placeOfWork"] = this.placeOfWork;
        data["requestApprenticeshipTypeId"] = this.requestApprenticeshipTypeId;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : undefined as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : undefined as any;
        data["educationalDegreeLevelId"] = this.educationalDegreeLevelId;
        data["educationalDegreeId"] = this.educationalDegreeId;
        data["otherEducationalDegreeLevel"] = this.otherEducationalDegreeLevel;
        data["reference"] = this.reference;
        data["businessSectorId"] = this.businessSectorId;
        data["jobId"] = this.jobId;
        data["requestTypeId"] = this.requestTypeId;
        data["requestApprenticeshipStateId"] = this.requestApprenticeshipStateId;
        return data;
    }

    clone(): CreateRequestApprenticeshipDto {
        const json = this.toJSON();
        let result = new CreateRequestApprenticeshipDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRequestApprenticeshipDto {
    title: string;
    partnerId: number;
    operativeUnitId: number;
    contractProposalId: number | undefined;
    placeOfWork: string | undefined;
    requestApprenticeshipTypeId: number | undefined;
    startDateTime: moment.Moment | undefined;
    endDateTime: moment.Moment | undefined;
    educationalDegreeLevelId: number;
    educationalDegreeId: number | undefined;
    otherEducationalDegreeLevel: string | undefined;
    reference: string | undefined;
    businessSectorId: number;
    jobId: number | undefined;
    requestTypeId: number | undefined;
    requestApprenticeshipStateId: number | undefined;
}

export class CreateResidenceInfoDto implements ICreateResidenceInfoDto {
    userId!: number;
    employmentCenterRegistration!: boolean | undefined;
    residencePermitId!: number | undefined;
    motivationResidencePermitId!: number | undefined;
    empiryDateResindence!: moment.Moment | undefined;
    incomeSupportRecipient!: boolean | undefined;
    incomeSupportTypeIds!: number[] | undefined;
    residence!: CreateAddressDto;
    isDomicileOther!: boolean | undefined;
    domicile!: CreateAddressDto;
    policeRelease!: string | undefined;

    constructor(data?: ICreateResidenceInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.employmentCenterRegistration = _data["employmentCenterRegistration"];
            this.residencePermitId = _data["residencePermitId"];
            this.motivationResidencePermitId = _data["motivationResidencePermitId"];
            this.empiryDateResindence = _data["empiryDateResindence"] ? moment(_data["empiryDateResindence"].toString()) : undefined as any;
            this.incomeSupportRecipient = _data["incomeSupportRecipient"];
            if (Array.isArray(_data["incomeSupportTypeIds"])) {
                this.incomeSupportTypeIds = [] as any;
                for (let item of _data["incomeSupportTypeIds"])
                    this.incomeSupportTypeIds!.push(item);
            }
            this.residence = _data["residence"] ? CreateAddressDto.fromJS(_data["residence"]) : undefined as any;
            this.isDomicileOther = _data["isDomicileOther"];
            this.domicile = _data["domicile"] ? CreateAddressDto.fromJS(_data["domicile"]) : undefined as any;
            this.policeRelease = _data["policeRelease"];
        }
    }

    static fromJS(data: any): CreateResidenceInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateResidenceInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["employmentCenterRegistration"] = this.employmentCenterRegistration;
        data["residencePermitId"] = this.residencePermitId;
        data["motivationResidencePermitId"] = this.motivationResidencePermitId;
        data["empiryDateResindence"] = this.empiryDateResindence ? this.empiryDateResindence.format('YYYY-MM-DD') : undefined as any;
        data["incomeSupportRecipient"] = this.incomeSupportRecipient;
        if (Array.isArray(this.incomeSupportTypeIds)) {
            data["incomeSupportTypeIds"] = [];
            for (let item of this.incomeSupportTypeIds)
                data["incomeSupportTypeIds"].push(item);
        }
        data["residence"] = this.residence ? this.residence.toJSON() : undefined as any;
        data["isDomicileOther"] = this.isDomicileOther;
        data["domicile"] = this.domicile ? this.domicile.toJSON() : undefined as any;
        data["policeRelease"] = this.policeRelease;
        return data;
    }

    clone(): CreateResidenceInfoDto {
        const json = this.toJSON();
        let result = new CreateResidenceInfoDto();
        result.init(json);
        return result;
    }
}

export interface ICreateResidenceInfoDto {
    userId: number;
    employmentCenterRegistration: boolean | undefined;
    residencePermitId: number | undefined;
    motivationResidencePermitId: number | undefined;
    empiryDateResindence: moment.Moment | undefined;
    incomeSupportRecipient: boolean | undefined;
    incomeSupportTypeIds: number[] | undefined;
    residence: CreateAddressDto;
    isDomicileOther: boolean | undefined;
    domicile: CreateAddressDto;
    policeRelease: string | undefined;
}

export class CreateRoleDto implements ICreateRoleDto {
    name!: string;
    displayName!: string;
    normalizedName!: string | undefined;
    description!: string | undefined;
    grantedPermissions!: string[] | undefined;

    constructor(data?: ICreateRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        return data;
    }

    clone(): CreateRoleDto {
        const json = this.toJSON();
        let result = new CreateRoleDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
}

export class CreateSelectionApplicationDto implements ICreateSelectionApplicationDto {
    personId!: number;
    selectionId!: number;
    interviewResult!: boolean | undefined;
    interviewDate!: moment.Moment | undefined;

    constructor(data?: ICreateSelectionApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.selectionId = _data["selectionId"];
            this.interviewResult = _data["interviewResult"];
            this.interviewDate = _data["interviewDate"] ? moment(_data["interviewDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CreateSelectionApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSelectionApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["selectionId"] = this.selectionId;
        data["interviewResult"] = this.interviewResult;
        data["interviewDate"] = this.interviewDate ? this.interviewDate.format('YYYY-MM-DD') : undefined as any;
        return data;
    }

    clone(): CreateSelectionApplicationDto {
        const json = this.toJSON();
        let result = new CreateSelectionApplicationDto();
        result.init(json);
        return result;
    }
}

export interface ICreateSelectionApplicationDto {
    personId: number;
    selectionId: number;
    interviewResult: boolean | undefined;
    interviewDate: moment.Moment | undefined;
}

export class CreateSelectionComputerSkillDto implements ICreateSelectionComputerSkillDto {
    selectionId!: number;
    computerSkillId!: number;
    notes!: string | undefined;

    constructor(data?: ICreateSelectionComputerSkillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selectionId = _data["selectionId"];
            this.computerSkillId = _data["computerSkillId"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): CreateSelectionComputerSkillDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSelectionComputerSkillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selectionId"] = this.selectionId;
        data["computerSkillId"] = this.computerSkillId;
        data["notes"] = this.notes;
        return data;
    }

    clone(): CreateSelectionComputerSkillDto {
        const json = this.toJSON();
        let result = new CreateSelectionComputerSkillDto();
        result.init(json);
        return result;
    }
}

export interface ICreateSelectionComputerSkillDto {
    selectionId: number;
    computerSkillId: number;
    notes: string | undefined;
}

export class CreateSelectionDto implements ICreateSelectionDto {
    title!: string;
    partnerId!: number;
    operativeUnitId!: number;
    contractProposalId!: number | undefined;
    educationalDegreeLevelId!: number;
    educationalDegreeId!: number | undefined;
    otherEducationalDegreeLevel!: string | undefined;
    businessSectorId!: number;
    jobId!: number | undefined;
    placeOfWork!: string | undefined;
    insertionDate!: moment.Moment | undefined;
    experyDate!: moment.Moment | undefined;
    requestTypeId!: number | undefined;
    hasCar!: boolean | undefined;
    drivingLicenseTypeIds!: number[] | undefined;
    obligationLaw381!: boolean | undefined;
    obligationLaw68!: boolean | undefined;
    noisyEnvironment!: boolean | undefined;
    dustyEnvironment!: boolean | undefined;
    loadHandling!: boolean | undefined;
    workModeId!: number | undefined;
    description!: string | undefined;
    note!: string | undefined;
    orderCodeIds!: number[] | undefined;
    isPrivate!: boolean | undefined;

    constructor(data?: ICreateSelectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.partnerId = _data["partnerId"];
            this.operativeUnitId = _data["operativeUnitId"];
            this.contractProposalId = _data["contractProposalId"];
            this.educationalDegreeLevelId = _data["educationalDegreeLevelId"];
            this.educationalDegreeId = _data["educationalDegreeId"];
            this.otherEducationalDegreeLevel = _data["otherEducationalDegreeLevel"];
            this.businessSectorId = _data["businessSectorId"];
            this.jobId = _data["jobId"];
            this.placeOfWork = _data["placeOfWork"];
            this.insertionDate = _data["insertionDate"] ? moment(_data["insertionDate"].toString()) : undefined as any;
            this.experyDate = _data["experyDate"] ? moment(_data["experyDate"].toString()) : undefined as any;
            this.requestTypeId = _data["requestTypeId"];
            this.hasCar = _data["hasCar"];
            if (Array.isArray(_data["drivingLicenseTypeIds"])) {
                this.drivingLicenseTypeIds = [] as any;
                for (let item of _data["drivingLicenseTypeIds"])
                    this.drivingLicenseTypeIds!.push(item);
            }
            this.obligationLaw381 = _data["obligationLaw381"];
            this.obligationLaw68 = _data["obligationLaw68"];
            this.noisyEnvironment = _data["noisyEnvironment"];
            this.dustyEnvironment = _data["dustyEnvironment"];
            this.loadHandling = _data["loadHandling"];
            this.workModeId = _data["workModeId"];
            this.description = _data["description"];
            this.note = _data["note"];
            if (Array.isArray(_data["orderCodeIds"])) {
                this.orderCodeIds = [] as any;
                for (let item of _data["orderCodeIds"])
                    this.orderCodeIds!.push(item);
            }
            this.isPrivate = _data["isPrivate"];
        }
    }

    static fromJS(data: any): CreateSelectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSelectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["partnerId"] = this.partnerId;
        data["operativeUnitId"] = this.operativeUnitId;
        data["contractProposalId"] = this.contractProposalId;
        data["educationalDegreeLevelId"] = this.educationalDegreeLevelId;
        data["educationalDegreeId"] = this.educationalDegreeId;
        data["otherEducationalDegreeLevel"] = this.otherEducationalDegreeLevel;
        data["businessSectorId"] = this.businessSectorId;
        data["jobId"] = this.jobId;
        data["placeOfWork"] = this.placeOfWork;
        data["insertionDate"] = this.insertionDate ? this.insertionDate.format('YYYY-MM-DD') : undefined as any;
        data["experyDate"] = this.experyDate ? this.experyDate.format('YYYY-MM-DD') : undefined as any;
        data["requestTypeId"] = this.requestTypeId;
        data["hasCar"] = this.hasCar;
        if (Array.isArray(this.drivingLicenseTypeIds)) {
            data["drivingLicenseTypeIds"] = [];
            for (let item of this.drivingLicenseTypeIds)
                data["drivingLicenseTypeIds"].push(item);
        }
        data["obligationLaw381"] = this.obligationLaw381;
        data["obligationLaw68"] = this.obligationLaw68;
        data["noisyEnvironment"] = this.noisyEnvironment;
        data["dustyEnvironment"] = this.dustyEnvironment;
        data["loadHandling"] = this.loadHandling;
        data["workModeId"] = this.workModeId;
        data["description"] = this.description;
        data["note"] = this.note;
        if (Array.isArray(this.orderCodeIds)) {
            data["orderCodeIds"] = [];
            for (let item of this.orderCodeIds)
                data["orderCodeIds"].push(item);
        }
        data["isPrivate"] = this.isPrivate;
        return data;
    }

    clone(): CreateSelectionDto {
        const json = this.toJSON();
        let result = new CreateSelectionDto();
        result.init(json);
        return result;
    }
}

export interface ICreateSelectionDto {
    title: string;
    partnerId: number;
    operativeUnitId: number;
    contractProposalId: number | undefined;
    educationalDegreeLevelId: number;
    educationalDegreeId: number | undefined;
    otherEducationalDegreeLevel: string | undefined;
    businessSectorId: number;
    jobId: number | undefined;
    placeOfWork: string | undefined;
    insertionDate: moment.Moment | undefined;
    experyDate: moment.Moment | undefined;
    requestTypeId: number | undefined;
    hasCar: boolean | undefined;
    drivingLicenseTypeIds: number[] | undefined;
    obligationLaw381: boolean | undefined;
    obligationLaw68: boolean | undefined;
    noisyEnvironment: boolean | undefined;
    dustyEnvironment: boolean | undefined;
    loadHandling: boolean | undefined;
    workModeId: number | undefined;
    description: string | undefined;
    note: string | undefined;
    orderCodeIds: number[] | undefined;
    isPrivate: boolean | undefined;
}

export class CreateSelectionJobSearchDto implements ICreateSelectionJobSearchDto {
    selectionId!: number;
    jobExperiences!: CreateJobExperienceDto[] | undefined;
    contractTypeIds!: number[] | undefined;
    hourEffortId!: number | undefined;
    traineeshipAvailability!: boolean;
    shiftWorkAvailability!: boolean;
    businessTripAvailability!: boolean;
    timeAvailability!: CreateTimeAvailabilityDto;
    daysAvailabilityId!: number | undefined;

    constructor(data?: ICreateSelectionJobSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selectionId = _data["selectionId"];
            if (Array.isArray(_data["jobExperiences"])) {
                this.jobExperiences = [] as any;
                for (let item of _data["jobExperiences"])
                    this.jobExperiences!.push(CreateJobExperienceDto.fromJS(item));
            }
            if (Array.isArray(_data["contractTypeIds"])) {
                this.contractTypeIds = [] as any;
                for (let item of _data["contractTypeIds"])
                    this.contractTypeIds!.push(item);
            }
            this.hourEffortId = _data["hourEffortId"];
            this.traineeshipAvailability = _data["traineeshipAvailability"];
            this.shiftWorkAvailability = _data["shiftWorkAvailability"];
            this.businessTripAvailability = _data["businessTripAvailability"];
            this.timeAvailability = _data["timeAvailability"] ? CreateTimeAvailabilityDto.fromJS(_data["timeAvailability"]) : undefined as any;
            this.daysAvailabilityId = _data["daysAvailabilityId"];
        }
    }

    static fromJS(data: any): CreateSelectionJobSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSelectionJobSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selectionId"] = this.selectionId;
        if (Array.isArray(this.jobExperiences)) {
            data["jobExperiences"] = [];
            for (let item of this.jobExperiences)
                data["jobExperiences"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.contractTypeIds)) {
            data["contractTypeIds"] = [];
            for (let item of this.contractTypeIds)
                data["contractTypeIds"].push(item);
        }
        data["hourEffortId"] = this.hourEffortId;
        data["traineeshipAvailability"] = this.traineeshipAvailability;
        data["shiftWorkAvailability"] = this.shiftWorkAvailability;
        data["businessTripAvailability"] = this.businessTripAvailability;
        data["timeAvailability"] = this.timeAvailability ? this.timeAvailability.toJSON() : undefined as any;
        data["daysAvailabilityId"] = this.daysAvailabilityId;
        return data;
    }

    clone(): CreateSelectionJobSearchDto {
        const json = this.toJSON();
        let result = new CreateSelectionJobSearchDto();
        result.init(json);
        return result;
    }
}

export interface ICreateSelectionJobSearchDto {
    selectionId: number;
    jobExperiences: CreateJobExperienceDto[] | undefined;
    contractTypeIds: number[] | undefined;
    hourEffortId: number | undefined;
    traineeshipAvailability: boolean;
    shiftWorkAvailability: boolean;
    businessTripAvailability: boolean;
    timeAvailability: CreateTimeAvailabilityDto;
    daysAvailabilityId: number | undefined;
}

export class CreateSelectionLanguageDto implements ICreateSelectionLanguageDto {
    selectionId!: number;
    languageId!: number;
    spokenLevelId!: number;
    writtenLevelId!: number;
    listeningLevelId!: number;
    readingLevelId!: number;
    certificateId!: number | undefined;
    attested!: boolean;
    notes!: string | undefined;

    constructor(data?: ICreateSelectionLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selectionId = _data["selectionId"];
            this.languageId = _data["languageId"];
            this.spokenLevelId = _data["spokenLevelId"];
            this.writtenLevelId = _data["writtenLevelId"];
            this.listeningLevelId = _data["listeningLevelId"];
            this.readingLevelId = _data["readingLevelId"];
            this.certificateId = _data["certificateId"];
            this.attested = _data["attested"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): CreateSelectionLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSelectionLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selectionId"] = this.selectionId;
        data["languageId"] = this.languageId;
        data["spokenLevelId"] = this.spokenLevelId;
        data["writtenLevelId"] = this.writtenLevelId;
        data["listeningLevelId"] = this.listeningLevelId;
        data["readingLevelId"] = this.readingLevelId;
        data["certificateId"] = this.certificateId;
        data["attested"] = this.attested;
        data["notes"] = this.notes;
        return data;
    }

    clone(): CreateSelectionLanguageDto {
        const json = this.toJSON();
        let result = new CreateSelectionLanguageDto();
        result.init(json);
        return result;
    }
}

export interface ICreateSelectionLanguageDto {
    selectionId: number;
    languageId: number;
    spokenLevelId: number;
    writtenLevelId: number;
    listeningLevelId: number;
    readingLevelId: number;
    certificateId: number | undefined;
    attested: boolean;
    notes: string | undefined;
}

export class CreateSelectionQualificationDto implements ICreateSelectionQualificationDto {
    selectionId!: number;
    qualificationTypeId!: number;
    inProgress!: boolean;
    graduationDate!: moment.Moment | undefined;
    notes!: string | undefined;

    constructor(data?: ICreateSelectionQualificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selectionId = _data["selectionId"];
            this.qualificationTypeId = _data["qualificationTypeId"];
            this.inProgress = _data["inProgress"];
            this.graduationDate = _data["graduationDate"] ? moment(_data["graduationDate"].toString()) : undefined as any;
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): CreateSelectionQualificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSelectionQualificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selectionId"] = this.selectionId;
        data["qualificationTypeId"] = this.qualificationTypeId;
        data["inProgress"] = this.inProgress;
        data["graduationDate"] = this.graduationDate ? this.graduationDate.format('YYYY-MM-DD') : undefined as any;
        data["notes"] = this.notes;
        return data;
    }

    clone(): CreateSelectionQualificationDto {
        const json = this.toJSON();
        let result = new CreateSelectionQualificationDto();
        result.init(json);
        return result;
    }
}

export interface ICreateSelectionQualificationDto {
    selectionId: number;
    qualificationTypeId: number;
    inProgress: boolean;
    graduationDate: moment.Moment | undefined;
    notes: string | undefined;
}

export class CreateSILServiceOperativeUnitDto implements ICreateSILServiceOperativeUnitDto {
    operativeUnitId!: number;

    constructor(data?: ICreateSILServiceOperativeUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operativeUnitId = _data["operativeUnitId"];
        }
    }

    static fromJS(data: any): CreateSILServiceOperativeUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSILServiceOperativeUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operativeUnitId"] = this.operativeUnitId;
        return data;
    }

    clone(): CreateSILServiceOperativeUnitDto {
        const json = this.toJSON();
        let result = new CreateSILServiceOperativeUnitDto();
        result.init(json);
        return result;
    }
}

export interface ICreateSILServiceOperativeUnitDto {
    operativeUnitId: number;
}

export class CreateTenantDto implements ICreateTenantDto {
    tenancyName!: string;
    name!: string;
    adminEmailAddress!: string;
    connectionString!: string | undefined;
    isActive!: boolean;

    constructor(data?: ICreateTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): CreateTenantDto {
        const json = this.toJSON();
        let result = new CreateTenantDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean;
}

export class CreateTimeAvailabilityDto implements ICreateTimeAvailabilityDto {
    timeAvailabilitySlotId!: number | undefined;
    startTime!: moment.Moment | undefined;
    endTime!: moment.Moment | undefined;

    constructor(data?: ICreateTimeAvailabilityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeAvailabilitySlotId = _data["timeAvailabilitySlotId"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : undefined as any;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CreateTimeAvailabilityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTimeAvailabilityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeAvailabilitySlotId"] = this.timeAvailabilitySlotId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
        return data;
    }

    clone(): CreateTimeAvailabilityDto {
        const json = this.toJSON();
        let result = new CreateTimeAvailabilityDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTimeAvailabilityDto {
    timeAvailabilitySlotId: number | undefined;
    startTime: moment.Moment | undefined;
    endTime: moment.Moment | undefined;
}

export class CreateUserCertificationDto implements ICreateUserCertificationDto {
    userId!: number;
    title!: string;
    date!: moment.Moment | undefined;
    issuedBy!: string | undefined;
    description!: string | undefined;

    constructor(data?: ICreateUserCertificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.title = _data["title"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.issuedBy = _data["issuedBy"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateUserCertificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserCertificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["title"] = this.title;
        data["date"] = this.date ? this.date.format('YYYY-MM-DD') : undefined as any;
        data["issuedBy"] = this.issuedBy;
        data["description"] = this.description;
        return data;
    }

    clone(): CreateUserCertificationDto {
        const json = this.toJSON();
        let result = new CreateUserCertificationDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserCertificationDto {
    userId: number;
    title: string;
    date: moment.Moment | undefined;
    issuedBy: string | undefined;
    description: string | undefined;
}

export class CreateUserComputerSkillDto implements ICreateUserComputerSkillDto {
    userId!: number;
    computerSkillId!: number;
    notes!: string | undefined;

    constructor(data?: ICreateUserComputerSkillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.computerSkillId = _data["computerSkillId"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): CreateUserComputerSkillDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserComputerSkillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["computerSkillId"] = this.computerSkillId;
        data["notes"] = this.notes;
        return data;
    }

    clone(): CreateUserComputerSkillDto {
        const json = this.toJSON();
        let result = new CreateUserComputerSkillDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserComputerSkillDto {
    userId: number;
    computerSkillId: number;
    notes: string | undefined;
}

export class CreateUserDisabilityDto implements ICreateUserDisabilityDto {
    protectedCategory!: boolean;
    placementRegistration!: boolean | undefined;
    userId!: number;
    isArt1!: boolean | undefined;
    isArt18!: boolean | undefined;
    art1DisabilityPercentage!: number | undefined;
    disabilityTypeId!: number | undefined;
    art18TypeId!: number | undefined;
    certifiedInstitution!: string | undefined;
    law381Disadvantage!: boolean | undefined;
    notes!: string | undefined;

    constructor(data?: ICreateUserDisabilityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.protectedCategory = _data["protectedCategory"];
            this.placementRegistration = _data["placementRegistration"];
            this.userId = _data["userId"];
            this.isArt1 = _data["isArt1"];
            this.isArt18 = _data["isArt18"];
            this.art1DisabilityPercentage = _data["art1DisabilityPercentage"];
            this.disabilityTypeId = _data["disabilityTypeId"];
            this.art18TypeId = _data["art18TypeId"];
            this.certifiedInstitution = _data["certifiedInstitution"];
            this.law381Disadvantage = _data["law381Disadvantage"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): CreateUserDisabilityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDisabilityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["protectedCategory"] = this.protectedCategory;
        data["placementRegistration"] = this.placementRegistration;
        data["userId"] = this.userId;
        data["isArt1"] = this.isArt1;
        data["isArt18"] = this.isArt18;
        data["art1DisabilityPercentage"] = this.art1DisabilityPercentage;
        data["disabilityTypeId"] = this.disabilityTypeId;
        data["art18TypeId"] = this.art18TypeId;
        data["certifiedInstitution"] = this.certifiedInstitution;
        data["law381Disadvantage"] = this.law381Disadvantage;
        data["notes"] = this.notes;
        return data;
    }

    clone(): CreateUserDisabilityDto {
        const json = this.toJSON();
        let result = new CreateUserDisabilityDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserDisabilityDto {
    protectedCategory: boolean;
    placementRegistration: boolean | undefined;
    userId: number;
    isArt1: boolean | undefined;
    isArt18: boolean | undefined;
    art1DisabilityPercentage: number | undefined;
    disabilityTypeId: number | undefined;
    art18TypeId: number | undefined;
    certifiedInstitution: string | undefined;
    law381Disadvantage: boolean | undefined;
    notes: string | undefined;
}

export class CreateUserDto implements ICreateUserDto {
    name!: string;
    surname!: string | undefined;
    emailAddress!: string;
    phoneNumber!: string | undefined;
    isActive!: boolean;
    roleNames!: string[] | undefined;
    fiscalCode!: string | undefined;
    operativeUnitIds!: number[] | undefined;
    birthDate!: moment.Moment | undefined;
    birthPlace!: string | undefined;
    genderId!: number | undefined;
    address!: CreateAddressDto;
    nationalityId!: number | undefined;
    businessName!: string | undefined;
    registeredOffice!: CreateAddressDto;
    vatNumber!: string | undefined;
    pec!: string | undefined;
    conventions!: CreateConventionDto[] | undefined;
    companyOrderCodeIds!: number[] | undefined;
    employeesId!: number | undefined;
    salesId!: number | undefined;
    salesLastYearId!: number | undefined;
    activityDescription!: string | undefined;
    telematicIdentificationCode!: string | undefined;
    businessSector!: number | undefined;
    partnerTypeId!: number | undefined;
    operativeOffices!: CreateAddressDto[] | undefined;
    legalObbligation68!: boolean | undefined;
    theseObbligation!: string | undefined;
    discoveriesNumber!: string | undefined;
    notes!: CreateNotesDto[] | undefined;
    atecoCodeIds!: number[] | undefined;
    laborConsultantId!: number | undefined;

    constructor(data?: ICreateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames!.push(item);
            }
            this.fiscalCode = _data["fiscalCode"];
            if (Array.isArray(_data["operativeUnitIds"])) {
                this.operativeUnitIds = [] as any;
                for (let item of _data["operativeUnitIds"])
                    this.operativeUnitIds!.push(item);
            }
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : undefined as any;
            this.birthPlace = _data["birthPlace"];
            this.genderId = _data["genderId"];
            this.address = _data["address"] ? CreateAddressDto.fromJS(_data["address"]) : undefined as any;
            this.nationalityId = _data["nationalityId"];
            this.businessName = _data["businessName"];
            this.registeredOffice = _data["registeredOffice"] ? CreateAddressDto.fromJS(_data["registeredOffice"]) : undefined as any;
            this.vatNumber = _data["vatNumber"];
            this.pec = _data["pec"];
            if (Array.isArray(_data["conventions"])) {
                this.conventions = [] as any;
                for (let item of _data["conventions"])
                    this.conventions!.push(CreateConventionDto.fromJS(item));
            }
            if (Array.isArray(_data["companyOrderCodeIds"])) {
                this.companyOrderCodeIds = [] as any;
                for (let item of _data["companyOrderCodeIds"])
                    this.companyOrderCodeIds!.push(item);
            }
            this.employeesId = _data["employeesId"];
            this.salesId = _data["salesId"];
            this.salesLastYearId = _data["salesLastYearId"];
            this.activityDescription = _data["activityDescription"];
            this.telematicIdentificationCode = _data["telematicIdentificationCode"];
            this.businessSector = _data["businessSector"];
            this.partnerTypeId = _data["partnerTypeId"];
            if (Array.isArray(_data["operativeOffices"])) {
                this.operativeOffices = [] as any;
                for (let item of _data["operativeOffices"])
                    this.operativeOffices!.push(CreateAddressDto.fromJS(item));
            }
            this.legalObbligation68 = _data["legalObbligation68"];
            this.theseObbligation = _data["theseObbligation"];
            this.discoveriesNumber = _data["discoveriesNumber"];
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(CreateNotesDto.fromJS(item));
            }
            if (Array.isArray(_data["atecoCodeIds"])) {
                this.atecoCodeIds = [] as any;
                for (let item of _data["atecoCodeIds"])
                    this.atecoCodeIds!.push(item);
            }
            this.laborConsultantId = _data["laborConsultantId"];
        }
    }

    static fromJS(data: any): CreateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["fiscalCode"] = this.fiscalCode;
        if (Array.isArray(this.operativeUnitIds)) {
            data["operativeUnitIds"] = [];
            for (let item of this.operativeUnitIds)
                data["operativeUnitIds"].push(item);
        }
        data["birthDate"] = this.birthDate ? this.birthDate.format('YYYY-MM-DD') : undefined as any;
        data["birthPlace"] = this.birthPlace;
        data["genderId"] = this.genderId;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["nationalityId"] = this.nationalityId;
        data["businessName"] = this.businessName;
        data["registeredOffice"] = this.registeredOffice ? this.registeredOffice.toJSON() : undefined as any;
        data["vatNumber"] = this.vatNumber;
        data["pec"] = this.pec;
        if (Array.isArray(this.conventions)) {
            data["conventions"] = [];
            for (let item of this.conventions)
                data["conventions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.companyOrderCodeIds)) {
            data["companyOrderCodeIds"] = [];
            for (let item of this.companyOrderCodeIds)
                data["companyOrderCodeIds"].push(item);
        }
        data["employeesId"] = this.employeesId;
        data["salesId"] = this.salesId;
        data["salesLastYearId"] = this.salesLastYearId;
        data["activityDescription"] = this.activityDescription;
        data["telematicIdentificationCode"] = this.telematicIdentificationCode;
        data["businessSector"] = this.businessSector;
        data["partnerTypeId"] = this.partnerTypeId;
        if (Array.isArray(this.operativeOffices)) {
            data["operativeOffices"] = [];
            for (let item of this.operativeOffices)
                data["operativeOffices"].push(item ? item.toJSON() : undefined as any);
        }
        data["legalObbligation68"] = this.legalObbligation68;
        data["theseObbligation"] = this.theseObbligation;
        data["discoveriesNumber"] = this.discoveriesNumber;
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.atecoCodeIds)) {
            data["atecoCodeIds"] = [];
            for (let item of this.atecoCodeIds)
                data["atecoCodeIds"].push(item);
        }
        data["laborConsultantId"] = this.laborConsultantId;
        return data;
    }

    clone(): CreateUserDto {
        const json = this.toJSON();
        let result = new CreateUserDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserDto {
    name: string;
    surname: string | undefined;
    emailAddress: string;
    phoneNumber: string | undefined;
    isActive: boolean;
    roleNames: string[] | undefined;
    fiscalCode: string | undefined;
    operativeUnitIds: number[] | undefined;
    birthDate: moment.Moment | undefined;
    birthPlace: string | undefined;
    genderId: number | undefined;
    address: CreateAddressDto;
    nationalityId: number | undefined;
    businessName: string | undefined;
    registeredOffice: CreateAddressDto;
    vatNumber: string | undefined;
    pec: string | undefined;
    conventions: CreateConventionDto[] | undefined;
    companyOrderCodeIds: number[] | undefined;
    employeesId: number | undefined;
    salesId: number | undefined;
    salesLastYearId: number | undefined;
    activityDescription: string | undefined;
    telematicIdentificationCode: string | undefined;
    businessSector: number | undefined;
    partnerTypeId: number | undefined;
    operativeOffices: CreateAddressDto[] | undefined;
    legalObbligation68: boolean | undefined;
    theseObbligation: string | undefined;
    discoveriesNumber: string | undefined;
    notes: CreateNotesDto[] | undefined;
    atecoCodeIds: number[] | undefined;
    laborConsultantId: number | undefined;
}

export class CreateUserEducationDto implements ICreateUserEducationDto {
    userId!: number;
    educationalDegreeLevelId!: number;
    educationalDegreeId!: number | undefined;
    titleRecognitionId!: number;
    nationId!: number;
    institute!: string | undefined;
    graduationDate!: moment.Moment;
    other!: string | undefined;

    constructor(data?: ICreateUserEducationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.educationalDegreeLevelId = _data["educationalDegreeLevelId"];
            this.educationalDegreeId = _data["educationalDegreeId"];
            this.titleRecognitionId = _data["titleRecognitionId"];
            this.nationId = _data["nationId"];
            this.institute = _data["institute"];
            this.graduationDate = _data["graduationDate"] ? moment(_data["graduationDate"].toString()) : undefined as any;
            this.other = _data["other"];
        }
    }

    static fromJS(data: any): CreateUserEducationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserEducationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["educationalDegreeLevelId"] = this.educationalDegreeLevelId;
        data["educationalDegreeId"] = this.educationalDegreeId;
        data["titleRecognitionId"] = this.titleRecognitionId;
        data["nationId"] = this.nationId;
        data["institute"] = this.institute;
        data["graduationDate"] = this.graduationDate ? this.graduationDate.format('YYYY-MM-DD') : undefined as any;
        data["other"] = this.other;
        return data;
    }

    clone(): CreateUserEducationDto {
        const json = this.toJSON();
        let result = new CreateUserEducationDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserEducationDto {
    userId: number;
    educationalDegreeLevelId: number;
    educationalDegreeId: number | undefined;
    titleRecognitionId: number;
    nationId: number;
    institute: string | undefined;
    graduationDate: moment.Moment;
    other: string | undefined;
}

export class CreateUserJobDto implements ICreateUserJobDto {
    userId!: number;
    jobId!: number;
    contractTypeId!: number;
    startDate!: moment.Moment;
    endDate!: moment.Moment | undefined;
    inProgress!: boolean;
    employer!: string | undefined;

    constructor(data?: ICreateUserJobDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.jobId = _data["jobId"];
            this.contractTypeId = _data["contractTypeId"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : undefined as any;
            this.inProgress = _data["inProgress"];
            this.employer = _data["employer"];
        }
    }

    static fromJS(data: any): CreateUserJobDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserJobDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["jobId"] = this.jobId;
        data["contractTypeId"] = this.contractTypeId;
        data["startDate"] = this.startDate ? this.startDate.format('YYYY-MM-DD') : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.format('YYYY-MM-DD') : undefined as any;
        data["inProgress"] = this.inProgress;
        data["employer"] = this.employer;
        return data;
    }

    clone(): CreateUserJobDto {
        const json = this.toJSON();
        let result = new CreateUserJobDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserJobDto {
    userId: number;
    jobId: number;
    contractTypeId: number;
    startDate: moment.Moment;
    endDate: moment.Moment | undefined;
    inProgress: boolean;
    employer: string | undefined;
}

export class CreateUserLanguageDto implements ICreateUserLanguageDto {
    userId!: number;
    languageId!: number;
    spokenLevelId!: number;
    writtenLevelId!: number;
    listeningLevelId!: number;
    readingLevelId!: number;
    certificateId!: number | undefined;
    attested!: boolean;
    notes!: string | undefined;

    constructor(data?: ICreateUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.languageId = _data["languageId"];
            this.spokenLevelId = _data["spokenLevelId"];
            this.writtenLevelId = _data["writtenLevelId"];
            this.listeningLevelId = _data["listeningLevelId"];
            this.readingLevelId = _data["readingLevelId"];
            this.certificateId = _data["certificateId"];
            this.attested = _data["attested"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): CreateUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["languageId"] = this.languageId;
        data["spokenLevelId"] = this.spokenLevelId;
        data["writtenLevelId"] = this.writtenLevelId;
        data["listeningLevelId"] = this.listeningLevelId;
        data["readingLevelId"] = this.readingLevelId;
        data["certificateId"] = this.certificateId;
        data["attested"] = this.attested;
        data["notes"] = this.notes;
        return data;
    }

    clone(): CreateUserLanguageDto {
        const json = this.toJSON();
        let result = new CreateUserLanguageDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserLanguageDto {
    userId: number;
    languageId: number;
    spokenLevelId: number;
    writtenLevelId: number;
    listeningLevelId: number;
    readingLevelId: number;
    certificateId: number | undefined;
    attested: boolean;
    notes: string | undefined;
}

export class CreateUserNoteDto implements ICreateUserNoteDto {
    userId!: number;
    note!: string;
    date!: moment.Moment;

    constructor(data?: ICreateUserNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.note = _data["note"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CreateUserNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["note"] = this.note;
        data["date"] = this.date ? this.date.format('YYYY-MM-DD') : undefined as any;
        return data;
    }

    clone(): CreateUserNoteDto {
        const json = this.toJSON();
        let result = new CreateUserNoteDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserNoteDto {
    userId: number;
    note: string;
    date: moment.Moment;
}

export class CreateUserQualificationDto implements ICreateUserQualificationDto {
    userId!: number;
    qualificationTypeId!: number;
    inProgress!: boolean;
    graduationDate!: moment.Moment | undefined;
    notes!: string | undefined;

    constructor(data?: ICreateUserQualificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.qualificationTypeId = _data["qualificationTypeId"];
            this.inProgress = _data["inProgress"];
            this.graduationDate = _data["graduationDate"] ? moment(_data["graduationDate"].toString()) : undefined as any;
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): CreateUserQualificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserQualificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["qualificationTypeId"] = this.qualificationTypeId;
        data["inProgress"] = this.inProgress;
        data["graduationDate"] = this.graduationDate ? this.graduationDate.format('YYYY-MM-DD') : undefined as any;
        data["notes"] = this.notes;
        return data;
    }

    clone(): CreateUserQualificationDto {
        const json = this.toJSON();
        let result = new CreateUserQualificationDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserQualificationDto {
    userId: number;
    qualificationTypeId: number;
    inProgress: boolean;
    graduationDate: moment.Moment | undefined;
    notes: string | undefined;
}

export class CreateUserSafetyTrainingDto implements ICreateUserSafetyTrainingDto {
    userId!: number;
    safetyTrainingTypeId!: number;
    date!: moment.Moment;

    constructor(data?: ICreateUserSafetyTrainingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.safetyTrainingTypeId = _data["safetyTrainingTypeId"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CreateUserSafetyTrainingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserSafetyTrainingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["safetyTrainingTypeId"] = this.safetyTrainingTypeId;
        data["date"] = this.date ? this.date.format('YYYY-MM-DD') : undefined as any;
        return data;
    }

    clone(): CreateUserSafetyTrainingDto {
        const json = this.toJSON();
        let result = new CreateUserSafetyTrainingDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserSafetyTrainingDto {
    userId: number;
    safetyTrainingTypeId: number;
    date: moment.Moment;
}

export class CreateUserSurveyDto implements ICreateUserSurveyDto {
    userId!: number;
    cvWritingSupportServices!: number;
    jobInterviewPreparation!: number;
    careerEducationGuidanceCounseling!: number;
    workshopsActiveJobSearching!: number;
    trainingCourses!: number;
    informationMeetingsOnTheJobMarket!: number;

    constructor(data?: ICreateUserSurveyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.cvWritingSupportServices = _data["cvWritingSupportServices"];
            this.jobInterviewPreparation = _data["jobInterviewPreparation"];
            this.careerEducationGuidanceCounseling = _data["careerEducationGuidanceCounseling"];
            this.workshopsActiveJobSearching = _data["workshopsActiveJobSearching"];
            this.trainingCourses = _data["trainingCourses"];
            this.informationMeetingsOnTheJobMarket = _data["informationMeetingsOnTheJobMarket"];
        }
    }

    static fromJS(data: any): CreateUserSurveyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserSurveyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["cvWritingSupportServices"] = this.cvWritingSupportServices;
        data["jobInterviewPreparation"] = this.jobInterviewPreparation;
        data["careerEducationGuidanceCounseling"] = this.careerEducationGuidanceCounseling;
        data["workshopsActiveJobSearching"] = this.workshopsActiveJobSearching;
        data["trainingCourses"] = this.trainingCourses;
        data["informationMeetingsOnTheJobMarket"] = this.informationMeetingsOnTheJobMarket;
        return data;
    }

    clone(): CreateUserSurveyDto {
        const json = this.toJSON();
        let result = new CreateUserSurveyDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserSurveyDto {
    userId: number;
    cvWritingSupportServices: number;
    jobInterviewPreparation: number;
    careerEducationGuidanceCounseling: number;
    workshopsActiveJobSearching: number;
    trainingCourses: number;
    informationMeetingsOnTheJobMarket: number;
}

export class CreateUserTrainingCourseDto implements ICreateUserTrainingCourseDto {
    userId!: number;
    title!: string;
    institute!: string;
    achievementYear!: moment.Moment | undefined;
    courseHours!: number | undefined;
    certificateId!: number | undefined;
    attested!: boolean;

    constructor(data?: ICreateUserTrainingCourseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.title = _data["title"];
            this.institute = _data["institute"];
            this.achievementYear = _data["achievementYear"] ? moment(_data["achievementYear"].toString()) : undefined as any;
            this.courseHours = _data["courseHours"];
            this.certificateId = _data["certificateId"];
            this.attested = _data["attested"];
        }
    }

    static fromJS(data: any): CreateUserTrainingCourseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserTrainingCourseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["title"] = this.title;
        data["institute"] = this.institute;
        data["achievementYear"] = this.achievementYear ? this.achievementYear.format('YYYY-MM-DD') : undefined as any;
        data["courseHours"] = this.courseHours;
        data["certificateId"] = this.certificateId;
        data["attested"] = this.attested;
        return data;
    }

    clone(): CreateUserTrainingCourseDto {
        const json = this.toJSON();
        let result = new CreateUserTrainingCourseDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserTrainingCourseDto {
    userId: number;
    title: string;
    institute: string;
    achievementYear: moment.Moment | undefined;
    courseHours: number | undefined;
    certificateId: number | undefined;
    attested: boolean;
}

export class CreateUserTrainingCourseInterestDto implements ICreateUserTrainingCourseInterestDto {
    userId!: number;
    businessSectorId!: number;
    areaOfInterest!: string | undefined;
    operativeUnitIds!: number[];
    fruitionTypeId!: number;
    isInterestedInSelfFinancedCourse!: boolean;

    constructor(data?: ICreateUserTrainingCourseInterestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.operativeUnitIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.businessSectorId = _data["businessSectorId"];
            this.areaOfInterest = _data["areaOfInterest"];
            if (Array.isArray(_data["operativeUnitIds"])) {
                this.operativeUnitIds = [] as any;
                for (let item of _data["operativeUnitIds"])
                    this.operativeUnitIds!.push(item);
            }
            this.fruitionTypeId = _data["fruitionTypeId"];
            this.isInterestedInSelfFinancedCourse = _data["isInterestedInSelfFinancedCourse"];
        }
    }

    static fromJS(data: any): CreateUserTrainingCourseInterestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserTrainingCourseInterestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["businessSectorId"] = this.businessSectorId;
        data["areaOfInterest"] = this.areaOfInterest;
        if (Array.isArray(this.operativeUnitIds)) {
            data["operativeUnitIds"] = [];
            for (let item of this.operativeUnitIds)
                data["operativeUnitIds"].push(item);
        }
        data["fruitionTypeId"] = this.fruitionTypeId;
        data["isInterestedInSelfFinancedCourse"] = this.isInterestedInSelfFinancedCourse;
        return data;
    }

    clone(): CreateUserTrainingCourseInterestDto {
        const json = this.toJSON();
        let result = new CreateUserTrainingCourseInterestDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserTrainingCourseInterestDto {
    userId: number;
    businessSectorId: number;
    areaOfInterest: string | undefined;
    operativeUnitIds: number[];
    fruitionTypeId: number;
    isInterestedInSelfFinancedCourse: boolean;
}

export class CreateUserTrainingCourseInterestOperativeUnitDto implements ICreateUserTrainingCourseInterestOperativeUnitDto {
    userTrainingCourseInterestId!: number | undefined;
    operativeUnitId!: number | undefined;

    constructor(data?: ICreateUserTrainingCourseInterestOperativeUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userTrainingCourseInterestId = _data["userTrainingCourseInterestId"];
            this.operativeUnitId = _data["operativeUnitId"];
        }
    }

    static fromJS(data: any): CreateUserTrainingCourseInterestOperativeUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserTrainingCourseInterestOperativeUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userTrainingCourseInterestId"] = this.userTrainingCourseInterestId;
        data["operativeUnitId"] = this.operativeUnitId;
        return data;
    }

    clone(): CreateUserTrainingCourseInterestOperativeUnitDto {
        const json = this.toJSON();
        let result = new CreateUserTrainingCourseInterestOperativeUnitDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserTrainingCourseInterestOperativeUnitDto {
    userTrainingCourseInterestId: number | undefined;
    operativeUnitId: number | undefined;
}

export class CreateUserTransversalSkillDto implements ICreateUserTransversalSkillDto {
    usertId!: number;
    description!: string | undefined;
    levelId!: number | undefined;

    constructor(data?: ICreateUserTransversalSkillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.usertId = _data["usertId"];
            this.description = _data["description"];
            this.levelId = _data["levelId"];
        }
    }

    static fromJS(data: any): CreateUserTransversalSkillDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserTransversalSkillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["usertId"] = this.usertId;
        data["description"] = this.description;
        data["levelId"] = this.levelId;
        return data;
    }

    clone(): CreateUserTransversalSkillDto {
        const json = this.toJSON();
        let result = new CreateUserTransversalSkillDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserTransversalSkillDto {
    usertId: number;
    description: string | undefined;
    levelId: number | undefined;
}

export class DictionaryDto implements IDictionaryDto {
    id!: number;
    description!: string | undefined;
    staticCode!: string | undefined;

    constructor(data?: IDictionaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.staticCode = _data["staticCode"];
        }
    }

    static fromJS(data: any): DictionaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new DictionaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["staticCode"] = this.staticCode;
        return data;
    }

    clone(): DictionaryDto {
        const json = this.toJSON();
        let result = new DictionaryDto();
        result.init(json);
        return result;
    }
}

export interface IDictionaryDto {
    id: number;
    description: string | undefined;
    staticCode: string | undefined;
}

export class EducationalDegreeDto implements IEducationalDegreeDto {
    id!: number;
    description!: string | undefined;
    staticCode!: string | undefined;
    educationalDegreeLevel!: DictionaryDto;

    constructor(data?: IEducationalDegreeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.staticCode = _data["staticCode"];
            this.educationalDegreeLevel = _data["educationalDegreeLevel"] ? DictionaryDto.fromJS(_data["educationalDegreeLevel"]) : undefined as any;
        }
    }

    static fromJS(data: any): EducationalDegreeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EducationalDegreeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["staticCode"] = this.staticCode;
        data["educationalDegreeLevel"] = this.educationalDegreeLevel ? this.educationalDegreeLevel.toJSON() : undefined as any;
        return data;
    }

    clone(): EducationalDegreeDto {
        const json = this.toJSON();
        let result = new EducationalDegreeDto();
        result.init(json);
        return result;
    }
}

export interface IEducationalDegreeDto {
    id: number;
    description: string | undefined;
    staticCode: string | undefined;
    educationalDegreeLevel: DictionaryDto;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider!: string;
    providerKey!: string;
    providerAccessCode!: string;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authProvider = _data["authProvider"];
            this.providerKey = _data["providerKey"];
            this.providerAccessCode = _data["providerAccessCode"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        return data;
    }

    clone(): ExternalAuthenticateModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;
    waitingForActivation!: boolean;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.waitingForActivation = _data["waitingForActivation"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["waitingForActivation"] = this.waitingForActivation;
        return data;
    }

    clone(): ExternalAuthenticateResultModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name!: string | undefined;
    clientId!: string | undefined;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        return data;
    }

    clone(): ExternalLoginProviderInfoModel {
        const json = this.toJSON();
        let result = new ExternalLoginProviderInfoModel();
        result.init(json);
        return result;
    }
}

export interface IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;
}

export class FileDownloadDto implements IFileDownloadDto {
    id!: number;
    fileName!: string | undefined;
    mimeType!: string | undefined;
    size!: number;
    byteArray!: string | undefined;

    constructor(data?: IFileDownloadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.mimeType = _data["mimeType"];
            this.size = _data["size"];
            this.byteArray = _data["byteArray"];
        }
    }

    static fromJS(data: any): FileDownloadDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDownloadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["mimeType"] = this.mimeType;
        data["size"] = this.size;
        data["byteArray"] = this.byteArray;
        return data;
    }

    clone(): FileDownloadDto {
        const json = this.toJSON();
        let result = new FileDownloadDto();
        result.init(json);
        return result;
    }
}

export interface IFileDownloadDto {
    id: number;
    fileName: string | undefined;
    mimeType: string | undefined;
    size: number;
    byteArray: string | undefined;
}

export class FileDto implements IFileDto {
    id!: number;
    mask!: string | undefined;
    name!: string | undefined;
    extension!: string | undefined;
    mimeType!: string | undefined;
    size!: number;
    signedUrl!: string | undefined;
    fileType!: DictionaryDto;
    expireDate!: moment.Moment | undefined;
    creationTime!: moment.Moment;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mask = _data["mask"];
            this.name = _data["name"];
            this.extension = _data["extension"];
            this.mimeType = _data["mimeType"];
            this.size = _data["size"];
            this.signedUrl = _data["signedUrl"];
            this.fileType = _data["fileType"] ? DictionaryDto.fromJS(_data["fileType"]) : undefined as any;
            this.expireDate = _data["expireDate"] ? moment(_data["expireDate"].toString()) : undefined as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mask"] = this.mask;
        data["name"] = this.name;
        data["extension"] = this.extension;
        data["mimeType"] = this.mimeType;
        data["size"] = this.size;
        data["signedUrl"] = this.signedUrl;
        data["fileType"] = this.fileType ? this.fileType.toJSON() : undefined as any;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : undefined as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        return data;
    }

    clone(): FileDto {
        const json = this.toJSON();
        let result = new FileDto();
        result.init(json);
        return result;
    }
}

export interface IFileDto {
    id: number;
    mask: string | undefined;
    name: string | undefined;
    extension: string | undefined;
    mimeType: string | undefined;
    size: number;
    signedUrl: string | undefined;
    fileType: DictionaryDto;
    expireDate: moment.Moment | undefined;
    creationTime: moment.Moment;
}

export class FileDtoPagedResultDto implements IFileDtoPagedResultDto {
    items!: FileDto[] | undefined;
    totalCount!: number;

    constructor(data?: IFileDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FileDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): FileDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): FileDtoPagedResultDto {
        const json = this.toJSON();
        let result = new FileDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IFileDtoPagedResultDto {
    items: FileDto[] | undefined;
    totalCount: number;
}

export class FileExcelDto implements IFileExcelDto {
    fileName!: string | undefined;
    fileData!: string | undefined;
    mimeType!: string | undefined;

    constructor(data?: IFileExcelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileData = _data["fileData"];
            this.mimeType = _data["mimeType"];
        }
    }

    static fromJS(data: any): FileExcelDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileExcelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileData"] = this.fileData;
        data["mimeType"] = this.mimeType;
        return data;
    }

    clone(): FileExcelDto {
        const json = this.toJSON();
        let result = new FileExcelDto();
        result.init(json);
        return result;
    }
}

export interface IFileExcelDto {
    fileName: string | undefined;
    fileData: string | undefined;
    mimeType: string | undefined;
}

export class FileExtendedDto implements IFileExtendedDto {
    byteArray!: string | undefined;
    signedUrl!: string | undefined;

    constructor(data?: IFileExtendedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.byteArray = _data["byteArray"];
            this.signedUrl = _data["signedUrl"];
        }
    }

    static fromJS(data: any): FileExtendedDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileExtendedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["byteArray"] = this.byteArray;
        data["signedUrl"] = this.signedUrl;
        return data;
    }

    clone(): FileExtendedDto {
        const json = this.toJSON();
        let result = new FileExtendedDto();
        result.init(json);
        return result;
    }
}

export interface IFileExtendedDto {
    byteArray: string | undefined;
    signedUrl: string | undefined;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data;
    }

    clone(): FlatPermissionDto {
        const json = this.toJSON();
        let result = new FlatPermissionDto();
        result.init(json);
        return result;
    }
}

export interface IFlatPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
}

export class ForceResetPasswordDto implements IForceResetPasswordDto {
    adminPassword!: string;
    userId!: number;
    newPassword!: string;

    constructor(data?: IForceResetPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adminPassword = _data["adminPassword"];
            this.userId = _data["userId"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ForceResetPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ForceResetPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminPassword"] = this.adminPassword;
        data["userId"] = this.userId;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ForceResetPasswordDto {
        const json = this.toJSON();
        let result = new ForceResetPasswordDto();
        result.init(json);
        return result;
    }
}

export interface IForceResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string;
}

export class ForgotPasswordDto implements IForgotPasswordDto {
    emailAddress!: string;

    constructor(data?: IForgotPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): ForgotPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }

    clone(): ForgotPasswordDto {
        const json = this.toJSON();
        let result = new ForgotPasswordDto();
        result.init(json);
        return result;
    }
}

export interface IForgotPasswordDto {
    emailAddress: string;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    application!: ApplicationInfoDto;
    user!: UserLoginInfoDto;
    tenant!: TenantLoginInfoDto;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : undefined as any;
            this.user = _data["user"] ? UserLoginInfoDto.fromJS(_data["user"]) : undefined as any;
            this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : undefined as any;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : undefined as any;
        return data;
    }

    clone(): GetCurrentLoginInformationsOutput {
        const json = this.toJSON();
        let result = new GetCurrentLoginInformationsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role!: RoleEditDto;
    permissions!: FlatPermissionDto[] | undefined;
    grantedPermissionNames!: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : undefined as any;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : undefined as any;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }

    clone(): GetRoleForEditOutput {
        const json = this.toJSON();
        let result = new GetRoleForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class IdentityError implements IIdentityError {
    code!: string | undefined;
    description!: string | undefined;

    constructor(data?: IIdentityError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): IdentityError {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }

    clone(): IdentityError {
        const json = this.toJSON();
        let result = new IdentityError();
        result.init(json);
        return result;
    }
}

export interface IIdentityError {
    code: string | undefined;
    description: string | undefined;
}

export class IdentityResult implements IIdentityResult {
    readonly succeeded!: boolean;
    readonly errors!: IdentityError[] | undefined;

    constructor(data?: IIdentityResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                (this as any).errors = [] as any;
                for (let item of _data["errors"])
                    (this as any).errors!.push(IdentityError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IdentityResult {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): IdentityResult {
        const json = this.toJSON();
        let result = new IdentityResult();
        result.init(json);
        return result;
    }
}

export interface IIdentityResult {
    succeeded: boolean;
    errors: IdentityError[] | undefined;
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName!: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data;
    }

    clone(): IsTenantAvailableInput {
        const json = this.toJSON();
        let result = new IsTenantAvailableInput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string;
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state!: TenantAvailabilityState;
    tenantId!: number | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): IsTenantAvailableOutput {
        const json = this.toJSON();
        let result = new IsTenantAvailableOutput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;
}

export class JobExperienceDto implements IJobExperienceDto {
    id!: number;
    job!: DictionaryDto;
    hasExperience!: boolean;

    constructor(data?: IJobExperienceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.job = _data["job"] ? DictionaryDto.fromJS(_data["job"]) : undefined as any;
            this.hasExperience = _data["hasExperience"];
        }
    }

    static fromJS(data: any): JobExperienceDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobExperienceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["job"] = this.job ? this.job.toJSON() : undefined as any;
        data["hasExperience"] = this.hasExperience;
        return data;
    }

    clone(): JobExperienceDto {
        const json = this.toJSON();
        let result = new JobExperienceDto();
        result.init(json);
        return result;
    }
}

export interface IJobExperienceDto {
    id: number;
    job: DictionaryDto;
    hasExperience: boolean;
}

export class JobSearchDto implements IJobSearchDto {
    id!: number;
    user!: UserDto;
    jobExperiences!: JobExperienceDto[] | undefined;
    contractTypes!: DictionaryDto[] | undefined;
    hourEffort!: DictionaryDto;
    traineeshipAvailability!: boolean | undefined;
    shiftWorkAvailability!: boolean | undefined;
    businessTripAvailability!: boolean | undefined;
    timeAvailability!: TimeAvailabilityDto;
    daysAvailability!: DictionaryDto;

    constructor(data?: IJobSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : undefined as any;
            if (Array.isArray(_data["jobExperiences"])) {
                this.jobExperiences = [] as any;
                for (let item of _data["jobExperiences"])
                    this.jobExperiences!.push(JobExperienceDto.fromJS(item));
            }
            if (Array.isArray(_data["contractTypes"])) {
                this.contractTypes = [] as any;
                for (let item of _data["contractTypes"])
                    this.contractTypes!.push(DictionaryDto.fromJS(item));
            }
            this.hourEffort = _data["hourEffort"] ? DictionaryDto.fromJS(_data["hourEffort"]) : undefined as any;
            this.traineeshipAvailability = _data["traineeshipAvailability"];
            this.shiftWorkAvailability = _data["shiftWorkAvailability"];
            this.businessTripAvailability = _data["businessTripAvailability"];
            this.timeAvailability = _data["timeAvailability"] ? TimeAvailabilityDto.fromJS(_data["timeAvailability"]) : undefined as any;
            this.daysAvailability = _data["daysAvailability"] ? DictionaryDto.fromJS(_data["daysAvailability"]) : undefined as any;
        }
    }

    static fromJS(data: any): JobSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        if (Array.isArray(this.jobExperiences)) {
            data["jobExperiences"] = [];
            for (let item of this.jobExperiences)
                data["jobExperiences"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.contractTypes)) {
            data["contractTypes"] = [];
            for (let item of this.contractTypes)
                data["contractTypes"].push(item ? item.toJSON() : undefined as any);
        }
        data["hourEffort"] = this.hourEffort ? this.hourEffort.toJSON() : undefined as any;
        data["traineeshipAvailability"] = this.traineeshipAvailability;
        data["shiftWorkAvailability"] = this.shiftWorkAvailability;
        data["businessTripAvailability"] = this.businessTripAvailability;
        data["timeAvailability"] = this.timeAvailability ? this.timeAvailability.toJSON() : undefined as any;
        data["daysAvailability"] = this.daysAvailability ? this.daysAvailability.toJSON() : undefined as any;
        return data;
    }

    clone(): JobSearchDto {
        const json = this.toJSON();
        let result = new JobSearchDto();
        result.init(json);
        return result;
    }
}

export interface IJobSearchDto {
    id: number;
    user: UserDto;
    jobExperiences: JobExperienceDto[] | undefined;
    contractTypes: DictionaryDto[] | undefined;
    hourEffort: DictionaryDto;
    traineeshipAvailability: boolean | undefined;
    shiftWorkAvailability: boolean | undefined;
    businessTripAvailability: boolean | undefined;
    timeAvailability: TimeAvailabilityDto;
    daysAvailability: DictionaryDto;
}

export class JobSearchDtoPagedResultDto implements IJobSearchDtoPagedResultDto {
    items!: JobSearchDto[] | undefined;
    totalCount!: number;

    constructor(data?: IJobSearchDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(JobSearchDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): JobSearchDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobSearchDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): JobSearchDtoPagedResultDto {
        const json = this.toJSON();
        let result = new JobSearchDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IJobSearchDtoPagedResultDto {
    items: JobSearchDto[] | undefined;
    totalCount: number;
}

export class LaborConsultantCompanyDto implements ILaborConsultantCompanyDto {
    id!: number;
    businessName!: string | undefined;
    vatNumber!: string | undefined;
    emailAddress!: string | undefined;
    operativeUnitNames!: string | undefined;

    constructor(data?: ILaborConsultantCompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.businessName = _data["businessName"];
            this.vatNumber = _data["vatNumber"];
            this.emailAddress = _data["emailAddress"];
            this.operativeUnitNames = _data["operativeUnitNames"];
        }
    }

    static fromJS(data: any): LaborConsultantCompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new LaborConsultantCompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["businessName"] = this.businessName;
        data["vatNumber"] = this.vatNumber;
        data["emailAddress"] = this.emailAddress;
        data["operativeUnitNames"] = this.operativeUnitNames;
        return data;
    }

    clone(): LaborConsultantCompanyDto {
        const json = this.toJSON();
        let result = new LaborConsultantCompanyDto();
        result.init(json);
        return result;
    }
}

export interface ILaborConsultantCompanyDto {
    id: number;
    businessName: string | undefined;
    vatNumber: string | undefined;
    emailAddress: string | undefined;
    operativeUnitNames: string | undefined;
}

export class LaborConsultantDto implements ILaborConsultantDto {
    id!: number;
    businessName!: string | undefined;
    phoneNumber!: string | undefined;
    responsibleName!: string | undefined;
    vatNumber!: string | undefined;
    fiscalCode!: string | undefined;
    email!: string | undefined;
    address!: AddressDto;
    notes!: string | undefined;
    companies!: LaborConsultantCompanyDto[] | undefined;
    hasLinkedElements!: boolean;

    constructor(data?: ILaborConsultantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.businessName = _data["businessName"];
            this.phoneNumber = _data["phoneNumber"];
            this.responsibleName = _data["responsibleName"];
            this.vatNumber = _data["vatNumber"];
            this.fiscalCode = _data["fiscalCode"];
            this.email = _data["email"];
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : undefined as any;
            this.notes = _data["notes"];
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(LaborConsultantCompanyDto.fromJS(item));
            }
            this.hasLinkedElements = _data["hasLinkedElements"];
        }
    }

    static fromJS(data: any): LaborConsultantDto {
        data = typeof data === 'object' ? data : {};
        let result = new LaborConsultantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["businessName"] = this.businessName;
        data["phoneNumber"] = this.phoneNumber;
        data["responsibleName"] = this.responsibleName;
        data["vatNumber"] = this.vatNumber;
        data["fiscalCode"] = this.fiscalCode;
        data["email"] = this.email;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["notes"] = this.notes;
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item ? item.toJSON() : undefined as any);
        }
        data["hasLinkedElements"] = this.hasLinkedElements;
        return data;
    }

    clone(): LaborConsultantDto {
        const json = this.toJSON();
        let result = new LaborConsultantDto();
        result.init(json);
        return result;
    }
}

export interface ILaborConsultantDto {
    id: number;
    businessName: string | undefined;
    phoneNumber: string | undefined;
    responsibleName: string | undefined;
    vatNumber: string | undefined;
    fiscalCode: string | undefined;
    email: string | undefined;
    address: AddressDto;
    notes: string | undefined;
    companies: LaborConsultantCompanyDto[] | undefined;
    hasLinkedElements: boolean;
}

export class LaborConsultantItemDto implements ILaborConsultantItemDto {
    id!: number;
    businessName!: string | undefined;
    phoneNumber!: string | undefined;
    associatedCompanies!: string[] | undefined;
    hasLinkedElements!: boolean;

    constructor(data?: ILaborConsultantItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.businessName = _data["businessName"];
            this.phoneNumber = _data["phoneNumber"];
            if (Array.isArray(_data["associatedCompanies"])) {
                this.associatedCompanies = [] as any;
                for (let item of _data["associatedCompanies"])
                    this.associatedCompanies!.push(item);
            }
            this.hasLinkedElements = _data["hasLinkedElements"];
        }
    }

    static fromJS(data: any): LaborConsultantItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new LaborConsultantItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["businessName"] = this.businessName;
        data["phoneNumber"] = this.phoneNumber;
        if (Array.isArray(this.associatedCompanies)) {
            data["associatedCompanies"] = [];
            for (let item of this.associatedCompanies)
                data["associatedCompanies"].push(item);
        }
        data["hasLinkedElements"] = this.hasLinkedElements;
        return data;
    }

    clone(): LaborConsultantItemDto {
        const json = this.toJSON();
        let result = new LaborConsultantItemDto();
        result.init(json);
        return result;
    }
}

export interface ILaborConsultantItemDto {
    id: number;
    businessName: string | undefined;
    phoneNumber: string | undefined;
    associatedCompanies: string[] | undefined;
    hasLinkedElements: boolean;
}

export class LaborConsultantItemDtoPagedResultDto implements ILaborConsultantItemDtoPagedResultDto {
    items!: LaborConsultantItemDto[] | undefined;
    totalCount!: number;

    constructor(data?: ILaborConsultantItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LaborConsultantItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): LaborConsultantItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new LaborConsultantItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): LaborConsultantItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new LaborConsultantItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ILaborConsultantItemDtoPagedResultDto {
    items: LaborConsultantItemDto[] | undefined;
    totalCount: number;
}

export class MultiCreateCompensationPaymentRequestDto implements IMultiCreateCompensationPaymentRequestDto {
    apprenticeshipIds!: number[] | undefined;
    monthId!: number;
    year!: number;

    constructor(data?: IMultiCreateCompensationPaymentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["apprenticeshipIds"])) {
                this.apprenticeshipIds = [] as any;
                for (let item of _data["apprenticeshipIds"])
                    this.apprenticeshipIds!.push(item);
            }
            this.monthId = _data["monthId"];
            this.year = _data["year"];
        }
    }

    static fromJS(data: any): MultiCreateCompensationPaymentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new MultiCreateCompensationPaymentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.apprenticeshipIds)) {
            data["apprenticeshipIds"] = [];
            for (let item of this.apprenticeshipIds)
                data["apprenticeshipIds"].push(item);
        }
        data["monthId"] = this.monthId;
        data["year"] = this.year;
        return data;
    }

    clone(): MultiCreateCompensationPaymentRequestDto {
        const json = this.toJSON();
        let result = new MultiCreateCompensationPaymentRequestDto();
        result.init(json);
        return result;
    }
}

export interface IMultiCreateCompensationPaymentRequestDto {
    apprenticeshipIds: number[] | undefined;
    monthId: number;
    year: number;
}

export class MunicipalityDto implements IMunicipalityDto {
    id!: number;
    name!: string | undefined;
    isChiefTown!: boolean;
    province!: ProvinceDto;

    constructor(data?: IMunicipalityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isChiefTown = _data["isChiefTown"];
            this.province = _data["province"] ? ProvinceDto.fromJS(_data["province"]) : undefined as any;
        }
    }

    static fromJS(data: any): MunicipalityDto {
        data = typeof data === 'object' ? data : {};
        let result = new MunicipalityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isChiefTown"] = this.isChiefTown;
        data["province"] = this.province ? this.province.toJSON() : undefined as any;
        return data;
    }

    clone(): MunicipalityDto {
        const json = this.toJSON();
        let result = new MunicipalityDto();
        result.init(json);
        return result;
    }
}

export interface IMunicipalityDto {
    id: number;
    name: string | undefined;
    isChiefTown: boolean;
    province: ProvinceDto;
}

export class NoteDto implements INoteDto {
    id!: number;
    date!: moment.Moment;
    description!: string | undefined;
    creatorUser!: UserItemDto;

    constructor(data?: INoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.description = _data["description"];
            this.creatorUser = _data["creatorUser"] ? UserItemDto.fromJS(_data["creatorUser"]) : undefined as any;
        }
    }

    static fromJS(data: any): NoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new NoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.format('YYYY-MM-DD') : undefined as any;
        data["description"] = this.description;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : undefined as any;
        return data;
    }

    clone(): NoteDto {
        const json = this.toJSON();
        let result = new NoteDto();
        result.init(json);
        return result;
    }
}

export interface INoteDto {
    id: number;
    date: moment.Moment;
    description: string | undefined;
    creatorUser: UserItemDto;
}

export class OperativeUnitDto implements IOperativeUnitDto {
    id!: number;
    headOffice!: string | undefined;
    address!: AddressDto;
    contact!: string | undefined;

    constructor(data?: IOperativeUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.headOffice = _data["headOffice"];
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : undefined as any;
            this.contact = _data["contact"];
        }
    }

    static fromJS(data: any): OperativeUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperativeUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["headOffice"] = this.headOffice;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["contact"] = this.contact;
        return data;
    }

    clone(): OperativeUnitDto {
        const json = this.toJSON();
        let result = new OperativeUnitDto();
        result.init(json);
        return result;
    }
}

export interface IOperativeUnitDto {
    id: number;
    headOffice: string | undefined;
    address: AddressDto;
    contact: string | undefined;
}

export class OperativeUnitDtoPagedResultDto implements IOperativeUnitDtoPagedResultDto {
    items!: OperativeUnitDto[] | undefined;
    totalCount!: number;

    constructor(data?: IOperativeUnitDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OperativeUnitDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): OperativeUnitDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperativeUnitDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): OperativeUnitDtoPagedResultDto {
        const json = this.toJSON();
        let result = new OperativeUnitDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOperativeUnitDtoPagedResultDto {
    items: OperativeUnitDto[] | undefined;
    totalCount: number;
}

export class OrderCodeDto implements IOrderCodeDto {
    id!: number;
    description!: string | undefined;
    selection!: SelectionItemDto[] | undefined;
    people!: UserItemDto[] | undefined;
    requestApprenticeship!: RequestApprenticeshipItemDto[] | undefined;
    hasLinkedElements!: boolean;

    constructor(data?: IOrderCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            if (Array.isArray(_data["selection"])) {
                this.selection = [] as any;
                for (let item of _data["selection"])
                    this.selection!.push(SelectionItemDto.fromJS(item));
            }
            if (Array.isArray(_data["people"])) {
                this.people = [] as any;
                for (let item of _data["people"])
                    this.people!.push(UserItemDto.fromJS(item));
            }
            if (Array.isArray(_data["requestApprenticeship"])) {
                this.requestApprenticeship = [] as any;
                for (let item of _data["requestApprenticeship"])
                    this.requestApprenticeship!.push(RequestApprenticeshipItemDto.fromJS(item));
            }
            this.hasLinkedElements = _data["hasLinkedElements"];
        }
    }

    static fromJS(data: any): OrderCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        if (Array.isArray(this.selection)) {
            data["selection"] = [];
            for (let item of this.selection)
                data["selection"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.people)) {
            data["people"] = [];
            for (let item of this.people)
                data["people"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.requestApprenticeship)) {
            data["requestApprenticeship"] = [];
            for (let item of this.requestApprenticeship)
                data["requestApprenticeship"].push(item ? item.toJSON() : undefined as any);
        }
        data["hasLinkedElements"] = this.hasLinkedElements;
        return data;
    }

    clone(): OrderCodeDto {
        const json = this.toJSON();
        let result = new OrderCodeDto();
        result.init(json);
        return result;
    }
}

export interface IOrderCodeDto {
    id: number;
    description: string | undefined;
    selection: SelectionItemDto[] | undefined;
    people: UserItemDto[] | undefined;
    requestApprenticeship: RequestApprenticeshipItemDto[] | undefined;
    hasLinkedElements: boolean;
}

export class OrderCodeDtoPagedResultDto implements IOrderCodeDtoPagedResultDto {
    items!: OrderCodeDto[] | undefined;
    totalCount!: number;

    constructor(data?: IOrderCodeDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrderCodeDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): OrderCodeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderCodeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): OrderCodeDtoPagedResultDto {
        const json = this.toJSON();
        let result = new OrderCodeDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOrderCodeDtoPagedResultDto {
    items: OrderCodeDto[] | undefined;
    totalCount: number;
}

export class PartnerServiceDto implements IPartnerServiceDto {
    id!: number;
    silServiceOperativeUnits!: SILServiceOperativeUnitDto[] | undefined;
    agencyServiceOperativeUnits!: AgencyServiceOperativeUnitDto[] | undefined;
    silLastContact!: string | undefined;
    agencyLastContact!: string | undefined;
    hasSILService!: boolean | undefined;
    hasAgencyService!: boolean | undefined;

    constructor(data?: IPartnerServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["silServiceOperativeUnits"])) {
                this.silServiceOperativeUnits = [] as any;
                for (let item of _data["silServiceOperativeUnits"])
                    this.silServiceOperativeUnits!.push(SILServiceOperativeUnitDto.fromJS(item));
            }
            if (Array.isArray(_data["agencyServiceOperativeUnits"])) {
                this.agencyServiceOperativeUnits = [] as any;
                for (let item of _data["agencyServiceOperativeUnits"])
                    this.agencyServiceOperativeUnits!.push(AgencyServiceOperativeUnitDto.fromJS(item));
            }
            this.silLastContact = _data["silLastContact"];
            this.agencyLastContact = _data["agencyLastContact"];
            this.hasSILService = _data["hasSILService"];
            this.hasAgencyService = _data["hasAgencyService"];
        }
    }

    static fromJS(data: any): PartnerServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.silServiceOperativeUnits)) {
            data["silServiceOperativeUnits"] = [];
            for (let item of this.silServiceOperativeUnits)
                data["silServiceOperativeUnits"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.agencyServiceOperativeUnits)) {
            data["agencyServiceOperativeUnits"] = [];
            for (let item of this.agencyServiceOperativeUnits)
                data["agencyServiceOperativeUnits"].push(item ? item.toJSON() : undefined as any);
        }
        data["silLastContact"] = this.silLastContact;
        data["agencyLastContact"] = this.agencyLastContact;
        data["hasSILService"] = this.hasSILService;
        data["hasAgencyService"] = this.hasAgencyService;
        return data;
    }

    clone(): PartnerServiceDto {
        const json = this.toJSON();
        let result = new PartnerServiceDto();
        result.init(json);
        return result;
    }
}

export interface IPartnerServiceDto {
    id: number;
    silServiceOperativeUnits: SILServiceOperativeUnitDto[] | undefined;
    agencyServiceOperativeUnits: AgencyServiceOperativeUnitDto[] | undefined;
    silLastContact: string | undefined;
    agencyLastContact: string | undefined;
    hasSILService: boolean | undefined;
    hasAgencyService: boolean | undefined;
}

export class PartnerServiceDtoPagedResultDto implements IPartnerServiceDtoPagedResultDto {
    items!: PartnerServiceDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPartnerServiceDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PartnerServiceDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PartnerServiceDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerServiceDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PartnerServiceDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PartnerServiceDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPartnerServiceDtoPagedResultDto {
    items: PartnerServiceDto[] | undefined;
    totalCount: number;
}

export class PartnerSurveyDto implements IPartnerSurveyDto {
    id!: number;
    hastJobPlacementApprenticeships!: number;
    hostTrainingApprenticeship!: number;
    participantOrientationInitiatives!: number;
    hostJobTrialEvents!: number;

    constructor(data?: IPartnerSurveyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.hastJobPlacementApprenticeships = _data["hastJobPlacementApprenticeships"];
            this.hostTrainingApprenticeship = _data["hostTrainingApprenticeship"];
            this.participantOrientationInitiatives = _data["participantOrientationInitiatives"];
            this.hostJobTrialEvents = _data["hostJobTrialEvents"];
        }
    }

    static fromJS(data: any): PartnerSurveyDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerSurveyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["hastJobPlacementApprenticeships"] = this.hastJobPlacementApprenticeships;
        data["hostTrainingApprenticeship"] = this.hostTrainingApprenticeship;
        data["participantOrientationInitiatives"] = this.participantOrientationInitiatives;
        data["hostJobTrialEvents"] = this.hostJobTrialEvents;
        return data;
    }

    clone(): PartnerSurveyDto {
        const json = this.toJSON();
        let result = new PartnerSurveyDto();
        result.init(json);
        return result;
    }
}

export interface IPartnerSurveyDto {
    id: number;
    hastJobPlacementApprenticeships: number;
    hostTrainingApprenticeship: number;
    participantOrientationInitiatives: number;
    hostJobTrialEvents: number;
}

export class PartnerSurveyDtoPagedResultDto implements IPartnerSurveyDtoPagedResultDto {
    items!: PartnerSurveyDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPartnerSurveyDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PartnerSurveyDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PartnerSurveyDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerSurveyDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PartnerSurveyDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PartnerSurveyDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPartnerSurveyDtoPagedResultDto {
    items: PartnerSurveyDto[] | undefined;
    totalCount: number;
}

export class PartnerUserDto implements IPartnerUserDto {
    id!: number;
    partner!: UserItemDto;
    person!: UserItemDto;

    constructor(data?: IPartnerUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.partner = _data["partner"] ? UserItemDto.fromJS(_data["partner"]) : undefined as any;
            this.person = _data["person"] ? UserItemDto.fromJS(_data["person"]) : undefined as any;
        }
    }

    static fromJS(data: any): PartnerUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["partner"] = this.partner ? this.partner.toJSON() : undefined as any;
        data["person"] = this.person ? this.person.toJSON() : undefined as any;
        return data;
    }

    clone(): PartnerUserDto {
        const json = this.toJSON();
        let result = new PartnerUserDto();
        result.init(json);
        return result;
    }
}

export interface IPartnerUserDto {
    id: number;
    partner: UserItemDto;
    person: UserItemDto;
}

export class PartnerUserDtoPagedResultDto implements IPartnerUserDtoPagedResultDto {
    items!: PartnerUserDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPartnerUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PartnerUserDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PartnerUserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerUserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PartnerUserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PartnerUserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPartnerUserDtoPagedResultDto {
    items: PartnerUserDto[] | undefined;
    totalCount: number;
}

export class PermissionDto implements IPermissionDto {
    id!: number;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;

    constructor(data?: IPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data;
    }

    clone(): PermissionDto {
        const json = this.toJSON();
        let result = new PermissionDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
}

export class PermissionDtoListResultDto implements IPermissionDtoListResultDto {
    items!: PermissionDto[] | undefined;

    constructor(data?: IPermissionDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PermissionDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PermissionDtoListResultDto {
        const json = this.toJSON();
        let result = new PermissionDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDtoListResultDto {
    items: PermissionDto[] | undefined;
}

export class PersonalInfoDto implements IPersonalInfoDto {
    id!: number;
    user!: UserItemDto;
    employmentStatus!: DictionaryDto;
    currentCompany!: string | undefined;
    maritalStatus!: DictionaryDto;
    childrenNumber!: number | undefined;
    hasCar!: boolean | undefined;
    hasDrivingLicense!: boolean | undefined;
    drivingLicenseTypes!: DictionaryDto[] | undefined;
    usePublicTransport!: boolean | undefined;
    hasIndependently!: boolean | undefined;
    hasAvilabilityTravel!: boolean | undefined;
    kmRadius!: number | undefined;
    drivingLicenseDescription!: string | undefined;
    orderCodes!: DictionaryDto[] | undefined;

    constructor(data?: IPersonalInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"] ? UserItemDto.fromJS(_data["user"]) : undefined as any;
            this.employmentStatus = _data["employmentStatus"] ? DictionaryDto.fromJS(_data["employmentStatus"]) : undefined as any;
            this.currentCompany = _data["currentCompany"];
            this.maritalStatus = _data["maritalStatus"] ? DictionaryDto.fromJS(_data["maritalStatus"]) : undefined as any;
            this.childrenNumber = _data["childrenNumber"];
            this.hasCar = _data["hasCar"];
            this.hasDrivingLicense = _data["hasDrivingLicense"];
            if (Array.isArray(_data["drivingLicenseTypes"])) {
                this.drivingLicenseTypes = [] as any;
                for (let item of _data["drivingLicenseTypes"])
                    this.drivingLicenseTypes!.push(DictionaryDto.fromJS(item));
            }
            this.usePublicTransport = _data["usePublicTransport"];
            this.hasIndependently = _data["hasIndependently"];
            this.hasAvilabilityTravel = _data["hasAvilabilityTravel"];
            this.kmRadius = _data["kmRadius"];
            this.drivingLicenseDescription = _data["drivingLicenseDescription"];
            if (Array.isArray(_data["orderCodes"])) {
                this.orderCodes = [] as any;
                for (let item of _data["orderCodes"])
                    this.orderCodes!.push(DictionaryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PersonalInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonalInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["employmentStatus"] = this.employmentStatus ? this.employmentStatus.toJSON() : undefined as any;
        data["currentCompany"] = this.currentCompany;
        data["maritalStatus"] = this.maritalStatus ? this.maritalStatus.toJSON() : undefined as any;
        data["childrenNumber"] = this.childrenNumber;
        data["hasCar"] = this.hasCar;
        data["hasDrivingLicense"] = this.hasDrivingLicense;
        if (Array.isArray(this.drivingLicenseTypes)) {
            data["drivingLicenseTypes"] = [];
            for (let item of this.drivingLicenseTypes)
                data["drivingLicenseTypes"].push(item ? item.toJSON() : undefined as any);
        }
        data["usePublicTransport"] = this.usePublicTransport;
        data["hasIndependently"] = this.hasIndependently;
        data["hasAvilabilityTravel"] = this.hasAvilabilityTravel;
        data["kmRadius"] = this.kmRadius;
        data["drivingLicenseDescription"] = this.drivingLicenseDescription;
        if (Array.isArray(this.orderCodes)) {
            data["orderCodes"] = [];
            for (let item of this.orderCodes)
                data["orderCodes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PersonalInfoDto {
        const json = this.toJSON();
        let result = new PersonalInfoDto();
        result.init(json);
        return result;
    }
}

export interface IPersonalInfoDto {
    id: number;
    user: UserItemDto;
    employmentStatus: DictionaryDto;
    currentCompany: string | undefined;
    maritalStatus: DictionaryDto;
    childrenNumber: number | undefined;
    hasCar: boolean | undefined;
    hasDrivingLicense: boolean | undefined;
    drivingLicenseTypes: DictionaryDto[] | undefined;
    usePublicTransport: boolean | undefined;
    hasIndependently: boolean | undefined;
    hasAvilabilityTravel: boolean | undefined;
    kmRadius: number | undefined;
    drivingLicenseDescription: string | undefined;
    orderCodes: DictionaryDto[] | undefined;
}

export class PersonalInfoDtoPagedResultDto implements IPersonalInfoDtoPagedResultDto {
    items!: PersonalInfoDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPersonalInfoDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PersonalInfoDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PersonalInfoDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonalInfoDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PersonalInfoDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PersonalInfoDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPersonalInfoDtoPagedResultDto {
    items: PersonalInfoDto[] | undefined;
    totalCount: number;
}

export class ProvinceDto implements IProvinceDto {
    id!: number;
    name!: string | undefined;
    abbreviation!: string | undefined;
    region!: RegionDto;

    constructor(data?: IProvinceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.abbreviation = _data["abbreviation"];
            this.region = _data["region"] ? RegionDto.fromJS(_data["region"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProvinceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProvinceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["abbreviation"] = this.abbreviation;
        data["region"] = this.region ? this.region.toJSON() : undefined as any;
        return data;
    }

    clone(): ProvinceDto {
        const json = this.toJSON();
        let result = new ProvinceDto();
        result.init(json);
        return result;
    }
}

export interface IProvinceDto {
    id: number;
    name: string | undefined;
    abbreviation: string | undefined;
    region: RegionDto;
}

export class PublicSelectionDto implements IPublicSelectionDto {
    id!: number;
    title!: string | undefined;
    description!: string | undefined;

    constructor(data?: IPublicSelectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PublicSelectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PublicSelectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        return data;
    }

    clone(): PublicSelectionDto {
        const json = this.toJSON();
        let result = new PublicSelectionDto();
        result.init(json);
        return result;
    }
}

export interface IPublicSelectionDto {
    id: number;
    title: string | undefined;
    description: string | undefined;
}

export class RegionDto implements IRegionDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: IRegionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RegionDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): RegionDto {
        const json = this.toJSON();
        let result = new RegionDto();
        result.init(json);
        return result;
    }
}

export interface IRegionDto {
    id: number;
    name: string | undefined;
}

export class RegisterInput implements IRegisterInput {
    name!: string;
    surname!: string;
    userName!: string;
    emailAddress!: string;
    password!: string;
    captchaResponse!: string | undefined;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any): RegisterInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        return data;
    }

    clone(): RegisterInput {
        const json = this.toJSON();
        let result = new RegisterInput();
        result.init(json);
        return result;
    }
}

export interface IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;
}

export class RegisterOutput implements IRegisterOutput {
    canLogin!: boolean;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
        }
    }

    static fromJS(data: any): RegisterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data;
    }

    clone(): RegisterOutput {
        const json = this.toJSON();
        let result = new RegisterOutput();
        result.init(json);
        return result;
    }
}

export interface IRegisterOutput {
    canLogin: boolean;
}

export class RegisterPartnerDto implements IRegisterPartnerDto {
    name!: string;
    surname!: string;
    userName!: string;
    emailAddress!: string;
    password!: string;
    captchaResponse!: string | undefined;
    phoneNumber!: string;
    businessName!: string;
    registeredOffice!: CreateAddressDto;
    vatNumber!: string;
    fiscalCode!: string;

    constructor(data?: IRegisterPartnerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.registeredOffice = new CreateAddressDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.captchaResponse = _data["captchaResponse"];
            this.phoneNumber = _data["phoneNumber"];
            this.businessName = _data["businessName"];
            this.registeredOffice = _data["registeredOffice"] ? CreateAddressDto.fromJS(_data["registeredOffice"]) : new CreateAddressDto();
            this.vatNumber = _data["vatNumber"];
            this.fiscalCode = _data["fiscalCode"];
        }
    }

    static fromJS(data: any): RegisterPartnerDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterPartnerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        data["phoneNumber"] = this.phoneNumber;
        data["businessName"] = this.businessName;
        data["registeredOffice"] = this.registeredOffice ? this.registeredOffice.toJSON() : undefined as any;
        data["vatNumber"] = this.vatNumber;
        data["fiscalCode"] = this.fiscalCode;
        return data;
    }

    clone(): RegisterPartnerDto {
        const json = this.toJSON();
        let result = new RegisterPartnerDto();
        result.init(json);
        return result;
    }
}

export interface IRegisterPartnerDto {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;
    phoneNumber: string;
    businessName: string;
    registeredOffice: CreateAddressDto;
    vatNumber: string;
    fiscalCode: string;
}

export class RegisterPersonDto implements IRegisterPersonDto {
    name!: string;
    surname!: string;
    userName!: string;
    emailAddress!: string;
    password!: string;
    captchaResponse!: string | undefined;
    birthPlace!: string;
    birthDate!: moment.Moment;
    fiscalCode!: string;
    genderId!: number;
    nationalityId!: number;

    constructor(data?: IRegisterPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.captchaResponse = _data["captchaResponse"];
            this.birthPlace = _data["birthPlace"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : undefined as any;
            this.fiscalCode = _data["fiscalCode"];
            this.genderId = _data["genderId"];
            this.nationalityId = _data["nationalityId"];
        }
    }

    static fromJS(data: any): RegisterPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        data["birthPlace"] = this.birthPlace;
        data["birthDate"] = this.birthDate ? this.birthDate.format('YYYY-MM-DD') : undefined as any;
        data["fiscalCode"] = this.fiscalCode;
        data["genderId"] = this.genderId;
        data["nationalityId"] = this.nationalityId;
        return data;
    }

    clone(): RegisterPersonDto {
        const json = this.toJSON();
        let result = new RegisterPersonDto();
        result.init(json);
        return result;
    }
}

export interface IRegisterPersonDto {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;
    birthPlace: string;
    birthDate: moment.Moment;
    fiscalCode: string;
    genderId: number;
    nationalityId: number;
}

export class RequestApprenticeshipDto implements IRequestApprenticeshipDto {
    id!: number;
    title!: string | undefined;
    partner!: UserItemDto;
    operativeUnit!: OperativeUnitDto;
    contractProposal!: DictionaryDto;
    requestApprenticeshipType!: DictionaryDto;
    startDateTime!: moment.Moment | undefined;
    endDateTime!: moment.Moment | undefined;
    educationalDegreeLevel!: DictionaryDto;
    educationalDegree!: EducationalDegreeDto;
    otherEducationalDegreeLevel!: string | undefined;
    placeOfWork!: string | undefined;
    reference!: string | undefined;
    businessSector!: DictionaryDto;
    job!: DictionaryDto;
    requestType!: DictionaryDto;
    requestApprenticeshipState!: DictionaryDto;
    requestApprenticeshipOrderCodes!: OrderCodeDto[] | undefined;
    selectionId!: number | undefined;

    constructor(data?: IRequestApprenticeshipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.partner = _data["partner"] ? UserItemDto.fromJS(_data["partner"]) : undefined as any;
            this.operativeUnit = _data["operativeUnit"] ? OperativeUnitDto.fromJS(_data["operativeUnit"]) : undefined as any;
            this.contractProposal = _data["contractProposal"] ? DictionaryDto.fromJS(_data["contractProposal"]) : undefined as any;
            this.requestApprenticeshipType = _data["requestApprenticeshipType"] ? DictionaryDto.fromJS(_data["requestApprenticeshipType"]) : undefined as any;
            this.startDateTime = _data["startDateTime"] ? moment(_data["startDateTime"].toString()) : undefined as any;
            this.endDateTime = _data["endDateTime"] ? moment(_data["endDateTime"].toString()) : undefined as any;
            this.educationalDegreeLevel = _data["educationalDegreeLevel"] ? DictionaryDto.fromJS(_data["educationalDegreeLevel"]) : undefined as any;
            this.educationalDegree = _data["educationalDegree"] ? EducationalDegreeDto.fromJS(_data["educationalDegree"]) : undefined as any;
            this.otherEducationalDegreeLevel = _data["otherEducationalDegreeLevel"];
            this.placeOfWork = _data["placeOfWork"];
            this.reference = _data["reference"];
            this.businessSector = _data["businessSector"] ? DictionaryDto.fromJS(_data["businessSector"]) : undefined as any;
            this.job = _data["job"] ? DictionaryDto.fromJS(_data["job"]) : undefined as any;
            this.requestType = _data["requestType"] ? DictionaryDto.fromJS(_data["requestType"]) : undefined as any;
            this.requestApprenticeshipState = _data["requestApprenticeshipState"] ? DictionaryDto.fromJS(_data["requestApprenticeshipState"]) : undefined as any;
            if (Array.isArray(_data["requestApprenticeshipOrderCodes"])) {
                this.requestApprenticeshipOrderCodes = [] as any;
                for (let item of _data["requestApprenticeshipOrderCodes"])
                    this.requestApprenticeshipOrderCodes!.push(OrderCodeDto.fromJS(item));
            }
            this.selectionId = _data["selectionId"];
        }
    }

    static fromJS(data: any): RequestApprenticeshipDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestApprenticeshipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["partner"] = this.partner ? this.partner.toJSON() : undefined as any;
        data["operativeUnit"] = this.operativeUnit ? this.operativeUnit.toJSON() : undefined as any;
        data["contractProposal"] = this.contractProposal ? this.contractProposal.toJSON() : undefined as any;
        data["requestApprenticeshipType"] = this.requestApprenticeshipType ? this.requestApprenticeshipType.toJSON() : undefined as any;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : undefined as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : undefined as any;
        data["educationalDegreeLevel"] = this.educationalDegreeLevel ? this.educationalDegreeLevel.toJSON() : undefined as any;
        data["educationalDegree"] = this.educationalDegree ? this.educationalDegree.toJSON() : undefined as any;
        data["otherEducationalDegreeLevel"] = this.otherEducationalDegreeLevel;
        data["placeOfWork"] = this.placeOfWork;
        data["reference"] = this.reference;
        data["businessSector"] = this.businessSector ? this.businessSector.toJSON() : undefined as any;
        data["job"] = this.job ? this.job.toJSON() : undefined as any;
        data["requestType"] = this.requestType ? this.requestType.toJSON() : undefined as any;
        data["requestApprenticeshipState"] = this.requestApprenticeshipState ? this.requestApprenticeshipState.toJSON() : undefined as any;
        if (Array.isArray(this.requestApprenticeshipOrderCodes)) {
            data["requestApprenticeshipOrderCodes"] = [];
            for (let item of this.requestApprenticeshipOrderCodes)
                data["requestApprenticeshipOrderCodes"].push(item ? item.toJSON() : undefined as any);
        }
        data["selectionId"] = this.selectionId;
        return data;
    }

    clone(): RequestApprenticeshipDto {
        const json = this.toJSON();
        let result = new RequestApprenticeshipDto();
        result.init(json);
        return result;
    }
}

export interface IRequestApprenticeshipDto {
    id: number;
    title: string | undefined;
    partner: UserItemDto;
    operativeUnit: OperativeUnitDto;
    contractProposal: DictionaryDto;
    requestApprenticeshipType: DictionaryDto;
    startDateTime: moment.Moment | undefined;
    endDateTime: moment.Moment | undefined;
    educationalDegreeLevel: DictionaryDto;
    educationalDegree: EducationalDegreeDto;
    otherEducationalDegreeLevel: string | undefined;
    placeOfWork: string | undefined;
    reference: string | undefined;
    businessSector: DictionaryDto;
    job: DictionaryDto;
    requestType: DictionaryDto;
    requestApprenticeshipState: DictionaryDto;
    requestApprenticeshipOrderCodes: OrderCodeDto[] | undefined;
    selectionId: number | undefined;
}

export class RequestApprenticeshipDtoPagedResultDto implements IRequestApprenticeshipDtoPagedResultDto {
    items!: RequestApprenticeshipDto[] | undefined;
    totalCount!: number;

    constructor(data?: IRequestApprenticeshipDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RequestApprenticeshipDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): RequestApprenticeshipDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestApprenticeshipDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): RequestApprenticeshipDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RequestApprenticeshipDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRequestApprenticeshipDtoPagedResultDto {
    items: RequestApprenticeshipDto[] | undefined;
    totalCount: number;
}

export class RequestApprenticeshipItemDto implements IRequestApprenticeshipItemDto {
    id!: number;
    title!: string | undefined;

    constructor(data?: IRequestApprenticeshipItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): RequestApprenticeshipItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestApprenticeshipItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        return data;
    }

    clone(): RequestApprenticeshipItemDto {
        const json = this.toJSON();
        let result = new RequestApprenticeshipItemDto();
        result.init(json);
        return result;
    }
}

export interface IRequestApprenticeshipItemDto {
    id: number;
    title: string | undefined;
}

export class ResetPasswordResultDto implements IResetPasswordResultDto {
    result!: IdentityResult;
    userId!: number;
    isUserActive!: boolean;

    constructor(data?: IResetPasswordResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? IdentityResult.fromJS(_data["result"]) : undefined as any;
            this.userId = _data["userId"];
            this.isUserActive = _data["isUserActive"];
        }
    }

    static fromJS(data: any): ResetPasswordResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        data["userId"] = this.userId;
        data["isUserActive"] = this.isUserActive;
        return data;
    }

    clone(): ResetPasswordResultDto {
        const json = this.toJSON();
        let result = new ResetPasswordResultDto();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordResultDto {
    result: IdentityResult;
    userId: number;
    isUserActive: boolean;
}

export class ResidenceInfoDto implements IResidenceInfoDto {
    id!: number;
    user!: UserItemDto;
    employmentCenterRegistration!: boolean | undefined;
    residencePermit!: DictionaryDto;
    motivationResidencePermit!: DictionaryDto;
    empiryDateResindence!: moment.Moment | undefined;
    incomeSupportRecipient!: boolean | undefined;
    incomeSupportTypes!: DictionaryDto[] | undefined;
    residence!: AddressDto;
    isDomicileOther!: boolean | undefined;
    domicile!: AddressDto;
    policeRelease!: string | undefined;

    constructor(data?: IResidenceInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"] ? UserItemDto.fromJS(_data["user"]) : undefined as any;
            this.employmentCenterRegistration = _data["employmentCenterRegistration"];
            this.residencePermit = _data["residencePermit"] ? DictionaryDto.fromJS(_data["residencePermit"]) : undefined as any;
            this.motivationResidencePermit = _data["motivationResidencePermit"] ? DictionaryDto.fromJS(_data["motivationResidencePermit"]) : undefined as any;
            this.empiryDateResindence = _data["empiryDateResindence"] ? moment(_data["empiryDateResindence"].toString()) : undefined as any;
            this.incomeSupportRecipient = _data["incomeSupportRecipient"];
            if (Array.isArray(_data["incomeSupportTypes"])) {
                this.incomeSupportTypes = [] as any;
                for (let item of _data["incomeSupportTypes"])
                    this.incomeSupportTypes!.push(DictionaryDto.fromJS(item));
            }
            this.residence = _data["residence"] ? AddressDto.fromJS(_data["residence"]) : undefined as any;
            this.isDomicileOther = _data["isDomicileOther"];
            this.domicile = _data["domicile"] ? AddressDto.fromJS(_data["domicile"]) : undefined as any;
            this.policeRelease = _data["policeRelease"];
        }
    }

    static fromJS(data: any): ResidenceInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResidenceInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["employmentCenterRegistration"] = this.employmentCenterRegistration;
        data["residencePermit"] = this.residencePermit ? this.residencePermit.toJSON() : undefined as any;
        data["motivationResidencePermit"] = this.motivationResidencePermit ? this.motivationResidencePermit.toJSON() : undefined as any;
        data["empiryDateResindence"] = this.empiryDateResindence ? this.empiryDateResindence.format('YYYY-MM-DD') : undefined as any;
        data["incomeSupportRecipient"] = this.incomeSupportRecipient;
        if (Array.isArray(this.incomeSupportTypes)) {
            data["incomeSupportTypes"] = [];
            for (let item of this.incomeSupportTypes)
                data["incomeSupportTypes"].push(item ? item.toJSON() : undefined as any);
        }
        data["residence"] = this.residence ? this.residence.toJSON() : undefined as any;
        data["isDomicileOther"] = this.isDomicileOther;
        data["domicile"] = this.domicile ? this.domicile.toJSON() : undefined as any;
        data["policeRelease"] = this.policeRelease;
        return data;
    }

    clone(): ResidenceInfoDto {
        const json = this.toJSON();
        let result = new ResidenceInfoDto();
        result.init(json);
        return result;
    }
}

export interface IResidenceInfoDto {
    id: number;
    user: UserItemDto;
    employmentCenterRegistration: boolean | undefined;
    residencePermit: DictionaryDto;
    motivationResidencePermit: DictionaryDto;
    empiryDateResindence: moment.Moment | undefined;
    incomeSupportRecipient: boolean | undefined;
    incomeSupportTypes: DictionaryDto[] | undefined;
    residence: AddressDto;
    isDomicileOther: boolean | undefined;
    domicile: AddressDto;
    policeRelease: string | undefined;
}

export class ResidenceInfoDtoPagedResultDto implements IResidenceInfoDtoPagedResultDto {
    items!: ResidenceInfoDto[] | undefined;
    totalCount!: number;

    constructor(data?: IResidenceInfoDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ResidenceInfoDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ResidenceInfoDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResidenceInfoDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ResidenceInfoDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ResidenceInfoDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IResidenceInfoDtoPagedResultDto {
    items: ResidenceInfoDto[] | undefined;
    totalCount: number;
}

export class RoleDto implements IRoleDto {
    id!: number;
    name!: string;
    displayName!: string;
    normalizedName!: string | undefined;
    description!: string | undefined;
    grantedPermissions!: string[] | undefined;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions!.push(item);
            }
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        return data;
    }

    clone(): RoleDto {
        const json = this.toJSON();
        let result = new RoleDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDto {
    id: number;
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
}

export class RoleDtoPagedResultDto implements IRoleDtoPagedResultDto {
    items!: RoleDto[] | undefined;
    totalCount!: number;

    constructor(data?: IRoleDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoleDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): RoleDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): RoleDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RoleDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoPagedResultDto {
    items: RoleDto[] | undefined;
    totalCount: number;
}

export class RoleEditDto implements IRoleEditDto {
    id!: number;
    name!: string;
    displayName!: string;
    description!: string | undefined;
    isStatic!: boolean;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isStatic = _data["isStatic"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isStatic"] = this.isStatic;
        return data;
    }

    clone(): RoleEditDto {
        const json = this.toJSON();
        let result = new RoleEditDto();
        result.init(json);
        return result;
    }
}

export interface IRoleEditDto {
    id: number;
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean;
}

export class RoleListDto implements IRoleListDto {
    id!: number;
    name!: string | undefined;
    displayName!: string | undefined;
    isStatic!: boolean;
    isDefault!: boolean;
    creationTime!: moment.Moment;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isStatic = _data["isStatic"];
            this.isDefault = _data["isDefault"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        return data;
    }

    clone(): RoleListDto {
        const json = this.toJSON();
        let result = new RoleListDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;
}

export class RoleListDtoListResultDto implements IRoleListDtoListResultDto {
    items!: RoleListDto[] | undefined;

    constructor(data?: IRoleListDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleListDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): RoleListDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleListDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;
}

export class SelectionApplicationDto implements ISelectionApplicationDto {
    id!: number;
    selection!: SelectionDto;
    person!: UserDto;
    interviewResult!: boolean | undefined;
    interviewDate!: moment.Moment | undefined;

    constructor(data?: ISelectionApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.selection = _data["selection"] ? SelectionDto.fromJS(_data["selection"]) : undefined as any;
            this.person = _data["person"] ? UserDto.fromJS(_data["person"]) : undefined as any;
            this.interviewResult = _data["interviewResult"];
            this.interviewDate = _data["interviewDate"] ? moment(_data["interviewDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SelectionApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectionApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["selection"] = this.selection ? this.selection.toJSON() : undefined as any;
        data["person"] = this.person ? this.person.toJSON() : undefined as any;
        data["interviewResult"] = this.interviewResult;
        data["interviewDate"] = this.interviewDate ? this.interviewDate.format('YYYY-MM-DD') : undefined as any;
        return data;
    }

    clone(): SelectionApplicationDto {
        const json = this.toJSON();
        let result = new SelectionApplicationDto();
        result.init(json);
        return result;
    }
}

export interface ISelectionApplicationDto {
    id: number;
    selection: SelectionDto;
    person: UserDto;
    interviewResult: boolean | undefined;
    interviewDate: moment.Moment | undefined;
}

export class SelectionApplicationDtoPagedResultDto implements ISelectionApplicationDtoPagedResultDto {
    items!: SelectionApplicationDto[] | undefined;
    totalCount!: number;

    constructor(data?: ISelectionApplicationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SelectionApplicationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SelectionApplicationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectionApplicationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): SelectionApplicationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new SelectionApplicationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ISelectionApplicationDtoPagedResultDto {
    items: SelectionApplicationDto[] | undefined;
    totalCount: number;
}

export class SelectionComputerSkillDto implements ISelectionComputerSkillDto {
    id!: number;
    selection!: SelectionDto;
    computerSkill!: DictionaryDto;
    notes!: string | undefined;

    constructor(data?: ISelectionComputerSkillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.selection = _data["selection"] ? SelectionDto.fromJS(_data["selection"]) : undefined as any;
            this.computerSkill = _data["computerSkill"] ? DictionaryDto.fromJS(_data["computerSkill"]) : undefined as any;
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): SelectionComputerSkillDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectionComputerSkillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["selection"] = this.selection ? this.selection.toJSON() : undefined as any;
        data["computerSkill"] = this.computerSkill ? this.computerSkill.toJSON() : undefined as any;
        data["notes"] = this.notes;
        return data;
    }

    clone(): SelectionComputerSkillDto {
        const json = this.toJSON();
        let result = new SelectionComputerSkillDto();
        result.init(json);
        return result;
    }
}

export interface ISelectionComputerSkillDto {
    id: number;
    selection: SelectionDto;
    computerSkill: DictionaryDto;
    notes: string | undefined;
}

export class SelectionComputerSkillDtoPagedResultDto implements ISelectionComputerSkillDtoPagedResultDto {
    items!: SelectionComputerSkillDto[] | undefined;
    totalCount!: number;

    constructor(data?: ISelectionComputerSkillDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SelectionComputerSkillDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SelectionComputerSkillDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectionComputerSkillDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): SelectionComputerSkillDtoPagedResultDto {
        const json = this.toJSON();
        let result = new SelectionComputerSkillDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ISelectionComputerSkillDtoPagedResultDto {
    items: SelectionComputerSkillDto[] | undefined;
    totalCount: number;
}

export class SelectionDto implements ISelectionDto {
    id!: number;
    title!: string | undefined;
    partner!: UserItemDto;
    operativeUnit!: OperativeUnitDto;
    contractProposal!: DictionaryDto;
    educationalDegreeLevel!: DictionaryDto;
    educationalDegree!: EducationalDegreeDto;
    otherEducationalDegreeLevel!: string | undefined;
    reference!: string | undefined;
    businessSector!: DictionaryDto;
    job!: DictionaryDto;
    placeOfWork!: string | undefined;
    requestType!: DictionaryDto;
    insertionDate!: moment.Moment | undefined;
    experyDate!: moment.Moment | undefined;
    hasCar!: boolean | undefined;
    drivingLicenseTypes!: DictionaryDto[] | undefined;
    obligationLaw381!: boolean | undefined;
    obligationLaw68!: boolean | undefined;
    noisyEnvironment!: boolean | undefined;
    dustyEnvironment!: boolean | undefined;
    loadHandling!: boolean | undefined;
    workMode!: DictionaryDto;
    description!: string | undefined;
    note!: string | undefined;
    isAlreadySelected!: boolean;
    orderCodes!: OrderCodeDto[] | undefined;
    isPrivate!: boolean | undefined;
    requestApprenticeshipId!: number | undefined;
    requestApprenticeshipType!: DictionaryDto;
    requestApprenticeshipOrderCode!: OrderCodeDto;
    requestApprenticeshipOrderCodes!: OrderCodeDto[] | undefined;

    constructor(data?: ISelectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.partner = _data["partner"] ? UserItemDto.fromJS(_data["partner"]) : undefined as any;
            this.operativeUnit = _data["operativeUnit"] ? OperativeUnitDto.fromJS(_data["operativeUnit"]) : undefined as any;
            this.contractProposal = _data["contractProposal"] ? DictionaryDto.fromJS(_data["contractProposal"]) : undefined as any;
            this.educationalDegreeLevel = _data["educationalDegreeLevel"] ? DictionaryDto.fromJS(_data["educationalDegreeLevel"]) : undefined as any;
            this.educationalDegree = _data["educationalDegree"] ? EducationalDegreeDto.fromJS(_data["educationalDegree"]) : undefined as any;
            this.otherEducationalDegreeLevel = _data["otherEducationalDegreeLevel"];
            this.reference = _data["reference"];
            this.businessSector = _data["businessSector"] ? DictionaryDto.fromJS(_data["businessSector"]) : undefined as any;
            this.job = _data["job"] ? DictionaryDto.fromJS(_data["job"]) : undefined as any;
            this.placeOfWork = _data["placeOfWork"];
            this.requestType = _data["requestType"] ? DictionaryDto.fromJS(_data["requestType"]) : undefined as any;
            this.insertionDate = _data["insertionDate"] ? moment(_data["insertionDate"].toString()) : undefined as any;
            this.experyDate = _data["experyDate"] ? moment(_data["experyDate"].toString()) : undefined as any;
            this.hasCar = _data["hasCar"];
            if (Array.isArray(_data["drivingLicenseTypes"])) {
                this.drivingLicenseTypes = [] as any;
                for (let item of _data["drivingLicenseTypes"])
                    this.drivingLicenseTypes!.push(DictionaryDto.fromJS(item));
            }
            this.obligationLaw381 = _data["obligationLaw381"];
            this.obligationLaw68 = _data["obligationLaw68"];
            this.noisyEnvironment = _data["noisyEnvironment"];
            this.dustyEnvironment = _data["dustyEnvironment"];
            this.loadHandling = _data["loadHandling"];
            this.workMode = _data["workMode"] ? DictionaryDto.fromJS(_data["workMode"]) : undefined as any;
            this.description = _data["description"];
            this.note = _data["note"];
            this.isAlreadySelected = _data["isAlreadySelected"];
            if (Array.isArray(_data["orderCodes"])) {
                this.orderCodes = [] as any;
                for (let item of _data["orderCodes"])
                    this.orderCodes!.push(OrderCodeDto.fromJS(item));
            }
            this.isPrivate = _data["isPrivate"];
            this.requestApprenticeshipId = _data["requestApprenticeshipId"];
            this.requestApprenticeshipType = _data["requestApprenticeshipType"] ? DictionaryDto.fromJS(_data["requestApprenticeshipType"]) : undefined as any;
            this.requestApprenticeshipOrderCode = _data["requestApprenticeshipOrderCode"] ? OrderCodeDto.fromJS(_data["requestApprenticeshipOrderCode"]) : undefined as any;
            if (Array.isArray(_data["requestApprenticeshipOrderCodes"])) {
                this.requestApprenticeshipOrderCodes = [] as any;
                for (let item of _data["requestApprenticeshipOrderCodes"])
                    this.requestApprenticeshipOrderCodes!.push(OrderCodeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SelectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["partner"] = this.partner ? this.partner.toJSON() : undefined as any;
        data["operativeUnit"] = this.operativeUnit ? this.operativeUnit.toJSON() : undefined as any;
        data["contractProposal"] = this.contractProposal ? this.contractProposal.toJSON() : undefined as any;
        data["educationalDegreeLevel"] = this.educationalDegreeLevel ? this.educationalDegreeLevel.toJSON() : undefined as any;
        data["educationalDegree"] = this.educationalDegree ? this.educationalDegree.toJSON() : undefined as any;
        data["otherEducationalDegreeLevel"] = this.otherEducationalDegreeLevel;
        data["reference"] = this.reference;
        data["businessSector"] = this.businessSector ? this.businessSector.toJSON() : undefined as any;
        data["job"] = this.job ? this.job.toJSON() : undefined as any;
        data["placeOfWork"] = this.placeOfWork;
        data["requestType"] = this.requestType ? this.requestType.toJSON() : undefined as any;
        data["insertionDate"] = this.insertionDate ? this.insertionDate.format('YYYY-MM-DD') : undefined as any;
        data["experyDate"] = this.experyDate ? this.experyDate.format('YYYY-MM-DD') : undefined as any;
        data["hasCar"] = this.hasCar;
        if (Array.isArray(this.drivingLicenseTypes)) {
            data["drivingLicenseTypes"] = [];
            for (let item of this.drivingLicenseTypes)
                data["drivingLicenseTypes"].push(item ? item.toJSON() : undefined as any);
        }
        data["obligationLaw381"] = this.obligationLaw381;
        data["obligationLaw68"] = this.obligationLaw68;
        data["noisyEnvironment"] = this.noisyEnvironment;
        data["dustyEnvironment"] = this.dustyEnvironment;
        data["loadHandling"] = this.loadHandling;
        data["workMode"] = this.workMode ? this.workMode.toJSON() : undefined as any;
        data["description"] = this.description;
        data["note"] = this.note;
        data["isAlreadySelected"] = this.isAlreadySelected;
        if (Array.isArray(this.orderCodes)) {
            data["orderCodes"] = [];
            for (let item of this.orderCodes)
                data["orderCodes"].push(item ? item.toJSON() : undefined as any);
        }
        data["isPrivate"] = this.isPrivate;
        data["requestApprenticeshipId"] = this.requestApprenticeshipId;
        data["requestApprenticeshipType"] = this.requestApprenticeshipType ? this.requestApprenticeshipType.toJSON() : undefined as any;
        data["requestApprenticeshipOrderCode"] = this.requestApprenticeshipOrderCode ? this.requestApprenticeshipOrderCode.toJSON() : undefined as any;
        if (Array.isArray(this.requestApprenticeshipOrderCodes)) {
            data["requestApprenticeshipOrderCodes"] = [];
            for (let item of this.requestApprenticeshipOrderCodes)
                data["requestApprenticeshipOrderCodes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): SelectionDto {
        const json = this.toJSON();
        let result = new SelectionDto();
        result.init(json);
        return result;
    }
}

export interface ISelectionDto {
    id: number;
    title: string | undefined;
    partner: UserItemDto;
    operativeUnit: OperativeUnitDto;
    contractProposal: DictionaryDto;
    educationalDegreeLevel: DictionaryDto;
    educationalDegree: EducationalDegreeDto;
    otherEducationalDegreeLevel: string | undefined;
    reference: string | undefined;
    businessSector: DictionaryDto;
    job: DictionaryDto;
    placeOfWork: string | undefined;
    requestType: DictionaryDto;
    insertionDate: moment.Moment | undefined;
    experyDate: moment.Moment | undefined;
    hasCar: boolean | undefined;
    drivingLicenseTypes: DictionaryDto[] | undefined;
    obligationLaw381: boolean | undefined;
    obligationLaw68: boolean | undefined;
    noisyEnvironment: boolean | undefined;
    dustyEnvironment: boolean | undefined;
    loadHandling: boolean | undefined;
    workMode: DictionaryDto;
    description: string | undefined;
    note: string | undefined;
    isAlreadySelected: boolean;
    orderCodes: OrderCodeDto[] | undefined;
    isPrivate: boolean | undefined;
    requestApprenticeshipId: number | undefined;
    requestApprenticeshipType: DictionaryDto;
    requestApprenticeshipOrderCode: OrderCodeDto;
    requestApprenticeshipOrderCodes: OrderCodeDto[] | undefined;
}

export class SelectionDtoPagedResultDto implements ISelectionDtoPagedResultDto {
    items!: SelectionDto[] | undefined;
    totalCount!: number;

    constructor(data?: ISelectionDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SelectionDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SelectionDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectionDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): SelectionDtoPagedResultDto {
        const json = this.toJSON();
        let result = new SelectionDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ISelectionDtoPagedResultDto {
    items: SelectionDto[] | undefined;
    totalCount: number;
}

export class SelectionItemDto implements ISelectionItemDto {
    id!: number;
    title!: string | undefined;

    constructor(data?: ISelectionItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): SelectionItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectionItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        return data;
    }

    clone(): SelectionItemDto {
        const json = this.toJSON();
        let result = new SelectionItemDto();
        result.init(json);
        return result;
    }
}

export interface ISelectionItemDto {
    id: number;
    title: string | undefined;
}

export class SelectionJobSearchDto implements ISelectionJobSearchDto {
    id!: number;
    selection!: SelectionDto;
    jobExperiences!: JobExperienceDto[] | undefined;
    contractTypes!: DictionaryDto[] | undefined;
    hourEffort!: DictionaryDto;
    traineeshipAvailability!: boolean;
    shiftWorkAvailability!: boolean;
    businessTripAvailability!: boolean;
    timeAvailability!: TimeAvailabilityDto;
    daysAvailability!: DictionaryDto;

    constructor(data?: ISelectionJobSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.selection = _data["selection"] ? SelectionDto.fromJS(_data["selection"]) : undefined as any;
            if (Array.isArray(_data["jobExperiences"])) {
                this.jobExperiences = [] as any;
                for (let item of _data["jobExperiences"])
                    this.jobExperiences!.push(JobExperienceDto.fromJS(item));
            }
            if (Array.isArray(_data["contractTypes"])) {
                this.contractTypes = [] as any;
                for (let item of _data["contractTypes"])
                    this.contractTypes!.push(DictionaryDto.fromJS(item));
            }
            this.hourEffort = _data["hourEffort"] ? DictionaryDto.fromJS(_data["hourEffort"]) : undefined as any;
            this.traineeshipAvailability = _data["traineeshipAvailability"];
            this.shiftWorkAvailability = _data["shiftWorkAvailability"];
            this.businessTripAvailability = _data["businessTripAvailability"];
            this.timeAvailability = _data["timeAvailability"] ? TimeAvailabilityDto.fromJS(_data["timeAvailability"]) : undefined as any;
            this.daysAvailability = _data["daysAvailability"] ? DictionaryDto.fromJS(_data["daysAvailability"]) : undefined as any;
        }
    }

    static fromJS(data: any): SelectionJobSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectionJobSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["selection"] = this.selection ? this.selection.toJSON() : undefined as any;
        if (Array.isArray(this.jobExperiences)) {
            data["jobExperiences"] = [];
            for (let item of this.jobExperiences)
                data["jobExperiences"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.contractTypes)) {
            data["contractTypes"] = [];
            for (let item of this.contractTypes)
                data["contractTypes"].push(item ? item.toJSON() : undefined as any);
        }
        data["hourEffort"] = this.hourEffort ? this.hourEffort.toJSON() : undefined as any;
        data["traineeshipAvailability"] = this.traineeshipAvailability;
        data["shiftWorkAvailability"] = this.shiftWorkAvailability;
        data["businessTripAvailability"] = this.businessTripAvailability;
        data["timeAvailability"] = this.timeAvailability ? this.timeAvailability.toJSON() : undefined as any;
        data["daysAvailability"] = this.daysAvailability ? this.daysAvailability.toJSON() : undefined as any;
        return data;
    }

    clone(): SelectionJobSearchDto {
        const json = this.toJSON();
        let result = new SelectionJobSearchDto();
        result.init(json);
        return result;
    }
}

export interface ISelectionJobSearchDto {
    id: number;
    selection: SelectionDto;
    jobExperiences: JobExperienceDto[] | undefined;
    contractTypes: DictionaryDto[] | undefined;
    hourEffort: DictionaryDto;
    traineeshipAvailability: boolean;
    shiftWorkAvailability: boolean;
    businessTripAvailability: boolean;
    timeAvailability: TimeAvailabilityDto;
    daysAvailability: DictionaryDto;
}

export class SelectionJobSearchDtoPagedResultDto implements ISelectionJobSearchDtoPagedResultDto {
    items!: SelectionJobSearchDto[] | undefined;
    totalCount!: number;

    constructor(data?: ISelectionJobSearchDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SelectionJobSearchDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SelectionJobSearchDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectionJobSearchDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): SelectionJobSearchDtoPagedResultDto {
        const json = this.toJSON();
        let result = new SelectionJobSearchDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ISelectionJobSearchDtoPagedResultDto {
    items: SelectionJobSearchDto[] | undefined;
    totalCount: number;
}

export class SelectionLanguageDto implements ISelectionLanguageDto {
    id!: number;
    selection!: SelectionDto;
    language!: DictionaryDto;
    spokenLevel!: DictionaryDto;
    writtenLevel!: DictionaryDto;
    listeningLevel!: DictionaryDto;
    readingLevel!: DictionaryDto;
    certificate!: DictionaryDto;
    attested!: boolean;
    notes!: string | undefined;

    constructor(data?: ISelectionLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.selection = _data["selection"] ? SelectionDto.fromJS(_data["selection"]) : undefined as any;
            this.language = _data["language"] ? DictionaryDto.fromJS(_data["language"]) : undefined as any;
            this.spokenLevel = _data["spokenLevel"] ? DictionaryDto.fromJS(_data["spokenLevel"]) : undefined as any;
            this.writtenLevel = _data["writtenLevel"] ? DictionaryDto.fromJS(_data["writtenLevel"]) : undefined as any;
            this.listeningLevel = _data["listeningLevel"] ? DictionaryDto.fromJS(_data["listeningLevel"]) : undefined as any;
            this.readingLevel = _data["readingLevel"] ? DictionaryDto.fromJS(_data["readingLevel"]) : undefined as any;
            this.certificate = _data["certificate"] ? DictionaryDto.fromJS(_data["certificate"]) : undefined as any;
            this.attested = _data["attested"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): SelectionLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectionLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["selection"] = this.selection ? this.selection.toJSON() : undefined as any;
        data["language"] = this.language ? this.language.toJSON() : undefined as any;
        data["spokenLevel"] = this.spokenLevel ? this.spokenLevel.toJSON() : undefined as any;
        data["writtenLevel"] = this.writtenLevel ? this.writtenLevel.toJSON() : undefined as any;
        data["listeningLevel"] = this.listeningLevel ? this.listeningLevel.toJSON() : undefined as any;
        data["readingLevel"] = this.readingLevel ? this.readingLevel.toJSON() : undefined as any;
        data["certificate"] = this.certificate ? this.certificate.toJSON() : undefined as any;
        data["attested"] = this.attested;
        data["notes"] = this.notes;
        return data;
    }

    clone(): SelectionLanguageDto {
        const json = this.toJSON();
        let result = new SelectionLanguageDto();
        result.init(json);
        return result;
    }
}

export interface ISelectionLanguageDto {
    id: number;
    selection: SelectionDto;
    language: DictionaryDto;
    spokenLevel: DictionaryDto;
    writtenLevel: DictionaryDto;
    listeningLevel: DictionaryDto;
    readingLevel: DictionaryDto;
    certificate: DictionaryDto;
    attested: boolean;
    notes: string | undefined;
}

export class SelectionLanguageDtoPagedResultDto implements ISelectionLanguageDtoPagedResultDto {
    items!: SelectionLanguageDto[] | undefined;
    totalCount!: number;

    constructor(data?: ISelectionLanguageDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SelectionLanguageDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SelectionLanguageDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectionLanguageDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): SelectionLanguageDtoPagedResultDto {
        const json = this.toJSON();
        let result = new SelectionLanguageDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ISelectionLanguageDtoPagedResultDto {
    items: SelectionLanguageDto[] | undefined;
    totalCount: number;
}

export class SelectionQualificationDto implements ISelectionQualificationDto {
    id!: number;
    selection!: SelectionDto;
    qualificationType!: DictionaryDto;
    inProgress!: boolean;
    graduationDate!: moment.Moment | undefined;
    notes!: string | undefined;

    constructor(data?: ISelectionQualificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.selection = _data["selection"] ? SelectionDto.fromJS(_data["selection"]) : undefined as any;
            this.qualificationType = _data["qualificationType"] ? DictionaryDto.fromJS(_data["qualificationType"]) : undefined as any;
            this.inProgress = _data["inProgress"];
            this.graduationDate = _data["graduationDate"] ? moment(_data["graduationDate"].toString()) : undefined as any;
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): SelectionQualificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectionQualificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["selection"] = this.selection ? this.selection.toJSON() : undefined as any;
        data["qualificationType"] = this.qualificationType ? this.qualificationType.toJSON() : undefined as any;
        data["inProgress"] = this.inProgress;
        data["graduationDate"] = this.graduationDate ? this.graduationDate.format('YYYY-MM-DD') : undefined as any;
        data["notes"] = this.notes;
        return data;
    }

    clone(): SelectionQualificationDto {
        const json = this.toJSON();
        let result = new SelectionQualificationDto();
        result.init(json);
        return result;
    }
}

export interface ISelectionQualificationDto {
    id: number;
    selection: SelectionDto;
    qualificationType: DictionaryDto;
    inProgress: boolean;
    graduationDate: moment.Moment | undefined;
    notes: string | undefined;
}

export class SelectionQualificationDtoPagedResultDto implements ISelectionQualificationDtoPagedResultDto {
    items!: SelectionQualificationDto[] | undefined;
    totalCount!: number;

    constructor(data?: ISelectionQualificationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SelectionQualificationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SelectionQualificationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectionQualificationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): SelectionQualificationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new SelectionQualificationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ISelectionQualificationDtoPagedResultDto {
    items: SelectionQualificationDto[] | undefined;
    totalCount: number;
}

export class SelectionRatingDto implements ISelectionRatingDto {
    selection!: SelectionDto;
    matchingPercentage!: number;
    isAlreadySelected!: boolean;

    constructor(data?: ISelectionRatingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selection = _data["selection"] ? SelectionDto.fromJS(_data["selection"]) : undefined as any;
            this.matchingPercentage = _data["matchingPercentage"];
            this.isAlreadySelected = _data["isAlreadySelected"];
        }
    }

    static fromJS(data: any): SelectionRatingDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectionRatingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selection"] = this.selection ? this.selection.toJSON() : undefined as any;
        data["matchingPercentage"] = this.matchingPercentage;
        data["isAlreadySelected"] = this.isAlreadySelected;
        return data;
    }

    clone(): SelectionRatingDto {
        const json = this.toJSON();
        let result = new SelectionRatingDto();
        result.init(json);
        return result;
    }
}

export interface ISelectionRatingDto {
    selection: SelectionDto;
    matchingPercentage: number;
    isAlreadySelected: boolean;
}

export class SelectionRatingDtoPagedResultDto implements ISelectionRatingDtoPagedResultDto {
    items!: SelectionRatingDto[] | undefined;
    totalCount!: number;

    constructor(data?: ISelectionRatingDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SelectionRatingDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SelectionRatingDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectionRatingDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): SelectionRatingDtoPagedResultDto {
        const json = this.toJSON();
        let result = new SelectionRatingDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ISelectionRatingDtoPagedResultDto {
    items: SelectionRatingDto[] | undefined;
    totalCount: number;
}

export class SILServiceOperativeUnitDto implements ISILServiceOperativeUnitDto {
    id!: number;
    operativeUnit!: OperativeUnitDto;

    constructor(data?: ISILServiceOperativeUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.operativeUnit = _data["operativeUnit"] ? OperativeUnitDto.fromJS(_data["operativeUnit"]) : undefined as any;
        }
    }

    static fromJS(data: any): SILServiceOperativeUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new SILServiceOperativeUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["operativeUnit"] = this.operativeUnit ? this.operativeUnit.toJSON() : undefined as any;
        return data;
    }

    clone(): SILServiceOperativeUnitDto {
        const json = this.toJSON();
        let result = new SILServiceOperativeUnitDto();
        result.init(json);
        return result;
    }
}

export interface ISILServiceOperativeUnitDto {
    id: number;
    operativeUnit: OperativeUnitDto;
}

export enum TenantAvailabilityState {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class TenantDto implements ITenantDto {
    id!: number;
    tenancyName!: string;
    name!: string;
    isActive!: boolean;

    constructor(data?: ITenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): TenantDto {
        const json = this.toJSON();
        let result = new TenantDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDto {
    id: number;
    tenancyName: string;
    name: string;
    isActive: boolean;
}

export class TenantDtoPagedResultDto implements ITenantDtoPagedResultDto {
    items!: TenantDto[] | undefined;
    totalCount!: number;

    constructor(data?: ITenantDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TenantDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TenantDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TenantDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TenantDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDtoPagedResultDto {
    items: TenantDto[] | undefined;
    totalCount: number;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    id!: number;
    tenancyName!: string | undefined;
    name!: string | undefined;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        return data;
    }

    clone(): TenantLoginInfoDto {
        const json = this.toJSON();
        let result = new TenantLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface ITenantLoginInfoDto {
    id: number;
    tenancyName: string | undefined;
    name: string | undefined;
}

export class TimeAvailabilityDto implements ITimeAvailabilityDto {
    id!: number;
    timeAvailabilitySlot!: DictionaryDto;
    startDateTime!: moment.Moment | undefined;
    endDateTime!: moment.Moment | undefined;

    constructor(data?: ITimeAvailabilityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.timeAvailabilitySlot = _data["timeAvailabilitySlot"] ? DictionaryDto.fromJS(_data["timeAvailabilitySlot"]) : undefined as any;
            this.startDateTime = _data["startDateTime"] ? moment(_data["startDateTime"].toString()) : undefined as any;
            this.endDateTime = _data["endDateTime"] ? moment(_data["endDateTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): TimeAvailabilityDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimeAvailabilityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["timeAvailabilitySlot"] = this.timeAvailabilitySlot ? this.timeAvailabilitySlot.toJSON() : undefined as any;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : undefined as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : undefined as any;
        return data;
    }

    clone(): TimeAvailabilityDto {
        const json = this.toJSON();
        let result = new TimeAvailabilityDto();
        result.init(json);
        return result;
    }
}

export interface ITimeAvailabilityDto {
    id: number;
    timeAvailabilitySlot: DictionaryDto;
    startDateTime: moment.Moment | undefined;
    endDateTime: moment.Moment | undefined;
}

export class UpdateApprenticeshipDto implements IUpdateApprenticeshipDto {
    id!: number;
    stateId!: number | undefined;
    dgrId!: number | undefined;
    internIBAN!: string | undefined;
    apprenticeshipAdditionalData!: CreateApprenticeshipAdditionalDataDto;
    tutorORSoId!: number | undefined;
    externalTutor!: string | undefined;
    startDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    startSuspensionDate!: moment.Moment | undefined;
    endSuspensionDate!: moment.Moment | undefined;
    interruptionFrom!: moment.Moment | undefined;
    isPrivate!: boolean;
    isPaidService!: boolean;
    invoice!: string | undefined;
    compensationPaidByOrso!: boolean;
    compensationIban!: string | undefined;

    constructor(data?: IUpdateApprenticeshipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stateId = _data["stateId"];
            this.dgrId = _data["dgrId"];
            this.internIBAN = _data["internIBAN"];
            this.apprenticeshipAdditionalData = _data["apprenticeshipAdditionalData"] ? CreateApprenticeshipAdditionalDataDto.fromJS(_data["apprenticeshipAdditionalData"]) : undefined as any;
            this.tutorORSoId = _data["tutorORSoId"];
            this.externalTutor = _data["externalTutor"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : undefined as any;
            this.startSuspensionDate = _data["startSuspensionDate"] ? moment(_data["startSuspensionDate"].toString()) : undefined as any;
            this.endSuspensionDate = _data["endSuspensionDate"] ? moment(_data["endSuspensionDate"].toString()) : undefined as any;
            this.interruptionFrom = _data["interruptionFrom"] ? moment(_data["interruptionFrom"].toString()) : undefined as any;
            this.isPrivate = _data["isPrivate"];
            this.isPaidService = _data["isPaidService"];
            this.invoice = _data["invoice"];
            this.compensationPaidByOrso = _data["compensationPaidByOrso"];
            this.compensationIban = _data["compensationIban"];
        }
    }

    static fromJS(data: any): UpdateApprenticeshipDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateApprenticeshipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stateId"] = this.stateId;
        data["dgrId"] = this.dgrId;
        data["internIBAN"] = this.internIBAN;
        data["apprenticeshipAdditionalData"] = this.apprenticeshipAdditionalData ? this.apprenticeshipAdditionalData.toJSON() : undefined as any;
        data["tutorORSoId"] = this.tutorORSoId;
        data["externalTutor"] = this.externalTutor;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["startSuspensionDate"] = this.startSuspensionDate ? this.startSuspensionDate.toISOString() : undefined as any;
        data["endSuspensionDate"] = this.endSuspensionDate ? this.endSuspensionDate.toISOString() : undefined as any;
        data["interruptionFrom"] = this.interruptionFrom ? this.interruptionFrom.toISOString() : undefined as any;
        data["isPrivate"] = this.isPrivate;
        data["isPaidService"] = this.isPaidService;
        data["invoice"] = this.invoice;
        data["compensationPaidByOrso"] = this.compensationPaidByOrso;
        data["compensationIban"] = this.compensationIban;
        return data;
    }

    clone(): UpdateApprenticeshipDto {
        const json = this.toJSON();
        let result = new UpdateApprenticeshipDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateApprenticeshipDto {
    id: number;
    stateId: number | undefined;
    dgrId: number | undefined;
    internIBAN: string | undefined;
    apprenticeshipAdditionalData: CreateApprenticeshipAdditionalDataDto;
    tutorORSoId: number | undefined;
    externalTutor: string | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    startSuspensionDate: moment.Moment | undefined;
    endSuspensionDate: moment.Moment | undefined;
    interruptionFrom: moment.Moment | undefined;
    isPrivate: boolean;
    isPaidService: boolean;
    invoice: string | undefined;
    compensationPaidByOrso: boolean;
    compensationIban: string | undefined;
}

export class UpdateApprenticeshipExtensionDto implements IUpdateApprenticeshipExtensionDto {
    id!: number;
    startDateTime!: moment.Moment | undefined;
    endDateTime!: moment.Moment | undefined;

    constructor(data?: IUpdateApprenticeshipExtensionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startDateTime = _data["startDateTime"] ? moment(_data["startDateTime"].toString()) : undefined as any;
            this.endDateTime = _data["endDateTime"] ? moment(_data["endDateTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateApprenticeshipExtensionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateApprenticeshipExtensionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : undefined as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : undefined as any;
        return data;
    }

    clone(): UpdateApprenticeshipExtensionDto {
        const json = this.toJSON();
        let result = new UpdateApprenticeshipExtensionDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateApprenticeshipExtensionDto {
    id: number;
    startDateTime: moment.Moment | undefined;
    endDateTime: moment.Moment | undefined;
}

export class UpdateCompensationPaymentRequestDto implements IUpdateCompensationPaymentRequestDto {
    id!: number;
    monthId!: number;
    year!: number;
    tutorRequest!: number | undefined;
    totalPayment!: number | undefined;
    paymentConfirmed!: boolean;

    constructor(data?: IUpdateCompensationPaymentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.monthId = _data["monthId"];
            this.year = _data["year"];
            this.tutorRequest = _data["tutorRequest"];
            this.totalPayment = _data["totalPayment"];
            this.paymentConfirmed = _data["paymentConfirmed"];
        }
    }

    static fromJS(data: any): UpdateCompensationPaymentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompensationPaymentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["monthId"] = this.monthId;
        data["year"] = this.year;
        data["tutorRequest"] = this.tutorRequest;
        data["totalPayment"] = this.totalPayment;
        data["paymentConfirmed"] = this.paymentConfirmed;
        return data;
    }

    clone(): UpdateCompensationPaymentRequestDto {
        const json = this.toJSON();
        let result = new UpdateCompensationPaymentRequestDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCompensationPaymentRequestDto {
    id: number;
    monthId: number;
    year: number;
    tutorRequest: number | undefined;
    totalPayment: number | undefined;
    paymentConfirmed: boolean;
}

export class UpdateContactPersonDto implements IUpdateContactPersonDto {
    id!: number;
    userId!: number;
    name!: string;
    surname!: string;
    email!: string;
    role!: string | undefined;
    phoneNumber!: string | undefined;

    constructor(data?: IUpdateContactPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.email = _data["email"];
            this.role = _data["role"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): UpdateContactPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateContactPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["email"] = this.email;
        data["role"] = this.role;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }

    clone(): UpdateContactPersonDto {
        const json = this.toJSON();
        let result = new UpdateContactPersonDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateContactPersonDto {
    id: number;
    userId: number;
    name: string;
    surname: string;
    email: string;
    role: string | undefined;
    phoneNumber: string | undefined;
}

export class UpdateConventionDto implements IUpdateConventionDto {
    id!: number;
    expirationDate!: moment.Moment;
    conventionTypeId!: number;
    orderCodeIds!: number[] | undefined;
    fileIds!: number[] | undefined;

    constructor(data?: IUpdateConventionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : undefined as any;
            this.conventionTypeId = _data["conventionTypeId"];
            if (Array.isArray(_data["orderCodeIds"])) {
                this.orderCodeIds = [] as any;
                for (let item of _data["orderCodeIds"])
                    this.orderCodeIds!.push(item);
            }
            if (Array.isArray(_data["fileIds"])) {
                this.fileIds = [] as any;
                for (let item of _data["fileIds"])
                    this.fileIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateConventionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateConventionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : undefined as any;
        data["conventionTypeId"] = this.conventionTypeId;
        if (Array.isArray(this.orderCodeIds)) {
            data["orderCodeIds"] = [];
            for (let item of this.orderCodeIds)
                data["orderCodeIds"].push(item);
        }
        if (Array.isArray(this.fileIds)) {
            data["fileIds"] = [];
            for (let item of this.fileIds)
                data["fileIds"].push(item);
        }
        return data;
    }

    clone(): UpdateConventionDto {
        const json = this.toJSON();
        let result = new UpdateConventionDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateConventionDto {
    id: number;
    expirationDate: moment.Moment;
    conventionTypeId: number;
    orderCodeIds: number[] | undefined;
    fileIds: number[] | undefined;
}

export class UpdateJobSearchDto implements IUpdateJobSearchDto {
    id!: number;
    jobExperiences!: CreateJobExperienceDto[] | undefined;
    contractTypeIds!: number[] | undefined;
    hourEffortId!: number | undefined;
    traineeshipAvailability!: boolean | undefined;
    shiftWorkAvailability!: boolean | undefined;
    businessTripAvailability!: boolean | undefined;
    timeAvailability!: CreateTimeAvailabilityDto;
    daysAvailabilityId!: number | undefined;

    constructor(data?: IUpdateJobSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["jobExperiences"])) {
                this.jobExperiences = [] as any;
                for (let item of _data["jobExperiences"])
                    this.jobExperiences!.push(CreateJobExperienceDto.fromJS(item));
            }
            if (Array.isArray(_data["contractTypeIds"])) {
                this.contractTypeIds = [] as any;
                for (let item of _data["contractTypeIds"])
                    this.contractTypeIds!.push(item);
            }
            this.hourEffortId = _data["hourEffortId"];
            this.traineeshipAvailability = _data["traineeshipAvailability"];
            this.shiftWorkAvailability = _data["shiftWorkAvailability"];
            this.businessTripAvailability = _data["businessTripAvailability"];
            this.timeAvailability = _data["timeAvailability"] ? CreateTimeAvailabilityDto.fromJS(_data["timeAvailability"]) : undefined as any;
            this.daysAvailabilityId = _data["daysAvailabilityId"];
        }
    }

    static fromJS(data: any): UpdateJobSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateJobSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.jobExperiences)) {
            data["jobExperiences"] = [];
            for (let item of this.jobExperiences)
                data["jobExperiences"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.contractTypeIds)) {
            data["contractTypeIds"] = [];
            for (let item of this.contractTypeIds)
                data["contractTypeIds"].push(item);
        }
        data["hourEffortId"] = this.hourEffortId;
        data["traineeshipAvailability"] = this.traineeshipAvailability;
        data["shiftWorkAvailability"] = this.shiftWorkAvailability;
        data["businessTripAvailability"] = this.businessTripAvailability;
        data["timeAvailability"] = this.timeAvailability ? this.timeAvailability.toJSON() : undefined as any;
        data["daysAvailabilityId"] = this.daysAvailabilityId;
        return data;
    }

    clone(): UpdateJobSearchDto {
        const json = this.toJSON();
        let result = new UpdateJobSearchDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateJobSearchDto {
    id: number;
    jobExperiences: CreateJobExperienceDto[] | undefined;
    contractTypeIds: number[] | undefined;
    hourEffortId: number | undefined;
    traineeshipAvailability: boolean | undefined;
    shiftWorkAvailability: boolean | undefined;
    businessTripAvailability: boolean | undefined;
    timeAvailability: CreateTimeAvailabilityDto;
    daysAvailabilityId: number | undefined;
}

export class UpdateLaborConsultantDto implements IUpdateLaborConsultantDto {
    id!: number;
    businessName!: string;
    phoneNumber!: string;
    responsibleName!: string | undefined;
    vatNumber!: string | undefined;
    fiscalCode!: string | undefined;
    email!: string | undefined;
    address!: CreateAddressDto;
    notes!: string | undefined;

    constructor(data?: IUpdateLaborConsultantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.businessName = _data["businessName"];
            this.phoneNumber = _data["phoneNumber"];
            this.responsibleName = _data["responsibleName"];
            this.vatNumber = _data["vatNumber"];
            this.fiscalCode = _data["fiscalCode"];
            this.email = _data["email"];
            this.address = _data["address"] ? CreateAddressDto.fromJS(_data["address"]) : undefined as any;
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateLaborConsultantDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLaborConsultantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["businessName"] = this.businessName;
        data["phoneNumber"] = this.phoneNumber;
        data["responsibleName"] = this.responsibleName;
        data["vatNumber"] = this.vatNumber;
        data["fiscalCode"] = this.fiscalCode;
        data["email"] = this.email;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["notes"] = this.notes;
        return data;
    }

    clone(): UpdateLaborConsultantDto {
        const json = this.toJSON();
        let result = new UpdateLaborConsultantDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateLaborConsultantDto {
    id: number;
    businessName: string;
    phoneNumber: string;
    responsibleName: string | undefined;
    vatNumber: string | undefined;
    fiscalCode: string | undefined;
    email: string | undefined;
    address: CreateAddressDto;
    notes: string | undefined;
}

export class UpdateOperativeUnitDto implements IUpdateOperativeUnitDto {
    id!: number;
    headOffice!: string | undefined;
    address!: CreateAddressDto;
    contact!: string | undefined;

    constructor(data?: IUpdateOperativeUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.headOffice = _data["headOffice"];
            this.address = _data["address"] ? CreateAddressDto.fromJS(_data["address"]) : undefined as any;
            this.contact = _data["contact"];
        }
    }

    static fromJS(data: any): UpdateOperativeUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOperativeUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["headOffice"] = this.headOffice;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["contact"] = this.contact;
        return data;
    }

    clone(): UpdateOperativeUnitDto {
        const json = this.toJSON();
        let result = new UpdateOperativeUnitDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateOperativeUnitDto {
    id: number;
    headOffice: string | undefined;
    address: CreateAddressDto;
    contact: string | undefined;
}

export class UpdateOrderCodeDto implements IUpdateOrderCodeDto {
    id!: number;
    description!: string | undefined;

    constructor(data?: IUpdateOrderCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UpdateOrderCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrderCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    }

    clone(): UpdateOrderCodeDto {
        const json = this.toJSON();
        let result = new UpdateOrderCodeDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateOrderCodeDto {
    id: number;
    description: string | undefined;
}

export class UpdatePartnerServiceDto implements IUpdatePartnerServiceDto {
    id!: number;
    silServiceOperativeUnits!: CreateSILServiceOperativeUnitDto[] | undefined;
    agencyServiceOperativeUnits!: CreateAgencyServiceOperativeUnitDto[] | undefined;
    silLastContact!: string | undefined;
    agencyLastContact!: string | undefined;
    hasSILService!: boolean | undefined;
    hasAgencyService!: boolean | undefined;

    constructor(data?: IUpdatePartnerServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["silServiceOperativeUnits"])) {
                this.silServiceOperativeUnits = [] as any;
                for (let item of _data["silServiceOperativeUnits"])
                    this.silServiceOperativeUnits!.push(CreateSILServiceOperativeUnitDto.fromJS(item));
            }
            if (Array.isArray(_data["agencyServiceOperativeUnits"])) {
                this.agencyServiceOperativeUnits = [] as any;
                for (let item of _data["agencyServiceOperativeUnits"])
                    this.agencyServiceOperativeUnits!.push(CreateAgencyServiceOperativeUnitDto.fromJS(item));
            }
            this.silLastContact = _data["silLastContact"];
            this.agencyLastContact = _data["agencyLastContact"];
            this.hasSILService = _data["hasSILService"];
            this.hasAgencyService = _data["hasAgencyService"];
        }
    }

    static fromJS(data: any): UpdatePartnerServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePartnerServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.silServiceOperativeUnits)) {
            data["silServiceOperativeUnits"] = [];
            for (let item of this.silServiceOperativeUnits)
                data["silServiceOperativeUnits"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.agencyServiceOperativeUnits)) {
            data["agencyServiceOperativeUnits"] = [];
            for (let item of this.agencyServiceOperativeUnits)
                data["agencyServiceOperativeUnits"].push(item ? item.toJSON() : undefined as any);
        }
        data["silLastContact"] = this.silLastContact;
        data["agencyLastContact"] = this.agencyLastContact;
        data["hasSILService"] = this.hasSILService;
        data["hasAgencyService"] = this.hasAgencyService;
        return data;
    }

    clone(): UpdatePartnerServiceDto {
        const json = this.toJSON();
        let result = new UpdatePartnerServiceDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePartnerServiceDto {
    id: number;
    silServiceOperativeUnits: CreateSILServiceOperativeUnitDto[] | undefined;
    agencyServiceOperativeUnits: CreateAgencyServiceOperativeUnitDto[] | undefined;
    silLastContact: string | undefined;
    agencyLastContact: string | undefined;
    hasSILService: boolean | undefined;
    hasAgencyService: boolean | undefined;
}

export class UpdatePartnerSurveyDto implements IUpdatePartnerSurveyDto {
    id!: number;
    hastJobPlacementApprenticeships!: number;
    hostTrainingApprenticeship!: number;
    participantOrientationInitiatives!: number;
    hostJobTrialEvents!: number;

    constructor(data?: IUpdatePartnerSurveyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.hastJobPlacementApprenticeships = _data["hastJobPlacementApprenticeships"];
            this.hostTrainingApprenticeship = _data["hostTrainingApprenticeship"];
            this.participantOrientationInitiatives = _data["participantOrientationInitiatives"];
            this.hostJobTrialEvents = _data["hostJobTrialEvents"];
        }
    }

    static fromJS(data: any): UpdatePartnerSurveyDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePartnerSurveyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["hastJobPlacementApprenticeships"] = this.hastJobPlacementApprenticeships;
        data["hostTrainingApprenticeship"] = this.hostTrainingApprenticeship;
        data["participantOrientationInitiatives"] = this.participantOrientationInitiatives;
        data["hostJobTrialEvents"] = this.hostJobTrialEvents;
        return data;
    }

    clone(): UpdatePartnerSurveyDto {
        const json = this.toJSON();
        let result = new UpdatePartnerSurveyDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePartnerSurveyDto {
    id: number;
    hastJobPlacementApprenticeships: number;
    hostTrainingApprenticeship: number;
    participantOrientationInitiatives: number;
    hostJobTrialEvents: number;
}

export class UpdatePersonalInfoDto implements IUpdatePersonalInfoDto {
    id!: number;
    userId!: number;
    employmentStatusId!: number | undefined;
    currentCompany!: string | undefined;
    phoneNumber!: string | undefined;
    maritalStatusId!: number | undefined;
    childrenNumber!: number | undefined;
    hasCar!: boolean | undefined;
    hasDrivingLicense!: boolean | undefined;
    drivingLicenseTypeIds!: number[] | undefined;
    usePublicTransport!: boolean | undefined;
    hasIndependently!: boolean | undefined;
    hasAvilabilityTravel!: boolean | undefined;
    kmRadius!: number | undefined;
    drivingLicenseDescription!: string | undefined;
    orderCodeIds!: number[] | undefined;
    atecoCodeIds!: number[] | undefined;

    constructor(data?: IUpdatePersonalInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.employmentStatusId = _data["employmentStatusId"];
            this.currentCompany = _data["currentCompany"];
            this.phoneNumber = _data["phoneNumber"];
            this.maritalStatusId = _data["maritalStatusId"];
            this.childrenNumber = _data["childrenNumber"];
            this.hasCar = _data["hasCar"];
            this.hasDrivingLicense = _data["hasDrivingLicense"];
            if (Array.isArray(_data["drivingLicenseTypeIds"])) {
                this.drivingLicenseTypeIds = [] as any;
                for (let item of _data["drivingLicenseTypeIds"])
                    this.drivingLicenseTypeIds!.push(item);
            }
            this.usePublicTransport = _data["usePublicTransport"];
            this.hasIndependently = _data["hasIndependently"];
            this.hasAvilabilityTravel = _data["hasAvilabilityTravel"];
            this.kmRadius = _data["kmRadius"];
            this.drivingLicenseDescription = _data["drivingLicenseDescription"];
            if (Array.isArray(_data["orderCodeIds"])) {
                this.orderCodeIds = [] as any;
                for (let item of _data["orderCodeIds"])
                    this.orderCodeIds!.push(item);
            }
            if (Array.isArray(_data["atecoCodeIds"])) {
                this.atecoCodeIds = [] as any;
                for (let item of _data["atecoCodeIds"])
                    this.atecoCodeIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdatePersonalInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePersonalInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["employmentStatusId"] = this.employmentStatusId;
        data["currentCompany"] = this.currentCompany;
        data["phoneNumber"] = this.phoneNumber;
        data["maritalStatusId"] = this.maritalStatusId;
        data["childrenNumber"] = this.childrenNumber;
        data["hasCar"] = this.hasCar;
        data["hasDrivingLicense"] = this.hasDrivingLicense;
        if (Array.isArray(this.drivingLicenseTypeIds)) {
            data["drivingLicenseTypeIds"] = [];
            for (let item of this.drivingLicenseTypeIds)
                data["drivingLicenseTypeIds"].push(item);
        }
        data["usePublicTransport"] = this.usePublicTransport;
        data["hasIndependently"] = this.hasIndependently;
        data["hasAvilabilityTravel"] = this.hasAvilabilityTravel;
        data["kmRadius"] = this.kmRadius;
        data["drivingLicenseDescription"] = this.drivingLicenseDescription;
        if (Array.isArray(this.orderCodeIds)) {
            data["orderCodeIds"] = [];
            for (let item of this.orderCodeIds)
                data["orderCodeIds"].push(item);
        }
        if (Array.isArray(this.atecoCodeIds)) {
            data["atecoCodeIds"] = [];
            for (let item of this.atecoCodeIds)
                data["atecoCodeIds"].push(item);
        }
        return data;
    }

    clone(): UpdatePersonalInfoDto {
        const json = this.toJSON();
        let result = new UpdatePersonalInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePersonalInfoDto {
    id: number;
    userId: number;
    employmentStatusId: number | undefined;
    currentCompany: string | undefined;
    phoneNumber: string | undefined;
    maritalStatusId: number | undefined;
    childrenNumber: number | undefined;
    hasCar: boolean | undefined;
    hasDrivingLicense: boolean | undefined;
    drivingLicenseTypeIds: number[] | undefined;
    usePublicTransport: boolean | undefined;
    hasIndependently: boolean | undefined;
    hasAvilabilityTravel: boolean | undefined;
    kmRadius: number | undefined;
    drivingLicenseDescription: string | undefined;
    orderCodeIds: number[] | undefined;
    atecoCodeIds: number[] | undefined;
}

export class UpdateRequestApprenticeshipDto implements IUpdateRequestApprenticeshipDto {
    id!: number;
    title!: string;
    partnerId!: number;
    operativeUnitId!: number;
    contractProposalId!: number | undefined;
    placeOfWork!: string | undefined;
    requestApprenticeshipTypeId!: number | undefined;
    startDateTime!: moment.Moment | undefined;
    endDateTime!: moment.Moment | undefined;
    educationalDegreeLevelId!: number;
    educationalDegreeId!: number | undefined;
    otherEducationalDegreeLevel!: string | undefined;
    reference!: string | undefined;
    businessSectorId!: number;
    jobId!: number | undefined;
    requestTypeId!: number | undefined;
    requestApprenticeshipStateId!: number | undefined;
    orderCodeIds!: number[] | undefined;
    publish!: boolean;

    constructor(data?: IUpdateRequestApprenticeshipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.partnerId = _data["partnerId"];
            this.operativeUnitId = _data["operativeUnitId"];
            this.contractProposalId = _data["contractProposalId"];
            this.placeOfWork = _data["placeOfWork"];
            this.requestApprenticeshipTypeId = _data["requestApprenticeshipTypeId"];
            this.startDateTime = _data["startDateTime"] ? moment(_data["startDateTime"].toString()) : undefined as any;
            this.endDateTime = _data["endDateTime"] ? moment(_data["endDateTime"].toString()) : undefined as any;
            this.educationalDegreeLevelId = _data["educationalDegreeLevelId"];
            this.educationalDegreeId = _data["educationalDegreeId"];
            this.otherEducationalDegreeLevel = _data["otherEducationalDegreeLevel"];
            this.reference = _data["reference"];
            this.businessSectorId = _data["businessSectorId"];
            this.jobId = _data["jobId"];
            this.requestTypeId = _data["requestTypeId"];
            this.requestApprenticeshipStateId = _data["requestApprenticeshipStateId"];
            if (Array.isArray(_data["orderCodeIds"])) {
                this.orderCodeIds = [] as any;
                for (let item of _data["orderCodeIds"])
                    this.orderCodeIds!.push(item);
            }
            this.publish = _data["publish"];
        }
    }

    static fromJS(data: any): UpdateRequestApprenticeshipDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRequestApprenticeshipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["partnerId"] = this.partnerId;
        data["operativeUnitId"] = this.operativeUnitId;
        data["contractProposalId"] = this.contractProposalId;
        data["placeOfWork"] = this.placeOfWork;
        data["requestApprenticeshipTypeId"] = this.requestApprenticeshipTypeId;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : undefined as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : undefined as any;
        data["educationalDegreeLevelId"] = this.educationalDegreeLevelId;
        data["educationalDegreeId"] = this.educationalDegreeId;
        data["otherEducationalDegreeLevel"] = this.otherEducationalDegreeLevel;
        data["reference"] = this.reference;
        data["businessSectorId"] = this.businessSectorId;
        data["jobId"] = this.jobId;
        data["requestTypeId"] = this.requestTypeId;
        data["requestApprenticeshipStateId"] = this.requestApprenticeshipStateId;
        if (Array.isArray(this.orderCodeIds)) {
            data["orderCodeIds"] = [];
            for (let item of this.orderCodeIds)
                data["orderCodeIds"].push(item);
        }
        data["publish"] = this.publish;
        return data;
    }

    clone(): UpdateRequestApprenticeshipDto {
        const json = this.toJSON();
        let result = new UpdateRequestApprenticeshipDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateRequestApprenticeshipDto {
    id: number;
    title: string;
    partnerId: number;
    operativeUnitId: number;
    contractProposalId: number | undefined;
    placeOfWork: string | undefined;
    requestApprenticeshipTypeId: number | undefined;
    startDateTime: moment.Moment | undefined;
    endDateTime: moment.Moment | undefined;
    educationalDegreeLevelId: number;
    educationalDegreeId: number | undefined;
    otherEducationalDegreeLevel: string | undefined;
    reference: string | undefined;
    businessSectorId: number;
    jobId: number | undefined;
    requestTypeId: number | undefined;
    requestApprenticeshipStateId: number | undefined;
    orderCodeIds: number[] | undefined;
    publish: boolean;
}

export class UpdateResidenceInfoDto implements IUpdateResidenceInfoDto {
    id!: number;
    userId!: number;
    employmentCenterRegistration!: boolean | undefined;
    residencePermitId!: number | undefined;
    motivationResidencePermitId!: number | undefined;
    empiryDateResindence!: moment.Moment | undefined;
    incomeSupportRecipient!: boolean | undefined;
    incomeSupportTypeIds!: number[] | undefined;
    residence!: CreateAddressDto;
    isDomicileOther!: boolean | undefined;
    domicile!: CreateAddressDto;
    policeRelease!: string | undefined;

    constructor(data?: IUpdateResidenceInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.employmentCenterRegistration = _data["employmentCenterRegistration"];
            this.residencePermitId = _data["residencePermitId"];
            this.motivationResidencePermitId = _data["motivationResidencePermitId"];
            this.empiryDateResindence = _data["empiryDateResindence"] ? moment(_data["empiryDateResindence"].toString()) : undefined as any;
            this.incomeSupportRecipient = _data["incomeSupportRecipient"];
            if (Array.isArray(_data["incomeSupportTypeIds"])) {
                this.incomeSupportTypeIds = [] as any;
                for (let item of _data["incomeSupportTypeIds"])
                    this.incomeSupportTypeIds!.push(item);
            }
            this.residence = _data["residence"] ? CreateAddressDto.fromJS(_data["residence"]) : undefined as any;
            this.isDomicileOther = _data["isDomicileOther"];
            this.domicile = _data["domicile"] ? CreateAddressDto.fromJS(_data["domicile"]) : undefined as any;
            this.policeRelease = _data["policeRelease"];
        }
    }

    static fromJS(data: any): UpdateResidenceInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateResidenceInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["employmentCenterRegistration"] = this.employmentCenterRegistration;
        data["residencePermitId"] = this.residencePermitId;
        data["motivationResidencePermitId"] = this.motivationResidencePermitId;
        data["empiryDateResindence"] = this.empiryDateResindence ? this.empiryDateResindence.format('YYYY-MM-DD') : undefined as any;
        data["incomeSupportRecipient"] = this.incomeSupportRecipient;
        if (Array.isArray(this.incomeSupportTypeIds)) {
            data["incomeSupportTypeIds"] = [];
            for (let item of this.incomeSupportTypeIds)
                data["incomeSupportTypeIds"].push(item);
        }
        data["residence"] = this.residence ? this.residence.toJSON() : undefined as any;
        data["isDomicileOther"] = this.isDomicileOther;
        data["domicile"] = this.domicile ? this.domicile.toJSON() : undefined as any;
        data["policeRelease"] = this.policeRelease;
        return data;
    }

    clone(): UpdateResidenceInfoDto {
        const json = this.toJSON();
        let result = new UpdateResidenceInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateResidenceInfoDto {
    id: number;
    userId: number;
    employmentCenterRegistration: boolean | undefined;
    residencePermitId: number | undefined;
    motivationResidencePermitId: number | undefined;
    empiryDateResindence: moment.Moment | undefined;
    incomeSupportRecipient: boolean | undefined;
    incomeSupportTypeIds: number[] | undefined;
    residence: CreateAddressDto;
    isDomicileOther: boolean | undefined;
    domicile: CreateAddressDto;
    policeRelease: string | undefined;
}

export class UpdateSelectionApplicationDto implements IUpdateSelectionApplicationDto {
    id!: number;
    personId!: number;
    selectionId!: number;
    interviewResult!: boolean | undefined;
    interviewDate!: moment.Moment | undefined;

    constructor(data?: IUpdateSelectionApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.selectionId = _data["selectionId"];
            this.interviewResult = _data["interviewResult"];
            this.interviewDate = _data["interviewDate"] ? moment(_data["interviewDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateSelectionApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSelectionApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["selectionId"] = this.selectionId;
        data["interviewResult"] = this.interviewResult;
        data["interviewDate"] = this.interviewDate ? this.interviewDate.format('YYYY-MM-DD') : undefined as any;
        return data;
    }

    clone(): UpdateSelectionApplicationDto {
        const json = this.toJSON();
        let result = new UpdateSelectionApplicationDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateSelectionApplicationDto {
    id: number;
    personId: number;
    selectionId: number;
    interviewResult: boolean | undefined;
    interviewDate: moment.Moment | undefined;
}

export class UpdateSelectionComputerSkillDto implements IUpdateSelectionComputerSkillDto {
    id!: number;
    computerSkillId!: number;
    notes!: string | undefined;

    constructor(data?: IUpdateSelectionComputerSkillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.computerSkillId = _data["computerSkillId"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateSelectionComputerSkillDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSelectionComputerSkillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["computerSkillId"] = this.computerSkillId;
        data["notes"] = this.notes;
        return data;
    }

    clone(): UpdateSelectionComputerSkillDto {
        const json = this.toJSON();
        let result = new UpdateSelectionComputerSkillDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateSelectionComputerSkillDto {
    id: number;
    computerSkillId: number;
    notes: string | undefined;
}

export class UpdateSelectionDto implements IUpdateSelectionDto {
    id!: number;
    title!: string | undefined;
    partnerId!: number | undefined;
    operativeUnitId!: number | undefined;
    contractProposalId!: number | undefined;
    educationalDegreeLevelId!: number;
    educationalDegreeId!: number | undefined;
    otherEducationalDegreeLevel!: string | undefined;
    businessSectorId!: number | undefined;
    jobId!: number | undefined;
    placeOfWork!: string | undefined;
    insertionDate!: moment.Moment | undefined;
    experyDate!: moment.Moment | undefined;
    requestTypeId!: number | undefined;
    hasCar!: boolean | undefined;
    drivingLicenseTypeIds!: number[] | undefined;
    obligationLaw381!: boolean | undefined;
    obligationLaw68!: boolean | undefined;
    noisyEnvironment!: boolean | undefined;
    dustyEnvironment!: boolean | undefined;
    loadHandling!: boolean | undefined;
    workModeId!: number | undefined;
    description!: string | undefined;
    note!: string | undefined;
    orderCodeIds!: number[] | undefined;
    isPrivate!: boolean | undefined;

    constructor(data?: IUpdateSelectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.partnerId = _data["partnerId"];
            this.operativeUnitId = _data["operativeUnitId"];
            this.contractProposalId = _data["contractProposalId"];
            this.educationalDegreeLevelId = _data["educationalDegreeLevelId"];
            this.educationalDegreeId = _data["educationalDegreeId"];
            this.otherEducationalDegreeLevel = _data["otherEducationalDegreeLevel"];
            this.businessSectorId = _data["businessSectorId"];
            this.jobId = _data["jobId"];
            this.placeOfWork = _data["placeOfWork"];
            this.insertionDate = _data["insertionDate"] ? moment(_data["insertionDate"].toString()) : undefined as any;
            this.experyDate = _data["experyDate"] ? moment(_data["experyDate"].toString()) : undefined as any;
            this.requestTypeId = _data["requestTypeId"];
            this.hasCar = _data["hasCar"];
            if (Array.isArray(_data["drivingLicenseTypeIds"])) {
                this.drivingLicenseTypeIds = [] as any;
                for (let item of _data["drivingLicenseTypeIds"])
                    this.drivingLicenseTypeIds!.push(item);
            }
            this.obligationLaw381 = _data["obligationLaw381"];
            this.obligationLaw68 = _data["obligationLaw68"];
            this.noisyEnvironment = _data["noisyEnvironment"];
            this.dustyEnvironment = _data["dustyEnvironment"];
            this.loadHandling = _data["loadHandling"];
            this.workModeId = _data["workModeId"];
            this.description = _data["description"];
            this.note = _data["note"];
            if (Array.isArray(_data["orderCodeIds"])) {
                this.orderCodeIds = [] as any;
                for (let item of _data["orderCodeIds"])
                    this.orderCodeIds!.push(item);
            }
            this.isPrivate = _data["isPrivate"];
        }
    }

    static fromJS(data: any): UpdateSelectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSelectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["partnerId"] = this.partnerId;
        data["operativeUnitId"] = this.operativeUnitId;
        data["contractProposalId"] = this.contractProposalId;
        data["educationalDegreeLevelId"] = this.educationalDegreeLevelId;
        data["educationalDegreeId"] = this.educationalDegreeId;
        data["otherEducationalDegreeLevel"] = this.otherEducationalDegreeLevel;
        data["businessSectorId"] = this.businessSectorId;
        data["jobId"] = this.jobId;
        data["placeOfWork"] = this.placeOfWork;
        data["insertionDate"] = this.insertionDate ? this.insertionDate.format('YYYY-MM-DD') : undefined as any;
        data["experyDate"] = this.experyDate ? this.experyDate.format('YYYY-MM-DD') : undefined as any;
        data["requestTypeId"] = this.requestTypeId;
        data["hasCar"] = this.hasCar;
        if (Array.isArray(this.drivingLicenseTypeIds)) {
            data["drivingLicenseTypeIds"] = [];
            for (let item of this.drivingLicenseTypeIds)
                data["drivingLicenseTypeIds"].push(item);
        }
        data["obligationLaw381"] = this.obligationLaw381;
        data["obligationLaw68"] = this.obligationLaw68;
        data["noisyEnvironment"] = this.noisyEnvironment;
        data["dustyEnvironment"] = this.dustyEnvironment;
        data["loadHandling"] = this.loadHandling;
        data["workModeId"] = this.workModeId;
        data["description"] = this.description;
        data["note"] = this.note;
        if (Array.isArray(this.orderCodeIds)) {
            data["orderCodeIds"] = [];
            for (let item of this.orderCodeIds)
                data["orderCodeIds"].push(item);
        }
        data["isPrivate"] = this.isPrivate;
        return data;
    }

    clone(): UpdateSelectionDto {
        const json = this.toJSON();
        let result = new UpdateSelectionDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateSelectionDto {
    id: number;
    title: string | undefined;
    partnerId: number | undefined;
    operativeUnitId: number | undefined;
    contractProposalId: number | undefined;
    educationalDegreeLevelId: number;
    educationalDegreeId: number | undefined;
    otherEducationalDegreeLevel: string | undefined;
    businessSectorId: number | undefined;
    jobId: number | undefined;
    placeOfWork: string | undefined;
    insertionDate: moment.Moment | undefined;
    experyDate: moment.Moment | undefined;
    requestTypeId: number | undefined;
    hasCar: boolean | undefined;
    drivingLicenseTypeIds: number[] | undefined;
    obligationLaw381: boolean | undefined;
    obligationLaw68: boolean | undefined;
    noisyEnvironment: boolean | undefined;
    dustyEnvironment: boolean | undefined;
    loadHandling: boolean | undefined;
    workModeId: number | undefined;
    description: string | undefined;
    note: string | undefined;
    orderCodeIds: number[] | undefined;
    isPrivate: boolean | undefined;
}

export class UpdateSelectionJobSearchDto implements IUpdateSelectionJobSearchDto {
    id!: number;
    jobExperiences!: CreateJobExperienceDto[] | undefined;
    contractTypeIds!: number[] | undefined;
    hourEffortId!: number | undefined;
    traineeshipAvailability!: boolean;
    shiftWorkAvailability!: boolean;
    businessTripAvailability!: boolean;
    timeAvailability!: CreateTimeAvailabilityDto;
    daysAvailabilityId!: number | undefined;

    constructor(data?: IUpdateSelectionJobSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["jobExperiences"])) {
                this.jobExperiences = [] as any;
                for (let item of _data["jobExperiences"])
                    this.jobExperiences!.push(CreateJobExperienceDto.fromJS(item));
            }
            if (Array.isArray(_data["contractTypeIds"])) {
                this.contractTypeIds = [] as any;
                for (let item of _data["contractTypeIds"])
                    this.contractTypeIds!.push(item);
            }
            this.hourEffortId = _data["hourEffortId"];
            this.traineeshipAvailability = _data["traineeshipAvailability"];
            this.shiftWorkAvailability = _data["shiftWorkAvailability"];
            this.businessTripAvailability = _data["businessTripAvailability"];
            this.timeAvailability = _data["timeAvailability"] ? CreateTimeAvailabilityDto.fromJS(_data["timeAvailability"]) : undefined as any;
            this.daysAvailabilityId = _data["daysAvailabilityId"];
        }
    }

    static fromJS(data: any): UpdateSelectionJobSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSelectionJobSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.jobExperiences)) {
            data["jobExperiences"] = [];
            for (let item of this.jobExperiences)
                data["jobExperiences"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.contractTypeIds)) {
            data["contractTypeIds"] = [];
            for (let item of this.contractTypeIds)
                data["contractTypeIds"].push(item);
        }
        data["hourEffortId"] = this.hourEffortId;
        data["traineeshipAvailability"] = this.traineeshipAvailability;
        data["shiftWorkAvailability"] = this.shiftWorkAvailability;
        data["businessTripAvailability"] = this.businessTripAvailability;
        data["timeAvailability"] = this.timeAvailability ? this.timeAvailability.toJSON() : undefined as any;
        data["daysAvailabilityId"] = this.daysAvailabilityId;
        return data;
    }

    clone(): UpdateSelectionJobSearchDto {
        const json = this.toJSON();
        let result = new UpdateSelectionJobSearchDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateSelectionJobSearchDto {
    id: number;
    jobExperiences: CreateJobExperienceDto[] | undefined;
    contractTypeIds: number[] | undefined;
    hourEffortId: number | undefined;
    traineeshipAvailability: boolean;
    shiftWorkAvailability: boolean;
    businessTripAvailability: boolean;
    timeAvailability: CreateTimeAvailabilityDto;
    daysAvailabilityId: number | undefined;
}

export class UpdateSelectionLanguageDto implements IUpdateSelectionLanguageDto {
    id!: number;
    languageId!: number | undefined;
    spokenLevelId!: number | undefined;
    writtenLevelId!: number | undefined;
    listeningLevelId!: number | undefined;
    readingLevelId!: number | undefined;
    certificateId!: number | undefined;
    attested!: boolean;
    notes!: string | undefined;

    constructor(data?: IUpdateSelectionLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.languageId = _data["languageId"];
            this.spokenLevelId = _data["spokenLevelId"];
            this.writtenLevelId = _data["writtenLevelId"];
            this.listeningLevelId = _data["listeningLevelId"];
            this.readingLevelId = _data["readingLevelId"];
            this.certificateId = _data["certificateId"];
            this.attested = _data["attested"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateSelectionLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSelectionLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["languageId"] = this.languageId;
        data["spokenLevelId"] = this.spokenLevelId;
        data["writtenLevelId"] = this.writtenLevelId;
        data["listeningLevelId"] = this.listeningLevelId;
        data["readingLevelId"] = this.readingLevelId;
        data["certificateId"] = this.certificateId;
        data["attested"] = this.attested;
        data["notes"] = this.notes;
        return data;
    }

    clone(): UpdateSelectionLanguageDto {
        const json = this.toJSON();
        let result = new UpdateSelectionLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateSelectionLanguageDto {
    id: number;
    languageId: number | undefined;
    spokenLevelId: number | undefined;
    writtenLevelId: number | undefined;
    listeningLevelId: number | undefined;
    readingLevelId: number | undefined;
    certificateId: number | undefined;
    attested: boolean;
    notes: string | undefined;
}

export class UpdateSelectionQualificationDto implements IUpdateSelectionQualificationDto {
    id!: number;
    qualificationTypeId!: number | undefined;
    inProgress!: boolean;
    graduationDate!: moment.Moment | undefined;
    notes!: string | undefined;

    constructor(data?: IUpdateSelectionQualificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.qualificationTypeId = _data["qualificationTypeId"];
            this.inProgress = _data["inProgress"];
            this.graduationDate = _data["graduationDate"] ? moment(_data["graduationDate"].toString()) : undefined as any;
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateSelectionQualificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSelectionQualificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["qualificationTypeId"] = this.qualificationTypeId;
        data["inProgress"] = this.inProgress;
        data["graduationDate"] = this.graduationDate ? this.graduationDate.format('YYYY-MM-DD') : undefined as any;
        data["notes"] = this.notes;
        return data;
    }

    clone(): UpdateSelectionQualificationDto {
        const json = this.toJSON();
        let result = new UpdateSelectionQualificationDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateSelectionQualificationDto {
    id: number;
    qualificationTypeId: number | undefined;
    inProgress: boolean;
    graduationDate: moment.Moment | undefined;
    notes: string | undefined;
}

export class UpdateUserCertificationDto implements IUpdateUserCertificationDto {
    id!: number;
    title!: string;
    date!: moment.Moment | undefined;
    issuedBy!: string | undefined;
    description!: string | undefined;

    constructor(data?: IUpdateUserCertificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.issuedBy = _data["issuedBy"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UpdateUserCertificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserCertificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["date"] = this.date ? this.date.format('YYYY-MM-DD') : undefined as any;
        data["issuedBy"] = this.issuedBy;
        data["description"] = this.description;
        return data;
    }

    clone(): UpdateUserCertificationDto {
        const json = this.toJSON();
        let result = new UpdateUserCertificationDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserCertificationDto {
    id: number;
    title: string;
    date: moment.Moment | undefined;
    issuedBy: string | undefined;
    description: string | undefined;
}

export class UpdateUserComputerSkillDto implements IUpdateUserComputerSkillDto {
    id!: number;
    computerSkillId!: number | undefined;
    notes!: string | undefined;

    constructor(data?: IUpdateUserComputerSkillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.computerSkillId = _data["computerSkillId"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateUserComputerSkillDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserComputerSkillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["computerSkillId"] = this.computerSkillId;
        data["notes"] = this.notes;
        return data;
    }

    clone(): UpdateUserComputerSkillDto {
        const json = this.toJSON();
        let result = new UpdateUserComputerSkillDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserComputerSkillDto {
    id: number;
    computerSkillId: number | undefined;
    notes: string | undefined;
}

export class UpdateUserDisabilityDto implements IUpdateUserDisabilityDto {
    id!: number;
    protectedCategory!: boolean;
    placementRegistration!: boolean | undefined;
    isArt1!: boolean | undefined;
    isArt18!: boolean | undefined;
    art1DisabilityPercentage!: number | undefined;
    disabilityTypeId!: number | undefined;
    art18TypeId!: number | undefined;
    certifiedInstitution!: string | undefined;
    law381Disadvantage!: boolean | undefined;
    notes!: string | undefined;

    constructor(data?: IUpdateUserDisabilityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.protectedCategory = _data["protectedCategory"];
            this.placementRegistration = _data["placementRegistration"];
            this.isArt1 = _data["isArt1"];
            this.isArt18 = _data["isArt18"];
            this.art1DisabilityPercentage = _data["art1DisabilityPercentage"];
            this.disabilityTypeId = _data["disabilityTypeId"];
            this.art18TypeId = _data["art18TypeId"];
            this.certifiedInstitution = _data["certifiedInstitution"];
            this.law381Disadvantage = _data["law381Disadvantage"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateUserDisabilityDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserDisabilityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["protectedCategory"] = this.protectedCategory;
        data["placementRegistration"] = this.placementRegistration;
        data["isArt1"] = this.isArt1;
        data["isArt18"] = this.isArt18;
        data["art1DisabilityPercentage"] = this.art1DisabilityPercentage;
        data["disabilityTypeId"] = this.disabilityTypeId;
        data["art18TypeId"] = this.art18TypeId;
        data["certifiedInstitution"] = this.certifiedInstitution;
        data["law381Disadvantage"] = this.law381Disadvantage;
        data["notes"] = this.notes;
        return data;
    }

    clone(): UpdateUserDisabilityDto {
        const json = this.toJSON();
        let result = new UpdateUserDisabilityDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserDisabilityDto {
    id: number;
    protectedCategory: boolean;
    placementRegistration: boolean | undefined;
    isArt1: boolean | undefined;
    isArt18: boolean | undefined;
    art1DisabilityPercentage: number | undefined;
    disabilityTypeId: number | undefined;
    art18TypeId: number | undefined;
    certifiedInstitution: string | undefined;
    law381Disadvantage: boolean | undefined;
    notes: string | undefined;
}

export class UpdateUserDto implements IUpdateUserDto {
    id!: number;
    name!: string;
    surname!: string;
    emailAddress!: string;
    fiscalCode!: string | undefined;
    phoneNumber!: string | undefined;
    isActive!: boolean;
    roleNames!: string[];
    operativeUnitIds!: number[] | undefined;
    birthDate!: moment.Moment | undefined;
    birthPlace!: string | undefined;
    genderId!: number | undefined;
    address!: CreateAddressDto;
    nationalityId!: number | undefined;
    businessName!: string | undefined;
    registeredOffice!: CreateAddressDto;
    vatNumber!: string | undefined;
    pec!: string | undefined;
    conventions!: UpdateConventionDto[] | undefined;
    companyOrderCodeIds!: number[] | undefined;
    employeesId!: number | undefined;
    salesId!: number | undefined;
    activityDescription!: string | undefined;
    telematicIdentificationCode!: string | undefined;
    salesLastYearId!: number | undefined;
    businessSector!: number | undefined;
    partnerTypeId!: number | undefined;
    operativeOffices!: CreateAddressDto[] | undefined;
    legalObbligation68!: boolean | undefined;
    theseObbligation!: string | undefined;
    discoveriesNumber!: string | undefined;
    notes!: CreateNotesDto[] | undefined;
    atecoCodeIds!: number[] | undefined;
    laborConsultantId!: number | undefined;

    constructor(data?: IUpdateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.roleNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.fiscalCode = _data["fiscalCode"];
            this.phoneNumber = _data["phoneNumber"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames!.push(item);
            }
            if (Array.isArray(_data["operativeUnitIds"])) {
                this.operativeUnitIds = [] as any;
                for (let item of _data["operativeUnitIds"])
                    this.operativeUnitIds!.push(item);
            }
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : undefined as any;
            this.birthPlace = _data["birthPlace"];
            this.genderId = _data["genderId"];
            this.address = _data["address"] ? CreateAddressDto.fromJS(_data["address"]) : undefined as any;
            this.nationalityId = _data["nationalityId"];
            this.businessName = _data["businessName"];
            this.registeredOffice = _data["registeredOffice"] ? CreateAddressDto.fromJS(_data["registeredOffice"]) : undefined as any;
            this.vatNumber = _data["vatNumber"];
            this.pec = _data["pec"];
            if (Array.isArray(_data["conventions"])) {
                this.conventions = [] as any;
                for (let item of _data["conventions"])
                    this.conventions!.push(UpdateConventionDto.fromJS(item));
            }
            if (Array.isArray(_data["companyOrderCodeIds"])) {
                this.companyOrderCodeIds = [] as any;
                for (let item of _data["companyOrderCodeIds"])
                    this.companyOrderCodeIds!.push(item);
            }
            this.employeesId = _data["employeesId"];
            this.salesId = _data["salesId"];
            this.activityDescription = _data["activityDescription"];
            this.telematicIdentificationCode = _data["telematicIdentificationCode"];
            this.salesLastYearId = _data["salesLastYearId"];
            this.businessSector = _data["businessSector"];
            this.partnerTypeId = _data["partnerTypeId"];
            if (Array.isArray(_data["operativeOffices"])) {
                this.operativeOffices = [] as any;
                for (let item of _data["operativeOffices"])
                    this.operativeOffices!.push(CreateAddressDto.fromJS(item));
            }
            this.legalObbligation68 = _data["legalObbligation68"];
            this.theseObbligation = _data["theseObbligation"];
            this.discoveriesNumber = _data["discoveriesNumber"];
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(CreateNotesDto.fromJS(item));
            }
            if (Array.isArray(_data["atecoCodeIds"])) {
                this.atecoCodeIds = [] as any;
                for (let item of _data["atecoCodeIds"])
                    this.atecoCodeIds!.push(item);
            }
            this.laborConsultantId = _data["laborConsultantId"];
        }
    }

    static fromJS(data: any): UpdateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["fiscalCode"] = this.fiscalCode;
        data["phoneNumber"] = this.phoneNumber;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        if (Array.isArray(this.operativeUnitIds)) {
            data["operativeUnitIds"] = [];
            for (let item of this.operativeUnitIds)
                data["operativeUnitIds"].push(item);
        }
        data["birthDate"] = this.birthDate ? this.birthDate.format('YYYY-MM-DD') : undefined as any;
        data["birthPlace"] = this.birthPlace;
        data["genderId"] = this.genderId;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["nationalityId"] = this.nationalityId;
        data["businessName"] = this.businessName;
        data["registeredOffice"] = this.registeredOffice ? this.registeredOffice.toJSON() : undefined as any;
        data["vatNumber"] = this.vatNumber;
        data["pec"] = this.pec;
        if (Array.isArray(this.conventions)) {
            data["conventions"] = [];
            for (let item of this.conventions)
                data["conventions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.companyOrderCodeIds)) {
            data["companyOrderCodeIds"] = [];
            for (let item of this.companyOrderCodeIds)
                data["companyOrderCodeIds"].push(item);
        }
        data["employeesId"] = this.employeesId;
        data["salesId"] = this.salesId;
        data["activityDescription"] = this.activityDescription;
        data["telematicIdentificationCode"] = this.telematicIdentificationCode;
        data["salesLastYearId"] = this.salesLastYearId;
        data["businessSector"] = this.businessSector;
        data["partnerTypeId"] = this.partnerTypeId;
        if (Array.isArray(this.operativeOffices)) {
            data["operativeOffices"] = [];
            for (let item of this.operativeOffices)
                data["operativeOffices"].push(item ? item.toJSON() : undefined as any);
        }
        data["legalObbligation68"] = this.legalObbligation68;
        data["theseObbligation"] = this.theseObbligation;
        data["discoveriesNumber"] = this.discoveriesNumber;
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.atecoCodeIds)) {
            data["atecoCodeIds"] = [];
            for (let item of this.atecoCodeIds)
                data["atecoCodeIds"].push(item);
        }
        data["laborConsultantId"] = this.laborConsultantId;
        return data;
    }

    clone(): UpdateUserDto {
        const json = this.toJSON();
        let result = new UpdateUserDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserDto {
    id: number;
    name: string;
    surname: string;
    emailAddress: string;
    fiscalCode: string | undefined;
    phoneNumber: string | undefined;
    isActive: boolean;
    roleNames: string[];
    operativeUnitIds: number[] | undefined;
    birthDate: moment.Moment | undefined;
    birthPlace: string | undefined;
    genderId: number | undefined;
    address: CreateAddressDto;
    nationalityId: number | undefined;
    businessName: string | undefined;
    registeredOffice: CreateAddressDto;
    vatNumber: string | undefined;
    pec: string | undefined;
    conventions: UpdateConventionDto[] | undefined;
    companyOrderCodeIds: number[] | undefined;
    employeesId: number | undefined;
    salesId: number | undefined;
    activityDescription: string | undefined;
    telematicIdentificationCode: string | undefined;
    salesLastYearId: number | undefined;
    businessSector: number | undefined;
    partnerTypeId: number | undefined;
    operativeOffices: CreateAddressDto[] | undefined;
    legalObbligation68: boolean | undefined;
    theseObbligation: string | undefined;
    discoveriesNumber: string | undefined;
    notes: CreateNotesDto[] | undefined;
    atecoCodeIds: number[] | undefined;
    laborConsultantId: number | undefined;
}

export class UpdateUserEducationDto implements IUpdateUserEducationDto {
    id!: number;
    educationalDegreeLevelId!: number | undefined;
    educationalDegreeId!: number | undefined;
    titleRecognitionId!: number | undefined;
    nationId!: number | undefined;
    institute!: string | undefined;
    graduationDate!: moment.Moment;
    other!: string | undefined;

    constructor(data?: IUpdateUserEducationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.educationalDegreeLevelId = _data["educationalDegreeLevelId"];
            this.educationalDegreeId = _data["educationalDegreeId"];
            this.titleRecognitionId = _data["titleRecognitionId"];
            this.nationId = _data["nationId"];
            this.institute = _data["institute"];
            this.graduationDate = _data["graduationDate"] ? moment(_data["graduationDate"].toString()) : undefined as any;
            this.other = _data["other"];
        }
    }

    static fromJS(data: any): UpdateUserEducationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserEducationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["educationalDegreeLevelId"] = this.educationalDegreeLevelId;
        data["educationalDegreeId"] = this.educationalDegreeId;
        data["titleRecognitionId"] = this.titleRecognitionId;
        data["nationId"] = this.nationId;
        data["institute"] = this.institute;
        data["graduationDate"] = this.graduationDate ? this.graduationDate.format('YYYY-MM-DD') : undefined as any;
        data["other"] = this.other;
        return data;
    }

    clone(): UpdateUserEducationDto {
        const json = this.toJSON();
        let result = new UpdateUserEducationDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserEducationDto {
    id: number;
    educationalDegreeLevelId: number | undefined;
    educationalDegreeId: number | undefined;
    titleRecognitionId: number | undefined;
    nationId: number | undefined;
    institute: string | undefined;
    graduationDate: moment.Moment;
    other: string | undefined;
}

export class UpdateUserJobDto implements IUpdateUserJobDto {
    id!: number;
    jobId!: number | undefined;
    contractTypeId!: number | undefined;
    startDate!: moment.Moment;
    endDate!: moment.Moment | undefined;
    inProgress!: boolean;
    employer!: string | undefined;

    constructor(data?: IUpdateUserJobDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.jobId = _data["jobId"];
            this.contractTypeId = _data["contractTypeId"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : undefined as any;
            this.inProgress = _data["inProgress"];
            this.employer = _data["employer"];
        }
    }

    static fromJS(data: any): UpdateUserJobDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserJobDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["jobId"] = this.jobId;
        data["contractTypeId"] = this.contractTypeId;
        data["startDate"] = this.startDate ? this.startDate.format('YYYY-MM-DD') : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.format('YYYY-MM-DD') : undefined as any;
        data["inProgress"] = this.inProgress;
        data["employer"] = this.employer;
        return data;
    }

    clone(): UpdateUserJobDto {
        const json = this.toJSON();
        let result = new UpdateUserJobDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserJobDto {
    id: number;
    jobId: number | undefined;
    contractTypeId: number | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment | undefined;
    inProgress: boolean;
    employer: string | undefined;
}

export class UpdateUserLanguageDto implements IUpdateUserLanguageDto {
    id!: number;
    languageId!: number | undefined;
    spokenLevelId!: number | undefined;
    writtenLevelId!: number | undefined;
    listeningLevelId!: number | undefined;
    readingLevelId!: number | undefined;
    certificateId!: number | undefined;
    attested!: boolean;
    notes!: string | undefined;

    constructor(data?: IUpdateUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.languageId = _data["languageId"];
            this.spokenLevelId = _data["spokenLevelId"];
            this.writtenLevelId = _data["writtenLevelId"];
            this.listeningLevelId = _data["listeningLevelId"];
            this.readingLevelId = _data["readingLevelId"];
            this.certificateId = _data["certificateId"];
            this.attested = _data["attested"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["languageId"] = this.languageId;
        data["spokenLevelId"] = this.spokenLevelId;
        data["writtenLevelId"] = this.writtenLevelId;
        data["listeningLevelId"] = this.listeningLevelId;
        data["readingLevelId"] = this.readingLevelId;
        data["certificateId"] = this.certificateId;
        data["attested"] = this.attested;
        data["notes"] = this.notes;
        return data;
    }

    clone(): UpdateUserLanguageDto {
        const json = this.toJSON();
        let result = new UpdateUserLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserLanguageDto {
    id: number;
    languageId: number | undefined;
    spokenLevelId: number | undefined;
    writtenLevelId: number | undefined;
    listeningLevelId: number | undefined;
    readingLevelId: number | undefined;
    certificateId: number | undefined;
    attested: boolean;
    notes: string | undefined;
}

export class UpdateUserNoteDto implements IUpdateUserNoteDto {
    id!: number;
    note!: string | undefined;
    date!: moment.Moment;

    constructor(data?: IUpdateUserNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.note = _data["note"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateUserNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["note"] = this.note;
        data["date"] = this.date ? this.date.format('YYYY-MM-DD') : undefined as any;
        return data;
    }

    clone(): UpdateUserNoteDto {
        const json = this.toJSON();
        let result = new UpdateUserNoteDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserNoteDto {
    id: number;
    note: string | undefined;
    date: moment.Moment;
}

export class UpdateUserQualificationDto implements IUpdateUserQualificationDto {
    id!: number;
    qualificationTypeId!: number | undefined;
    inProgress!: boolean;
    graduationDate!: moment.Moment | undefined;
    notes!: string | undefined;

    constructor(data?: IUpdateUserQualificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.qualificationTypeId = _data["qualificationTypeId"];
            this.inProgress = _data["inProgress"];
            this.graduationDate = _data["graduationDate"] ? moment(_data["graduationDate"].toString()) : undefined as any;
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateUserQualificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserQualificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["qualificationTypeId"] = this.qualificationTypeId;
        data["inProgress"] = this.inProgress;
        data["graduationDate"] = this.graduationDate ? this.graduationDate.format('YYYY-MM-DD') : undefined as any;
        data["notes"] = this.notes;
        return data;
    }

    clone(): UpdateUserQualificationDto {
        const json = this.toJSON();
        let result = new UpdateUserQualificationDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserQualificationDto {
    id: number;
    qualificationTypeId: number | undefined;
    inProgress: boolean;
    graduationDate: moment.Moment | undefined;
    notes: string | undefined;
}

export class UpdateUserSafetyTrainingDto implements IUpdateUserSafetyTrainingDto {
    id!: number;
    safetyTrainingTypeId!: number | undefined;
    date!: moment.Moment;

    constructor(data?: IUpdateUserSafetyTrainingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.safetyTrainingTypeId = _data["safetyTrainingTypeId"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateUserSafetyTrainingDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserSafetyTrainingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["safetyTrainingTypeId"] = this.safetyTrainingTypeId;
        data["date"] = this.date ? this.date.format('YYYY-MM-DD') : undefined as any;
        return data;
    }

    clone(): UpdateUserSafetyTrainingDto {
        const json = this.toJSON();
        let result = new UpdateUserSafetyTrainingDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserSafetyTrainingDto {
    id: number;
    safetyTrainingTypeId: number | undefined;
    date: moment.Moment;
}

export class UpdateUserSurveyDto implements IUpdateUserSurveyDto {
    id!: number;
    cvWritingSupportServices!: number;
    jobInterviewPreparation!: number;
    careerEducationGuidanceCounseling!: number;
    workshopsActiveJobSearching!: number;
    trainingCourses!: number;
    informationMeetingsOnTheJobMarket!: number;

    constructor(data?: IUpdateUserSurveyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cvWritingSupportServices = _data["cvWritingSupportServices"];
            this.jobInterviewPreparation = _data["jobInterviewPreparation"];
            this.careerEducationGuidanceCounseling = _data["careerEducationGuidanceCounseling"];
            this.workshopsActiveJobSearching = _data["workshopsActiveJobSearching"];
            this.trainingCourses = _data["trainingCourses"];
            this.informationMeetingsOnTheJobMarket = _data["informationMeetingsOnTheJobMarket"];
        }
    }

    static fromJS(data: any): UpdateUserSurveyDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserSurveyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cvWritingSupportServices"] = this.cvWritingSupportServices;
        data["jobInterviewPreparation"] = this.jobInterviewPreparation;
        data["careerEducationGuidanceCounseling"] = this.careerEducationGuidanceCounseling;
        data["workshopsActiveJobSearching"] = this.workshopsActiveJobSearching;
        data["trainingCourses"] = this.trainingCourses;
        data["informationMeetingsOnTheJobMarket"] = this.informationMeetingsOnTheJobMarket;
        return data;
    }

    clone(): UpdateUserSurveyDto {
        const json = this.toJSON();
        let result = new UpdateUserSurveyDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserSurveyDto {
    id: number;
    cvWritingSupportServices: number;
    jobInterviewPreparation: number;
    careerEducationGuidanceCounseling: number;
    workshopsActiveJobSearching: number;
    trainingCourses: number;
    informationMeetingsOnTheJobMarket: number;
}

export class UpdateUserTrainingCourseDto implements IUpdateUserTrainingCourseDto {
    id!: number;
    title!: string | undefined;
    institute!: string | undefined;
    achievementYear!: moment.Moment | undefined;
    courseHours!: number | undefined;
    certificateId!: number | undefined;
    attested!: boolean;

    constructor(data?: IUpdateUserTrainingCourseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.institute = _data["institute"];
            this.achievementYear = _data["achievementYear"] ? moment(_data["achievementYear"].toString()) : undefined as any;
            this.courseHours = _data["courseHours"];
            this.certificateId = _data["certificateId"];
            this.attested = _data["attested"];
        }
    }

    static fromJS(data: any): UpdateUserTrainingCourseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserTrainingCourseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["institute"] = this.institute;
        data["achievementYear"] = this.achievementYear ? this.achievementYear.format('YYYY-MM-DD') : undefined as any;
        data["courseHours"] = this.courseHours;
        data["certificateId"] = this.certificateId;
        data["attested"] = this.attested;
        return data;
    }

    clone(): UpdateUserTrainingCourseDto {
        const json = this.toJSON();
        let result = new UpdateUserTrainingCourseDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserTrainingCourseDto {
    id: number;
    title: string | undefined;
    institute: string | undefined;
    achievementYear: moment.Moment | undefined;
    courseHours: number | undefined;
    certificateId: number | undefined;
    attested: boolean;
}

export class UpdateUserTrainingCourseInterestDto implements IUpdateUserTrainingCourseInterestDto {
    id!: number;
    businessSectorId!: number | undefined;
    areaOfInterest!: string | undefined;
    operativeUnitIds!: number[] | undefined;
    fruitionTypeId!: number | undefined;
    isInterestedInSelfFinancedCourse!: boolean;

    constructor(data?: IUpdateUserTrainingCourseInterestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.businessSectorId = _data["businessSectorId"];
            this.areaOfInterest = _data["areaOfInterest"];
            if (Array.isArray(_data["operativeUnitIds"])) {
                this.operativeUnitIds = [] as any;
                for (let item of _data["operativeUnitIds"])
                    this.operativeUnitIds!.push(item);
            }
            this.fruitionTypeId = _data["fruitionTypeId"];
            this.isInterestedInSelfFinancedCourse = _data["isInterestedInSelfFinancedCourse"];
        }
    }

    static fromJS(data: any): UpdateUserTrainingCourseInterestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserTrainingCourseInterestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["businessSectorId"] = this.businessSectorId;
        data["areaOfInterest"] = this.areaOfInterest;
        if (Array.isArray(this.operativeUnitIds)) {
            data["operativeUnitIds"] = [];
            for (let item of this.operativeUnitIds)
                data["operativeUnitIds"].push(item);
        }
        data["fruitionTypeId"] = this.fruitionTypeId;
        data["isInterestedInSelfFinancedCourse"] = this.isInterestedInSelfFinancedCourse;
        return data;
    }

    clone(): UpdateUserTrainingCourseInterestDto {
        const json = this.toJSON();
        let result = new UpdateUserTrainingCourseInterestDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserTrainingCourseInterestDto {
    id: number;
    businessSectorId: number | undefined;
    areaOfInterest: string | undefined;
    operativeUnitIds: number[] | undefined;
    fruitionTypeId: number | undefined;
    isInterestedInSelfFinancedCourse: boolean;
}

export class UpdateUserTrainingCourseInterestOperativeUnitDto implements IUpdateUserTrainingCourseInterestOperativeUnitDto {
    id!: number;
    userTrainingCourseInterestId!: number | undefined;
    operativeUnitId!: number;

    constructor(data?: IUpdateUserTrainingCourseInterestOperativeUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userTrainingCourseInterestId = _data["userTrainingCourseInterestId"];
            this.operativeUnitId = _data["operativeUnitId"];
        }
    }

    static fromJS(data: any): UpdateUserTrainingCourseInterestOperativeUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserTrainingCourseInterestOperativeUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userTrainingCourseInterestId"] = this.userTrainingCourseInterestId;
        data["operativeUnitId"] = this.operativeUnitId;
        return data;
    }

    clone(): UpdateUserTrainingCourseInterestOperativeUnitDto {
        const json = this.toJSON();
        let result = new UpdateUserTrainingCourseInterestOperativeUnitDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserTrainingCourseInterestOperativeUnitDto {
    id: number;
    userTrainingCourseInterestId: number | undefined;
    operativeUnitId: number;
}

export class UpdateUserTransversalSkillDto implements IUpdateUserTransversalSkillDto {
    id!: number;
    description!: string | undefined;
    levelId!: number | undefined;

    constructor(data?: IUpdateUserTransversalSkillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.levelId = _data["levelId"];
        }
    }

    static fromJS(data: any): UpdateUserTransversalSkillDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserTransversalSkillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["levelId"] = this.levelId;
        return data;
    }

    clone(): UpdateUserTransversalSkillDto {
        const json = this.toJSON();
        let result = new UpdateUserTransversalSkillDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserTransversalSkillDto {
    id: number;
    description: string | undefined;
    levelId: number | undefined;
}

export class UserCertificationDto implements IUserCertificationDto {
    id!: number;
    title!: string | undefined;
    date!: moment.Moment | undefined;
    issuedBy!: string | undefined;
    description!: string | undefined;

    constructor(data?: IUserCertificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.issuedBy = _data["issuedBy"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UserCertificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserCertificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["date"] = this.date ? this.date.format('YYYY-MM-DD') : undefined as any;
        data["issuedBy"] = this.issuedBy;
        data["description"] = this.description;
        return data;
    }

    clone(): UserCertificationDto {
        const json = this.toJSON();
        let result = new UserCertificationDto();
        result.init(json);
        return result;
    }
}

export interface IUserCertificationDto {
    id: number;
    title: string | undefined;
    date: moment.Moment | undefined;
    issuedBy: string | undefined;
    description: string | undefined;
}

export class UserCertificationDtoPagedResultDto implements IUserCertificationDtoPagedResultDto {
    items!: UserCertificationDto[] | undefined;
    totalCount!: number;

    constructor(data?: IUserCertificationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserCertificationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserCertificationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserCertificationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserCertificationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserCertificationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserCertificationDtoPagedResultDto {
    items: UserCertificationDto[] | undefined;
    totalCount: number;
}

export class UserComputerSkillDto implements IUserComputerSkillDto {
    id!: number;
    user!: UserDto;
    computerSkill!: DictionaryDto;
    notes!: string | undefined;

    constructor(data?: IUserComputerSkillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : undefined as any;
            this.computerSkill = _data["computerSkill"] ? DictionaryDto.fromJS(_data["computerSkill"]) : undefined as any;
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UserComputerSkillDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserComputerSkillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["computerSkill"] = this.computerSkill ? this.computerSkill.toJSON() : undefined as any;
        data["notes"] = this.notes;
        return data;
    }

    clone(): UserComputerSkillDto {
        const json = this.toJSON();
        let result = new UserComputerSkillDto();
        result.init(json);
        return result;
    }
}

export interface IUserComputerSkillDto {
    id: number;
    user: UserDto;
    computerSkill: DictionaryDto;
    notes: string | undefined;
}

export class UserComputerSkillDtoPagedResultDto implements IUserComputerSkillDtoPagedResultDto {
    items!: UserComputerSkillDto[] | undefined;
    totalCount!: number;

    constructor(data?: IUserComputerSkillDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserComputerSkillDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserComputerSkillDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserComputerSkillDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserComputerSkillDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserComputerSkillDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserComputerSkillDtoPagedResultDto {
    items: UserComputerSkillDto[] | undefined;
    totalCount: number;
}

export class UserDisabilityDto implements IUserDisabilityDto {
    id!: number;
    protectedCategory!: boolean;
    placementRegistration!: boolean | undefined;
    user!: UserDto;
    isArt1!: boolean | undefined;
    isArt18!: boolean | undefined;
    art1DisabilityPercentage!: number;
    disabilityType!: DictionaryDto;
    art18Type!: DictionaryDto;
    certifiedInstitution!: string | undefined;
    law381Disadvantage!: boolean | undefined;
    notes!: string | undefined;

    constructor(data?: IUserDisabilityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.protectedCategory = _data["protectedCategory"];
            this.placementRegistration = _data["placementRegistration"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : undefined as any;
            this.isArt1 = _data["isArt1"];
            this.isArt18 = _data["isArt18"];
            this.art1DisabilityPercentage = _data["art1DisabilityPercentage"];
            this.disabilityType = _data["disabilityType"] ? DictionaryDto.fromJS(_data["disabilityType"]) : undefined as any;
            this.art18Type = _data["art18Type"] ? DictionaryDto.fromJS(_data["art18Type"]) : undefined as any;
            this.certifiedInstitution = _data["certifiedInstitution"];
            this.law381Disadvantage = _data["law381Disadvantage"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UserDisabilityDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDisabilityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["protectedCategory"] = this.protectedCategory;
        data["placementRegistration"] = this.placementRegistration;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["isArt1"] = this.isArt1;
        data["isArt18"] = this.isArt18;
        data["art1DisabilityPercentage"] = this.art1DisabilityPercentage;
        data["disabilityType"] = this.disabilityType ? this.disabilityType.toJSON() : undefined as any;
        data["art18Type"] = this.art18Type ? this.art18Type.toJSON() : undefined as any;
        data["certifiedInstitution"] = this.certifiedInstitution;
        data["law381Disadvantage"] = this.law381Disadvantage;
        data["notes"] = this.notes;
        return data;
    }

    clone(): UserDisabilityDto {
        const json = this.toJSON();
        let result = new UserDisabilityDto();
        result.init(json);
        return result;
    }
}

export interface IUserDisabilityDto {
    id: number;
    protectedCategory: boolean;
    placementRegistration: boolean | undefined;
    user: UserDto;
    isArt1: boolean | undefined;
    isArt18: boolean | undefined;
    art1DisabilityPercentage: number;
    disabilityType: DictionaryDto;
    art18Type: DictionaryDto;
    certifiedInstitution: string | undefined;
    law381Disadvantage: boolean | undefined;
    notes: string | undefined;
}

export class UserDisabilityDtoPagedResultDto implements IUserDisabilityDtoPagedResultDto {
    items!: UserDisabilityDto[] | undefined;
    totalCount!: number;

    constructor(data?: IUserDisabilityDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserDisabilityDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserDisabilityDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDisabilityDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserDisabilityDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserDisabilityDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserDisabilityDtoPagedResultDto {
    items: UserDisabilityDto[] | undefined;
    totalCount: number;
}

export class UserDto implements IUserDto {
    id!: number;
    name!: string | undefined;
    surname!: string | undefined;
    phoneNumber!: string | undefined;
    fiscalCode!: string | undefined;
    emailAddress!: string | undefined;
    roleNames!: string[] | undefined;
    roleDisplayNames!: string[] | undefined;
    isActive!: boolean;
    isDeleted!: boolean;
    lastLoginTime!: moment.Moment | undefined;
    isEmailConfirmed!: boolean;
    fullName!: string | undefined;
    accessFailedCount!: number;
    lockoutEndDateUtc!: moment.Moment | undefined;
    birthDate!: moment.Moment | undefined;
    birthPlace!: string | undefined;
    gender!: DictionaryDto;
    address!: AddressDto;
    businessName!: string | undefined;
    registeredOffice!: AddressDto;
    vatNumber!: string | undefined;
    pec!: string | undefined;
    employees!: DictionaryDto;
    sales!: DictionaryDto;
    salesLastYear!: DictionaryDto;
    businessSector!: DictionaryDto;
    partnerType!: DictionaryDto;
    operativeOfficesAddresses!: AddressDto[] | undefined;
    legalObbligation68!: boolean | undefined;
    theseObbligation!: string | undefined;
    discoveriesNumber!: string | undefined;
    activityDescription!: string | undefined;
    telematicIdentificationCode!: string | undefined;
    notes!: NoteDto[] | undefined;
    atecoCodes!: DictionaryDto[] | undefined;
    conventions!: ConventionDto[] | undefined;
    companyOrderCodes!: OrderCodeDto[] | undefined;
    laborConsultant!: LaborConsultantItemDto;
    nationality!: DictionaryDto;
    operativeUnits!: OperativeUnitDto[] | undefined;
    isAlreadySelected!: boolean;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.phoneNumber = _data["phoneNumber"];
            this.fiscalCode = _data["fiscalCode"];
            this.emailAddress = _data["emailAddress"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames!.push(item);
            }
            if (Array.isArray(_data["roleDisplayNames"])) {
                this.roleDisplayNames = [] as any;
                for (let item of _data["roleDisplayNames"])
                    this.roleDisplayNames!.push(item);
            }
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.lastLoginTime = _data["lastLoginTime"] ? moment(_data["lastLoginTime"].toString()) : undefined as any;
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            this.fullName = _data["fullName"];
            this.accessFailedCount = _data["accessFailedCount"];
            this.lockoutEndDateUtc = _data["lockoutEndDateUtc"] ? moment(_data["lockoutEndDateUtc"].toString()) : undefined as any;
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : undefined as any;
            this.birthPlace = _data["birthPlace"];
            this.gender = _data["gender"] ? DictionaryDto.fromJS(_data["gender"]) : undefined as any;
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : undefined as any;
            this.businessName = _data["businessName"];
            this.registeredOffice = _data["registeredOffice"] ? AddressDto.fromJS(_data["registeredOffice"]) : undefined as any;
            this.vatNumber = _data["vatNumber"];
            this.pec = _data["pec"];
            this.employees = _data["employees"] ? DictionaryDto.fromJS(_data["employees"]) : undefined as any;
            this.sales = _data["sales"] ? DictionaryDto.fromJS(_data["sales"]) : undefined as any;
            this.salesLastYear = _data["salesLastYear"] ? DictionaryDto.fromJS(_data["salesLastYear"]) : undefined as any;
            this.businessSector = _data["businessSector"] ? DictionaryDto.fromJS(_data["businessSector"]) : undefined as any;
            this.partnerType = _data["partnerType"] ? DictionaryDto.fromJS(_data["partnerType"]) : undefined as any;
            if (Array.isArray(_data["operativeOfficesAddresses"])) {
                this.operativeOfficesAddresses = [] as any;
                for (let item of _data["operativeOfficesAddresses"])
                    this.operativeOfficesAddresses!.push(AddressDto.fromJS(item));
            }
            this.legalObbligation68 = _data["legalObbligation68"];
            this.theseObbligation = _data["theseObbligation"];
            this.discoveriesNumber = _data["discoveriesNumber"];
            this.activityDescription = _data["activityDescription"];
            this.telematicIdentificationCode = _data["telematicIdentificationCode"];
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(NoteDto.fromJS(item));
            }
            if (Array.isArray(_data["atecoCodes"])) {
                this.atecoCodes = [] as any;
                for (let item of _data["atecoCodes"])
                    this.atecoCodes!.push(DictionaryDto.fromJS(item));
            }
            if (Array.isArray(_data["conventions"])) {
                this.conventions = [] as any;
                for (let item of _data["conventions"])
                    this.conventions!.push(ConventionDto.fromJS(item));
            }
            if (Array.isArray(_data["companyOrderCodes"])) {
                this.companyOrderCodes = [] as any;
                for (let item of _data["companyOrderCodes"])
                    this.companyOrderCodes!.push(OrderCodeDto.fromJS(item));
            }
            this.laborConsultant = _data["laborConsultant"] ? LaborConsultantItemDto.fromJS(_data["laborConsultant"]) : undefined as any;
            this.nationality = _data["nationality"] ? DictionaryDto.fromJS(_data["nationality"]) : undefined as any;
            if (Array.isArray(_data["operativeUnits"])) {
                this.operativeUnits = [] as any;
                for (let item of _data["operativeUnits"])
                    this.operativeUnits!.push(OperativeUnitDto.fromJS(item));
            }
            this.isAlreadySelected = _data["isAlreadySelected"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["phoneNumber"] = this.phoneNumber;
        data["fiscalCode"] = this.fiscalCode;
        data["emailAddress"] = this.emailAddress;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        if (Array.isArray(this.roleDisplayNames)) {
            data["roleDisplayNames"] = [];
            for (let item of this.roleDisplayNames)
                data["roleDisplayNames"].push(item);
        }
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : undefined as any;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["fullName"] = this.fullName;
        data["accessFailedCount"] = this.accessFailedCount;
        data["lockoutEndDateUtc"] = this.lockoutEndDateUtc ? this.lockoutEndDateUtc.toISOString() : undefined as any;
        data["birthDate"] = this.birthDate ? this.birthDate.format('YYYY-MM-DD') : undefined as any;
        data["birthPlace"] = this.birthPlace;
        data["gender"] = this.gender ? this.gender.toJSON() : undefined as any;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["businessName"] = this.businessName;
        data["registeredOffice"] = this.registeredOffice ? this.registeredOffice.toJSON() : undefined as any;
        data["vatNumber"] = this.vatNumber;
        data["pec"] = this.pec;
        data["employees"] = this.employees ? this.employees.toJSON() : undefined as any;
        data["sales"] = this.sales ? this.sales.toJSON() : undefined as any;
        data["salesLastYear"] = this.salesLastYear ? this.salesLastYear.toJSON() : undefined as any;
        data["businessSector"] = this.businessSector ? this.businessSector.toJSON() : undefined as any;
        data["partnerType"] = this.partnerType ? this.partnerType.toJSON() : undefined as any;
        if (Array.isArray(this.operativeOfficesAddresses)) {
            data["operativeOfficesAddresses"] = [];
            for (let item of this.operativeOfficesAddresses)
                data["operativeOfficesAddresses"].push(item ? item.toJSON() : undefined as any);
        }
        data["legalObbligation68"] = this.legalObbligation68;
        data["theseObbligation"] = this.theseObbligation;
        data["discoveriesNumber"] = this.discoveriesNumber;
        data["activityDescription"] = this.activityDescription;
        data["telematicIdentificationCode"] = this.telematicIdentificationCode;
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.atecoCodes)) {
            data["atecoCodes"] = [];
            for (let item of this.atecoCodes)
                data["atecoCodes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.conventions)) {
            data["conventions"] = [];
            for (let item of this.conventions)
                data["conventions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.companyOrderCodes)) {
            data["companyOrderCodes"] = [];
            for (let item of this.companyOrderCodes)
                data["companyOrderCodes"].push(item ? item.toJSON() : undefined as any);
        }
        data["laborConsultant"] = this.laborConsultant ? this.laborConsultant.toJSON() : undefined as any;
        data["nationality"] = this.nationality ? this.nationality.toJSON() : undefined as any;
        if (Array.isArray(this.operativeUnits)) {
            data["operativeUnits"] = [];
            for (let item of this.operativeUnits)
                data["operativeUnits"].push(item ? item.toJSON() : undefined as any);
        }
        data["isAlreadySelected"] = this.isAlreadySelected;
        return data;
    }

    clone(): UserDto {
        const json = this.toJSON();
        let result = new UserDto();
        result.init(json);
        return result;
    }
}

export interface IUserDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    phoneNumber: string | undefined;
    fiscalCode: string | undefined;
    emailAddress: string | undefined;
    roleNames: string[] | undefined;
    roleDisplayNames: string[] | undefined;
    isActive: boolean;
    isDeleted: boolean;
    lastLoginTime: moment.Moment | undefined;
    isEmailConfirmed: boolean;
    fullName: string | undefined;
    accessFailedCount: number;
    lockoutEndDateUtc: moment.Moment | undefined;
    birthDate: moment.Moment | undefined;
    birthPlace: string | undefined;
    gender: DictionaryDto;
    address: AddressDto;
    businessName: string | undefined;
    registeredOffice: AddressDto;
    vatNumber: string | undefined;
    pec: string | undefined;
    employees: DictionaryDto;
    sales: DictionaryDto;
    salesLastYear: DictionaryDto;
    businessSector: DictionaryDto;
    partnerType: DictionaryDto;
    operativeOfficesAddresses: AddressDto[] | undefined;
    legalObbligation68: boolean | undefined;
    theseObbligation: string | undefined;
    discoveriesNumber: string | undefined;
    activityDescription: string | undefined;
    telematicIdentificationCode: string | undefined;
    notes: NoteDto[] | undefined;
    atecoCodes: DictionaryDto[] | undefined;
    conventions: ConventionDto[] | undefined;
    companyOrderCodes: OrderCodeDto[] | undefined;
    laborConsultant: LaborConsultantItemDto;
    nationality: DictionaryDto;
    operativeUnits: OperativeUnitDto[] | undefined;
    isAlreadySelected: boolean;
}

export class UserDtoPagedResultDto implements IUserDtoPagedResultDto {
    items!: UserDto[] | undefined;
    totalCount!: number;

    constructor(data?: IUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserDtoPagedResultDto {
    items: UserDto[] | undefined;
    totalCount: number;
}

export class UserEducationDto implements IUserEducationDto {
    id!: number;
    user!: UserDto;
    educationalDegreeLevel!: DictionaryDto;
    educationalDegree!: EducationalDegreeDto;
    titleRecognition!: DictionaryDto;
    nation!: DictionaryDto;
    institute!: string | undefined;
    graduationDate!: moment.Moment;
    other!: string | undefined;

    constructor(data?: IUserEducationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : undefined as any;
            this.educationalDegreeLevel = _data["educationalDegreeLevel"] ? DictionaryDto.fromJS(_data["educationalDegreeLevel"]) : undefined as any;
            this.educationalDegree = _data["educationalDegree"] ? EducationalDegreeDto.fromJS(_data["educationalDegree"]) : undefined as any;
            this.titleRecognition = _data["titleRecognition"] ? DictionaryDto.fromJS(_data["titleRecognition"]) : undefined as any;
            this.nation = _data["nation"] ? DictionaryDto.fromJS(_data["nation"]) : undefined as any;
            this.institute = _data["institute"];
            this.graduationDate = _data["graduationDate"] ? moment(_data["graduationDate"].toString()) : undefined as any;
            this.other = _data["other"];
        }
    }

    static fromJS(data: any): UserEducationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserEducationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["educationalDegreeLevel"] = this.educationalDegreeLevel ? this.educationalDegreeLevel.toJSON() : undefined as any;
        data["educationalDegree"] = this.educationalDegree ? this.educationalDegree.toJSON() : undefined as any;
        data["titleRecognition"] = this.titleRecognition ? this.titleRecognition.toJSON() : undefined as any;
        data["nation"] = this.nation ? this.nation.toJSON() : undefined as any;
        data["institute"] = this.institute;
        data["graduationDate"] = this.graduationDate ? this.graduationDate.format('YYYY-MM-DD') : undefined as any;
        data["other"] = this.other;
        return data;
    }

    clone(): UserEducationDto {
        const json = this.toJSON();
        let result = new UserEducationDto();
        result.init(json);
        return result;
    }
}

export interface IUserEducationDto {
    id: number;
    user: UserDto;
    educationalDegreeLevel: DictionaryDto;
    educationalDegree: EducationalDegreeDto;
    titleRecognition: DictionaryDto;
    nation: DictionaryDto;
    institute: string | undefined;
    graduationDate: moment.Moment;
    other: string | undefined;
}

export class UserEducationDtoPagedResultDto implements IUserEducationDtoPagedResultDto {
    items!: UserEducationDto[] | undefined;
    totalCount!: number;

    constructor(data?: IUserEducationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserEducationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserEducationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserEducationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserEducationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserEducationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserEducationDtoPagedResultDto {
    items: UserEducationDto[] | undefined;
    totalCount: number;
}

export class UserItemDto implements IUserItemDto {
    id!: number;
    name!: string | undefined;
    surname!: string | undefined;
    emailAddress!: string | undefined;
    operativeUnits!: OperativeUnitDto[] | undefined;
    roleNames!: string[] | undefined;
    vatNumber!: string | undefined;

    constructor(data?: IUserItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            if (Array.isArray(_data["operativeUnits"])) {
                this.operativeUnits = [] as any;
                for (let item of _data["operativeUnits"])
                    this.operativeUnits!.push(OperativeUnitDto.fromJS(item));
            }
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames!.push(item);
            }
            this.vatNumber = _data["vatNumber"];
        }
    }

    static fromJS(data: any): UserItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        if (Array.isArray(this.operativeUnits)) {
            data["operativeUnits"] = [];
            for (let item of this.operativeUnits)
                data["operativeUnits"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["vatNumber"] = this.vatNumber;
        return data;
    }

    clone(): UserItemDto {
        const json = this.toJSON();
        let result = new UserItemDto();
        result.init(json);
        return result;
    }
}

export interface IUserItemDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    emailAddress: string | undefined;
    operativeUnits: OperativeUnitDto[] | undefined;
    roleNames: string[] | undefined;
    vatNumber: string | undefined;
}

export class UserJobDto implements IUserJobDto {
    id!: number;
    user!: UserDto;
    job!: DictionaryDto;
    contractType!: DictionaryDto;
    startDate!: moment.Moment;
    endDate!: moment.Moment;
    inProgress!: boolean;
    employer!: string | undefined;

    constructor(data?: IUserJobDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : undefined as any;
            this.job = _data["job"] ? DictionaryDto.fromJS(_data["job"]) : undefined as any;
            this.contractType = _data["contractType"] ? DictionaryDto.fromJS(_data["contractType"]) : undefined as any;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : undefined as any;
            this.inProgress = _data["inProgress"];
            this.employer = _data["employer"];
        }
    }

    static fromJS(data: any): UserJobDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserJobDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["job"] = this.job ? this.job.toJSON() : undefined as any;
        data["contractType"] = this.contractType ? this.contractType.toJSON() : undefined as any;
        data["startDate"] = this.startDate ? this.startDate.format('YYYY-MM-DD') : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.format('YYYY-MM-DD') : undefined as any;
        data["inProgress"] = this.inProgress;
        data["employer"] = this.employer;
        return data;
    }

    clone(): UserJobDto {
        const json = this.toJSON();
        let result = new UserJobDto();
        result.init(json);
        return result;
    }
}

export interface IUserJobDto {
    id: number;
    user: UserDto;
    job: DictionaryDto;
    contractType: DictionaryDto;
    startDate: moment.Moment;
    endDate: moment.Moment;
    inProgress: boolean;
    employer: string | undefined;
}

export class UserJobDtoPagedResultDto implements IUserJobDtoPagedResultDto {
    items!: UserJobDto[] | undefined;
    totalCount!: number;

    constructor(data?: IUserJobDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserJobDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserJobDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserJobDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserJobDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserJobDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserJobDtoPagedResultDto {
    items: UserJobDto[] | undefined;
    totalCount: number;
}

export class UserLanguageDto implements IUserLanguageDto {
    id!: number;
    user!: UserDto;
    language!: DictionaryDto;
    spokenLevel!: DictionaryDto;
    writtenLevel!: DictionaryDto;
    listeningLevel!: DictionaryDto;
    readingLevel!: DictionaryDto;
    certificate!: DictionaryDto;
    attested!: boolean;
    notes!: string | undefined;

    constructor(data?: IUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : undefined as any;
            this.language = _data["language"] ? DictionaryDto.fromJS(_data["language"]) : undefined as any;
            this.spokenLevel = _data["spokenLevel"] ? DictionaryDto.fromJS(_data["spokenLevel"]) : undefined as any;
            this.writtenLevel = _data["writtenLevel"] ? DictionaryDto.fromJS(_data["writtenLevel"]) : undefined as any;
            this.listeningLevel = _data["listeningLevel"] ? DictionaryDto.fromJS(_data["listeningLevel"]) : undefined as any;
            this.readingLevel = _data["readingLevel"] ? DictionaryDto.fromJS(_data["readingLevel"]) : undefined as any;
            this.certificate = _data["certificate"] ? DictionaryDto.fromJS(_data["certificate"]) : undefined as any;
            this.attested = _data["attested"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["language"] = this.language ? this.language.toJSON() : undefined as any;
        data["spokenLevel"] = this.spokenLevel ? this.spokenLevel.toJSON() : undefined as any;
        data["writtenLevel"] = this.writtenLevel ? this.writtenLevel.toJSON() : undefined as any;
        data["listeningLevel"] = this.listeningLevel ? this.listeningLevel.toJSON() : undefined as any;
        data["readingLevel"] = this.readingLevel ? this.readingLevel.toJSON() : undefined as any;
        data["certificate"] = this.certificate ? this.certificate.toJSON() : undefined as any;
        data["attested"] = this.attested;
        data["notes"] = this.notes;
        return data;
    }

    clone(): UserLanguageDto {
        const json = this.toJSON();
        let result = new UserLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IUserLanguageDto {
    id: number;
    user: UserDto;
    language: DictionaryDto;
    spokenLevel: DictionaryDto;
    writtenLevel: DictionaryDto;
    listeningLevel: DictionaryDto;
    readingLevel: DictionaryDto;
    certificate: DictionaryDto;
    attested: boolean;
    notes: string | undefined;
}

export class UserLanguageDtoPagedResultDto implements IUserLanguageDtoPagedResultDto {
    items!: UserLanguageDto[] | undefined;
    totalCount!: number;

    constructor(data?: IUserLanguageDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserLanguageDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserLanguageDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLanguageDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserLanguageDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserLanguageDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserLanguageDtoPagedResultDto {
    items: UserLanguageDto[] | undefined;
    totalCount: number;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    id!: number;
    name!: string | undefined;
    surname!: string | undefined;
    fullName!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    endRegistration!: boolean;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.fullName = _data["fullName"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.endRegistration = _data["endRegistration"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["fullName"] = this.fullName;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["endRegistration"] = this.endRegistration;
        return data;
    }

    clone(): UserLoginInfoDto {
        const json = this.toJSON();
        let result = new UserLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUserLoginInfoDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    fullName: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    endRegistration: boolean;
}

export class UserNoteDto implements IUserNoteDto {
    id!: number;
    user!: UserDto;
    note!: string | undefined;
    date!: moment.Moment;

    constructor(data?: IUserNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : undefined as any;
            this.note = _data["note"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UserNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["note"] = this.note;
        data["date"] = this.date ? this.date.format('YYYY-MM-DD') : undefined as any;
        return data;
    }

    clone(): UserNoteDto {
        const json = this.toJSON();
        let result = new UserNoteDto();
        result.init(json);
        return result;
    }
}

export interface IUserNoteDto {
    id: number;
    user: UserDto;
    note: string | undefined;
    date: moment.Moment;
}

export class UserNoteDtoPagedResultDto implements IUserNoteDtoPagedResultDto {
    items!: UserNoteDto[] | undefined;
    totalCount!: number;

    constructor(data?: IUserNoteDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserNoteDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserNoteDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserNoteDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserNoteDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserNoteDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserNoteDtoPagedResultDto {
    items: UserNoteDto[] | undefined;
    totalCount: number;
}

export class UserQualificationDto implements IUserQualificationDto {
    id!: number;
    user!: UserDto;
    qualificationType!: DictionaryDto;
    inProgress!: boolean;
    graduationDate!: moment.Moment | undefined;
    notes!: string | undefined;

    constructor(data?: IUserQualificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : undefined as any;
            this.qualificationType = _data["qualificationType"] ? DictionaryDto.fromJS(_data["qualificationType"]) : undefined as any;
            this.inProgress = _data["inProgress"];
            this.graduationDate = _data["graduationDate"] ? moment(_data["graduationDate"].toString()) : undefined as any;
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UserQualificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserQualificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["qualificationType"] = this.qualificationType ? this.qualificationType.toJSON() : undefined as any;
        data["inProgress"] = this.inProgress;
        data["graduationDate"] = this.graduationDate ? this.graduationDate.format('YYYY-MM-DD') : undefined as any;
        data["notes"] = this.notes;
        return data;
    }

    clone(): UserQualificationDto {
        const json = this.toJSON();
        let result = new UserQualificationDto();
        result.init(json);
        return result;
    }
}

export interface IUserQualificationDto {
    id: number;
    user: UserDto;
    qualificationType: DictionaryDto;
    inProgress: boolean;
    graduationDate: moment.Moment | undefined;
    notes: string | undefined;
}

export class UserQualificationDtoPagedResultDto implements IUserQualificationDtoPagedResultDto {
    items!: UserQualificationDto[] | undefined;
    totalCount!: number;

    constructor(data?: IUserQualificationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserQualificationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserQualificationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserQualificationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserQualificationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserQualificationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserQualificationDtoPagedResultDto {
    items: UserQualificationDto[] | undefined;
    totalCount: number;
}

export class UserRatingDto implements IUserRatingDto {
    user!: UserDto;
    matchingPercentage!: number;
    isAlreadySelected!: boolean;

    constructor(data?: IUserRatingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : undefined as any;
            this.matchingPercentage = _data["matchingPercentage"];
            this.isAlreadySelected = _data["isAlreadySelected"];
        }
    }

    static fromJS(data: any): UserRatingDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserRatingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["matchingPercentage"] = this.matchingPercentage;
        data["isAlreadySelected"] = this.isAlreadySelected;
        return data;
    }

    clone(): UserRatingDto {
        const json = this.toJSON();
        let result = new UserRatingDto();
        result.init(json);
        return result;
    }
}

export interface IUserRatingDto {
    user: UserDto;
    matchingPercentage: number;
    isAlreadySelected: boolean;
}

export class UserRatingDtoPagedResultDto implements IUserRatingDtoPagedResultDto {
    items!: UserRatingDto[] | undefined;
    totalCount!: number;

    constructor(data?: IUserRatingDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserRatingDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserRatingDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserRatingDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserRatingDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserRatingDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserRatingDtoPagedResultDto {
    items: UserRatingDto[] | undefined;
    totalCount: number;
}

export class UserSafetyTrainingDto implements IUserSafetyTrainingDto {
    id!: number;
    user!: UserDto;
    safetyTrainingType!: DictionaryDto;
    date!: moment.Moment;

    constructor(data?: IUserSafetyTrainingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : undefined as any;
            this.safetyTrainingType = _data["safetyTrainingType"] ? DictionaryDto.fromJS(_data["safetyTrainingType"]) : undefined as any;
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UserSafetyTrainingDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserSafetyTrainingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["safetyTrainingType"] = this.safetyTrainingType ? this.safetyTrainingType.toJSON() : undefined as any;
        data["date"] = this.date ? this.date.format('YYYY-MM-DD') : undefined as any;
        return data;
    }

    clone(): UserSafetyTrainingDto {
        const json = this.toJSON();
        let result = new UserSafetyTrainingDto();
        result.init(json);
        return result;
    }
}

export interface IUserSafetyTrainingDto {
    id: number;
    user: UserDto;
    safetyTrainingType: DictionaryDto;
    date: moment.Moment;
}

export class UserSafetyTrainingDtoPagedResultDto implements IUserSafetyTrainingDtoPagedResultDto {
    items!: UserSafetyTrainingDto[] | undefined;
    totalCount!: number;

    constructor(data?: IUserSafetyTrainingDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserSafetyTrainingDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserSafetyTrainingDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserSafetyTrainingDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserSafetyTrainingDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserSafetyTrainingDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserSafetyTrainingDtoPagedResultDto {
    items: UserSafetyTrainingDto[] | undefined;
    totalCount: number;
}

export class UserSurveyDto implements IUserSurveyDto {
    id!: number;
    cvWritingSupportServices!: number;
    jobInterviewPreparation!: number;
    careerEducationGuidanceCounseling!: number;
    workshopsActiveJobSearching!: number;
    trainingCourses!: number;
    informationMeetingsOnTheJobMarket!: number;

    constructor(data?: IUserSurveyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cvWritingSupportServices = _data["cvWritingSupportServices"];
            this.jobInterviewPreparation = _data["jobInterviewPreparation"];
            this.careerEducationGuidanceCounseling = _data["careerEducationGuidanceCounseling"];
            this.workshopsActiveJobSearching = _data["workshopsActiveJobSearching"];
            this.trainingCourses = _data["trainingCourses"];
            this.informationMeetingsOnTheJobMarket = _data["informationMeetingsOnTheJobMarket"];
        }
    }

    static fromJS(data: any): UserSurveyDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserSurveyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cvWritingSupportServices"] = this.cvWritingSupportServices;
        data["jobInterviewPreparation"] = this.jobInterviewPreparation;
        data["careerEducationGuidanceCounseling"] = this.careerEducationGuidanceCounseling;
        data["workshopsActiveJobSearching"] = this.workshopsActiveJobSearching;
        data["trainingCourses"] = this.trainingCourses;
        data["informationMeetingsOnTheJobMarket"] = this.informationMeetingsOnTheJobMarket;
        return data;
    }

    clone(): UserSurveyDto {
        const json = this.toJSON();
        let result = new UserSurveyDto();
        result.init(json);
        return result;
    }
}

export interface IUserSurveyDto {
    id: number;
    cvWritingSupportServices: number;
    jobInterviewPreparation: number;
    careerEducationGuidanceCounseling: number;
    workshopsActiveJobSearching: number;
    trainingCourses: number;
    informationMeetingsOnTheJobMarket: number;
}

export class UserSurveyDtoPagedResultDto implements IUserSurveyDtoPagedResultDto {
    items!: UserSurveyDto[] | undefined;
    totalCount!: number;

    constructor(data?: IUserSurveyDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserSurveyDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserSurveyDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserSurveyDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserSurveyDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserSurveyDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserSurveyDtoPagedResultDto {
    items: UserSurveyDto[] | undefined;
    totalCount: number;
}

export class UserTrainingCourseDto implements IUserTrainingCourseDto {
    id!: number;
    user!: UserDto;
    title!: string | undefined;
    institute!: string | undefined;
    achievementYear!: moment.Moment | undefined;
    courseHours!: number | undefined;
    certificate!: DictionaryDto;
    attested!: boolean;

    constructor(data?: IUserTrainingCourseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : undefined as any;
            this.title = _data["title"];
            this.institute = _data["institute"];
            this.achievementYear = _data["achievementYear"] ? moment(_data["achievementYear"].toString()) : undefined as any;
            this.courseHours = _data["courseHours"];
            this.certificate = _data["certificate"] ? DictionaryDto.fromJS(_data["certificate"]) : undefined as any;
            this.attested = _data["attested"];
        }
    }

    static fromJS(data: any): UserTrainingCourseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserTrainingCourseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["title"] = this.title;
        data["institute"] = this.institute;
        data["achievementYear"] = this.achievementYear ? this.achievementYear.format('YYYY-MM-DD') : undefined as any;
        data["courseHours"] = this.courseHours;
        data["certificate"] = this.certificate ? this.certificate.toJSON() : undefined as any;
        data["attested"] = this.attested;
        return data;
    }

    clone(): UserTrainingCourseDto {
        const json = this.toJSON();
        let result = new UserTrainingCourseDto();
        result.init(json);
        return result;
    }
}

export interface IUserTrainingCourseDto {
    id: number;
    user: UserDto;
    title: string | undefined;
    institute: string | undefined;
    achievementYear: moment.Moment | undefined;
    courseHours: number | undefined;
    certificate: DictionaryDto;
    attested: boolean;
}

export class UserTrainingCourseDtoPagedResultDto implements IUserTrainingCourseDtoPagedResultDto {
    items!: UserTrainingCourseDto[] | undefined;
    totalCount!: number;

    constructor(data?: IUserTrainingCourseDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserTrainingCourseDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserTrainingCourseDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserTrainingCourseDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserTrainingCourseDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserTrainingCourseDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserTrainingCourseDtoPagedResultDto {
    items: UserTrainingCourseDto[] | undefined;
    totalCount: number;
}

export class UserTrainingCourseInterestDto implements IUserTrainingCourseInterestDto {
    id!: number;
    user!: UserDto;
    businessSector!: DictionaryDto;
    areaOfInterest!: string | undefined;
    userTrainingCourseInterestOperativeUnits!: UserTrainingCourseInterestOperativeUnitDto[] | undefined;
    fruitionType!: DictionaryDto;
    isInterestedInSelfFinancedCourse!: boolean;

    constructor(data?: IUserTrainingCourseInterestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : undefined as any;
            this.businessSector = _data["businessSector"] ? DictionaryDto.fromJS(_data["businessSector"]) : undefined as any;
            this.areaOfInterest = _data["areaOfInterest"];
            if (Array.isArray(_data["userTrainingCourseInterestOperativeUnits"])) {
                this.userTrainingCourseInterestOperativeUnits = [] as any;
                for (let item of _data["userTrainingCourseInterestOperativeUnits"])
                    this.userTrainingCourseInterestOperativeUnits!.push(UserTrainingCourseInterestOperativeUnitDto.fromJS(item));
            }
            this.fruitionType = _data["fruitionType"] ? DictionaryDto.fromJS(_data["fruitionType"]) : undefined as any;
            this.isInterestedInSelfFinancedCourse = _data["isInterestedInSelfFinancedCourse"];
        }
    }

    static fromJS(data: any): UserTrainingCourseInterestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserTrainingCourseInterestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["businessSector"] = this.businessSector ? this.businessSector.toJSON() : undefined as any;
        data["areaOfInterest"] = this.areaOfInterest;
        if (Array.isArray(this.userTrainingCourseInterestOperativeUnits)) {
            data["userTrainingCourseInterestOperativeUnits"] = [];
            for (let item of this.userTrainingCourseInterestOperativeUnits)
                data["userTrainingCourseInterestOperativeUnits"].push(item ? item.toJSON() : undefined as any);
        }
        data["fruitionType"] = this.fruitionType ? this.fruitionType.toJSON() : undefined as any;
        data["isInterestedInSelfFinancedCourse"] = this.isInterestedInSelfFinancedCourse;
        return data;
    }

    clone(): UserTrainingCourseInterestDto {
        const json = this.toJSON();
        let result = new UserTrainingCourseInterestDto();
        result.init(json);
        return result;
    }
}

export interface IUserTrainingCourseInterestDto {
    id: number;
    user: UserDto;
    businessSector: DictionaryDto;
    areaOfInterest: string | undefined;
    userTrainingCourseInterestOperativeUnits: UserTrainingCourseInterestOperativeUnitDto[] | undefined;
    fruitionType: DictionaryDto;
    isInterestedInSelfFinancedCourse: boolean;
}

export class UserTrainingCourseInterestDtoPagedResultDto implements IUserTrainingCourseInterestDtoPagedResultDto {
    items!: UserTrainingCourseInterestDto[] | undefined;
    totalCount!: number;

    constructor(data?: IUserTrainingCourseInterestDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserTrainingCourseInterestDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserTrainingCourseInterestDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserTrainingCourseInterestDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserTrainingCourseInterestDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserTrainingCourseInterestDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserTrainingCourseInterestDtoPagedResultDto {
    items: UserTrainingCourseInterestDto[] | undefined;
    totalCount: number;
}

export class UserTrainingCourseInterestOperativeUnitDto implements IUserTrainingCourseInterestOperativeUnitDto {
    id!: number;
    operativeUnit!: OperativeUnitDto;

    constructor(data?: IUserTrainingCourseInterestOperativeUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.operativeUnit = _data["operativeUnit"] ? OperativeUnitDto.fromJS(_data["operativeUnit"]) : undefined as any;
        }
    }

    static fromJS(data: any): UserTrainingCourseInterestOperativeUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserTrainingCourseInterestOperativeUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["operativeUnit"] = this.operativeUnit ? this.operativeUnit.toJSON() : undefined as any;
        return data;
    }

    clone(): UserTrainingCourseInterestOperativeUnitDto {
        const json = this.toJSON();
        let result = new UserTrainingCourseInterestOperativeUnitDto();
        result.init(json);
        return result;
    }
}

export interface IUserTrainingCourseInterestOperativeUnitDto {
    id: number;
    operativeUnit: OperativeUnitDto;
}

export class UserTrainingCourseInterestOperativeUnitDtoPagedResultDto implements IUserTrainingCourseInterestOperativeUnitDtoPagedResultDto {
    items!: UserTrainingCourseInterestOperativeUnitDto[] | undefined;
    totalCount!: number;

    constructor(data?: IUserTrainingCourseInterestOperativeUnitDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserTrainingCourseInterestOperativeUnitDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserTrainingCourseInterestOperativeUnitDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserTrainingCourseInterestOperativeUnitDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserTrainingCourseInterestOperativeUnitDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserTrainingCourseInterestOperativeUnitDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserTrainingCourseInterestOperativeUnitDtoPagedResultDto {
    items: UserTrainingCourseInterestOperativeUnitDto[] | undefined;
    totalCount: number;
}

export class UserTransversalSkillDto implements IUserTransversalSkillDto {
    id!: number;
    description!: string | undefined;
    level!: DictionaryDto;

    constructor(data?: IUserTransversalSkillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.level = _data["level"] ? DictionaryDto.fromJS(_data["level"]) : undefined as any;
        }
    }

    static fromJS(data: any): UserTransversalSkillDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserTransversalSkillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["level"] = this.level ? this.level.toJSON() : undefined as any;
        return data;
    }

    clone(): UserTransversalSkillDto {
        const json = this.toJSON();
        let result = new UserTransversalSkillDto();
        result.init(json);
        return result;
    }
}

export interface IUserTransversalSkillDto {
    id: number;
    description: string | undefined;
    level: DictionaryDto;
}

export class UserTransversalSkillDtoPagedResultDto implements IUserTransversalSkillDtoPagedResultDto {
    items!: UserTransversalSkillDto[] | undefined;
    totalCount!: number;

    constructor(data?: IUserTransversalSkillDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserTransversalSkillDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserTransversalSkillDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserTransversalSkillDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserTransversalSkillDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserTransversalSkillDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserTransversalSkillDtoPagedResultDto {
    items: UserTransversalSkillDto[] | undefined;
    totalCount: number;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}